var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1360,
    height: 777,
    viewBox: "0 0 1360 777",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 0L339.959 6.11175H344.682L340.861 9.88902L342.321 16.0008L338.5 12.2235L334.679 16.0008L336.139 9.88902L332.318 6.11175H337.041L338.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 0L163.959 6.11175H168.682L164.861 9.88902L166.321 16.0008L162.5 12.2235L158.679 16.0008L160.139 9.88902L156.318 6.11175H161.041L162.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 0L515.959 6.11175H520.682L516.861 9.88902L518.321 16.0008L514.5 12.2235L510.679 16.0008L512.139 9.88902L508.318 6.11175H513.041L514.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 0L75.9593 6.11175H80.6819L76.8613 9.88902L78.3206 16.0008L74.5 12.2235L70.6794 16.0008L72.1387 9.88902L68.3181 6.11175H73.0407L74.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 0L427.959 6.11175H432.682L428.861 9.88902L430.321 16.0008L426.5 12.2235L422.679 16.0008L424.139 9.88902L420.318 6.11175H425.041L426.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 0L251.959 6.11175H256.682L252.861 9.88902L254.321 16.0008L250.5 12.2235L246.679 16.0008L248.139 9.88902L244.318 6.11175H249.041L250.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 0L603.959 6.11175H608.682L604.861 9.88902L606.321 16.0008L602.5 12.2235L598.679 16.0008L600.139 9.88902L596.318 6.11175H601.041L602.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 0L31.9593 6.11175H36.6819L32.8613 9.88902L34.3206 16.0008L30.5 12.2235L26.6794 16.0008L28.1387 9.88902L24.3181 6.11175H29.0407L30.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 0L383.959 6.11175H388.682L384.861 9.88902L386.321 16.0008L382.5 12.2235L378.679 16.0008L380.139 9.88902L376.318 6.11175H381.041L382.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 0L207.959 6.11175H212.682L208.861 9.88902L210.321 16.0008L206.5 12.2235L202.679 16.0008L204.139 9.88902L200.318 6.11175H205.041L206.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 0L559.959 6.11175H564.682L560.861 9.88902L562.321 16.0008L558.5 12.2235L554.679 16.0008L556.139 9.88902L552.318 6.11175H557.041L558.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 0L119.959 6.11175H124.682L120.861 9.88902L122.321 16.0008L118.5 12.2235L114.679 16.0008L116.139 9.88902L112.318 6.11175H117.041L118.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 0L471.959 6.11175H476.682L472.861 9.88902L474.321 16.0008L470.5 12.2235L466.679 16.0008L468.139 9.88902L464.318 6.11175H469.041L470.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 0L295.959 6.11175H300.682L296.861 9.88902L298.321 16.0008L294.5 12.2235L290.679 16.0008L292.139 9.88902L288.318 6.11175H293.041L294.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 0L647.959 6.11175H652.682L648.861 9.88902L650.321 16.0008L646.5 12.2235L642.679 16.0008L644.139 9.88902L640.318 6.11175H645.041L646.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0L9.95934 6.11175H14.6819L10.8613 9.88902L12.3206 16.0008L8.5 12.2235L4.6794 16.0008L6.13874 9.88902L2.31813 6.11175H7.04066L8.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 0L361.959 6.11175H366.682L362.861 9.88902L364.321 16.0008L360.5 12.2235L356.679 16.0008L358.139 9.88902L354.318 6.11175H359.041L360.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 0L185.959 6.11175H190.682L186.861 9.88902L188.321 16.0008L184.5 12.2235L180.679 16.0008L182.139 9.88902L178.318 6.11175H183.041L184.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 0L537.959 6.11175H542.682L538.861 9.88902L540.321 16.0008L536.5 12.2235L532.679 16.0008L534.139 9.88902L530.318 6.11175H535.041L536.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 0L97.9593 6.11175H102.682L98.8613 9.88902L100.321 16.0008L96.5 12.2235L92.6794 16.0008L94.1387 9.88902L90.3181 6.11175H95.0407L96.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 0L449.959 6.11175H454.682L450.861 9.88902L452.321 16.0008L448.5 12.2235L444.679 16.0008L446.139 9.88902L442.318 6.11175H447.041L448.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 0L273.959 6.11175H278.682L274.861 9.88902L276.321 16.0008L272.5 12.2235L268.679 16.0008L270.139 9.88902L266.318 6.11175H271.041L272.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 0L625.959 6.11175H630.682L626.861 9.88902L628.321 16.0008L624.5 12.2235L620.679 16.0008L622.139 9.88902L618.318 6.11175H623.041L624.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 0L53.9593 6.11175H58.6819L54.8613 9.88902L56.3206 16.0008L52.5 12.2235L48.6794 16.0008L50.1387 9.88902L46.3181 6.11175H51.0407L52.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 0L405.959 6.11175H410.682L406.861 9.88902L408.321 16.0008L404.5 12.2235L400.679 16.0008L402.139 9.88902L398.318 6.11175H403.041L404.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 0L229.959 6.11175H234.682L230.861 9.88902L232.321 16.0008L228.5 12.2235L224.679 16.0008L226.139 9.88902L222.318 6.11175H227.041L228.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 0L581.959 6.11175H586.682L582.861 9.88902L584.321 16.0008L580.5 12.2235L576.679 16.0008L578.139 9.88902L574.318 6.11175H579.041L580.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 0L141.959 6.11175H146.682L142.861 9.88902L144.321 16.0008L140.5 12.2235L136.679 16.0008L138.139 9.88902L134.318 6.11175H139.041L140.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 0L493.959 6.11175H498.682L494.861 9.88902L496.321 16.0008L492.5 12.2235L488.679 16.0008L490.139 9.88902L486.318 6.11175H491.041L492.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 0L317.959 6.11175H322.682L318.861 9.88902L320.321 16.0008L316.5 12.2235L312.679 16.0008L314.139 9.88902L310.318 6.11175H315.041L316.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 0L669.959 6.11175H674.682L670.861 9.88902L672.321 16.0008L668.5 12.2235L664.679 16.0008L666.139 9.88902L662.318 6.11175H667.041L668.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 195.951L339.959 202.063H344.682L340.861 205.84L342.321 211.952L338.5 208.174L334.679 211.952L336.139 205.84L332.318 202.063H337.041L338.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 195.951L163.959 202.063H168.682L164.861 205.84L166.321 211.952L162.5 208.174L158.679 211.952L160.139 205.84L156.318 202.063H161.041L162.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 195.951L515.959 202.063H520.682L516.861 205.84L518.321 211.952L514.5 208.174L510.679 211.952L512.139 205.84L508.318 202.063H513.041L514.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 195.951L75.9593 202.063H80.6819L76.8613 205.84L78.3206 211.952L74.5 208.174L70.6794 211.952L72.1387 205.84L68.3181 202.063H73.0407L74.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 195.951L427.959 202.063H432.682L428.861 205.84L430.321 211.952L426.5 208.174L422.679 211.952L424.139 205.84L420.318 202.063H425.041L426.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 195.951L251.959 202.063H256.682L252.861 205.84L254.321 211.952L250.5 208.174L246.679 211.952L248.139 205.84L244.318 202.063H249.041L250.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 195.951L603.959 202.063H608.682L604.861 205.84L606.321 211.952L602.5 208.174L598.679 211.952L600.139 205.84L596.318 202.063H601.041L602.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 195.951L31.9593 202.063H36.6819L32.8613 205.84L34.3206 211.952L30.5 208.174L26.6794 211.952L28.1387 205.84L24.3181 202.063H29.0407L30.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 195.951L383.959 202.063H388.682L384.861 205.84L386.321 211.952L382.5 208.174L378.679 211.952L380.139 205.84L376.318 202.063H381.041L382.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 195.951L207.959 202.063H212.682L208.861 205.84L210.321 211.952L206.5 208.174L202.679 211.952L204.139 205.84L200.318 202.063H205.041L206.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 195.951L559.959 202.063H564.682L560.861 205.84L562.321 211.952L558.5 208.174L554.679 211.952L556.139 205.84L552.318 202.063H557.041L558.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 195.951L119.959 202.063H124.682L120.861 205.84L122.321 211.952L118.5 208.174L114.679 211.952L116.139 205.84L112.318 202.063H117.041L118.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 195.951L471.959 202.063H476.682L472.861 205.84L474.321 211.952L470.5 208.174L466.679 211.952L468.139 205.84L464.318 202.063H469.041L470.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 195.951L295.959 202.063H300.682L296.861 205.84L298.321 211.952L294.5 208.174L290.679 211.952L292.139 205.84L288.318 202.063H293.041L294.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 195.951L647.959 202.063H652.682L648.861 205.84L650.321 211.952L646.5 208.174L642.679 211.952L644.139 205.84L640.318 202.063H645.041L646.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 195.951L9.95934 202.063H14.6819L10.8613 205.84L12.3206 211.952L8.5 208.174L4.6794 211.952L6.13874 205.84L2.31813 202.063H7.04066L8.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 195.951L361.959 202.063H366.682L362.861 205.84L364.321 211.952L360.5 208.174L356.679 211.952L358.139 205.84L354.318 202.063H359.041L360.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 195.951L185.959 202.063H190.682L186.861 205.84L188.321 211.952L184.5 208.174L180.679 211.952L182.139 205.84L178.318 202.063H183.041L184.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 195.951L537.959 202.063H542.682L538.861 205.84L540.321 211.952L536.5 208.174L532.679 211.952L534.139 205.84L530.318 202.063H535.041L536.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 195.951L97.9593 202.063H102.682L98.8613 205.84L100.321 211.952L96.5 208.174L92.6794 211.952L94.1387 205.84L90.3181 202.063H95.0407L96.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 195.951L449.959 202.063H454.682L450.861 205.84L452.321 211.952L448.5 208.174L444.679 211.952L446.139 205.84L442.318 202.063H447.041L448.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 195.951L273.959 202.063H278.682L274.861 205.84L276.321 211.952L272.5 208.174L268.679 211.952L270.139 205.84L266.318 202.063H271.041L272.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 195.951L625.959 202.063H630.682L626.861 205.84L628.321 211.952L624.5 208.174L620.679 211.952L622.139 205.84L618.318 202.063H623.041L624.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 195.951L53.9593 202.063H58.6819L54.8613 205.84L56.3206 211.952L52.5 208.174L48.6794 211.952L50.1387 205.84L46.3181 202.063H51.0407L52.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 195.951L405.959 202.063H410.682L406.861 205.84L408.321 211.952L404.5 208.174L400.679 211.952L402.139 205.84L398.318 202.063H403.041L404.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 195.951L229.959 202.063H234.682L230.861 205.84L232.321 211.952L228.5 208.174L224.679 211.952L226.139 205.84L222.318 202.063H227.041L228.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 195.951L581.959 202.063H586.682L582.861 205.84L584.321 211.952L580.5 208.174L576.679 211.952L578.139 205.84L574.318 202.063H579.041L580.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 195.951L141.959 202.063H146.682L142.861 205.84L144.321 211.952L140.5 208.174L136.679 211.952L138.139 205.84L134.318 202.063H139.041L140.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 195.951L493.959 202.063H498.682L494.861 205.84L496.321 211.952L492.5 208.174L488.679 211.952L490.139 205.84L486.318 202.063H491.041L492.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 195.951L317.959 202.063H322.682L318.861 205.84L320.321 211.952L316.5 208.174L312.679 211.952L314.139 205.84L310.318 202.063H315.041L316.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 195.951L669.959 202.063H674.682L670.861 205.84L672.321 211.952L668.5 208.174L664.679 211.952L666.139 205.84L662.318 202.063H667.041L668.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 97.9756L339.959 104.087H344.682L340.861 107.865L342.321 113.976L338.5 110.199L334.679 113.976L336.139 107.865L332.318 104.087H337.041L338.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 97.9756L163.959 104.087H168.682L164.861 107.865L166.321 113.976L162.5 110.199L158.679 113.976L160.139 107.865L156.318 104.087H161.041L162.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 97.9756L515.959 104.087H520.682L516.861 107.865L518.321 113.976L514.5 110.199L510.679 113.976L512.139 107.865L508.318 104.087H513.041L514.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 97.9756L75.9593 104.087H80.6819L76.8613 107.865L78.3206 113.976L74.5 110.199L70.6794 113.976L72.1387 107.865L68.3181 104.087H73.0407L74.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 97.9756L427.959 104.087H432.682L428.861 107.865L430.321 113.976L426.5 110.199L422.679 113.976L424.139 107.865L420.318 104.087H425.041L426.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 97.9756L251.959 104.087H256.682L252.861 107.865L254.321 113.976L250.5 110.199L246.679 113.976L248.139 107.865L244.318 104.087H249.041L250.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 97.9756L603.959 104.087H608.682L604.861 107.865L606.321 113.976L602.5 110.199L598.679 113.976L600.139 107.865L596.318 104.087H601.041L602.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 97.9756L31.9593 104.087H36.6819L32.8613 107.865L34.3206 113.976L30.5 110.199L26.6794 113.976L28.1387 107.865L24.3181 104.087H29.0407L30.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 97.9756L383.959 104.087H388.682L384.861 107.865L386.321 113.976L382.5 110.199L378.679 113.976L380.139 107.865L376.318 104.087H381.041L382.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 97.9756L207.959 104.087H212.682L208.861 107.865L210.321 113.976L206.5 110.199L202.679 113.976L204.139 107.865L200.318 104.087H205.041L206.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 97.9756L559.959 104.087H564.682L560.861 107.865L562.321 113.976L558.5 110.199L554.679 113.976L556.139 107.865L552.318 104.087H557.041L558.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 97.9756L119.959 104.087H124.682L120.861 107.865L122.321 113.976L118.5 110.199L114.679 113.976L116.139 107.865L112.318 104.087H117.041L118.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 97.9756L471.959 104.087H476.682L472.861 107.865L474.321 113.976L470.5 110.199L466.679 113.976L468.139 107.865L464.318 104.087H469.041L470.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 97.9756L295.959 104.087H300.682L296.861 107.865L298.321 113.976L294.5 110.199L290.679 113.976L292.139 107.865L288.318 104.087H293.041L294.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 97.9756L647.959 104.087H652.682L648.861 107.865L650.321 113.976L646.5 110.199L642.679 113.976L644.139 107.865L640.318 104.087H645.041L646.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 97.9756L9.95934 104.087H14.6819L10.8613 107.865L12.3206 113.976L8.5 110.199L4.6794 113.976L6.13874 107.865L2.31813 104.087H7.04066L8.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 97.9756L361.959 104.087H366.682L362.861 107.865L364.321 113.976L360.5 110.199L356.679 113.976L358.139 107.865L354.318 104.087H359.041L360.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 97.9756L185.959 104.087H190.682L186.861 107.865L188.321 113.976L184.5 110.199L180.679 113.976L182.139 107.865L178.318 104.087H183.041L184.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 97.9756L537.959 104.087H542.682L538.861 107.865L540.321 113.976L536.5 110.199L532.679 113.976L534.139 107.865L530.318 104.087H535.041L536.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 97.9756L97.9593 104.087H102.682L98.8613 107.865L100.321 113.976L96.5 110.199L92.6794 113.976L94.1387 107.865L90.3181 104.087H95.0407L96.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 97.9756L449.959 104.087H454.682L450.861 107.865L452.321 113.976L448.5 110.199L444.679 113.976L446.139 107.865L442.318 104.087H447.041L448.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 97.9756L273.959 104.087H278.682L274.861 107.865L276.321 113.976L272.5 110.199L268.679 113.976L270.139 107.865L266.318 104.087H271.041L272.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 97.9756L625.959 104.087H630.682L626.861 107.865L628.321 113.976L624.5 110.199L620.679 113.976L622.139 107.865L618.318 104.087H623.041L624.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 97.9756L53.9593 104.087H58.6819L54.8613 107.865L56.3206 113.976L52.5 110.199L48.6794 113.976L50.1387 107.865L46.3181 104.087H51.0407L52.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 97.9756L405.959 104.087H410.682L406.861 107.865L408.321 113.976L404.5 110.199L400.679 113.976L402.139 107.865L398.318 104.087H403.041L404.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 97.9756L229.959 104.087H234.682L230.861 107.865L232.321 113.976L228.5 110.199L224.679 113.976L226.139 107.865L222.318 104.087H227.041L228.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 97.9756L581.959 104.087H586.682L582.861 107.865L584.321 113.976L580.5 110.199L576.679 113.976L578.139 107.865L574.318 104.087H579.041L580.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 97.9756L141.959 104.087H146.682L142.861 107.865L144.321 113.976L140.5 110.199L136.679 113.976L138.139 107.865L134.318 104.087H139.041L140.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 97.9756L493.959 104.087H498.682L494.861 107.865L496.321 113.976L492.5 110.199L488.679 113.976L490.139 107.865L486.318 104.087H491.041L492.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 97.9756L317.959 104.087H322.682L318.861 107.865L320.321 113.976L316.5 110.199L312.679 113.976L314.139 107.865L310.318 104.087H315.041L316.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 97.9756L669.959 104.087H674.682L670.861 107.865L672.321 113.976L668.5 110.199L664.679 113.976L666.139 107.865L662.318 104.087H667.041L668.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 293.927L339.959 300.038H344.682L340.861 303.816L342.321 309.927L338.5 306.15L334.679 309.927L336.139 303.816L332.318 300.038H337.041L338.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 293.927L163.959 300.038H168.682L164.861 303.816L166.321 309.927L162.5 306.15L158.679 309.927L160.139 303.816L156.318 300.038H161.041L162.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 293.927L515.959 300.038H520.682L516.861 303.816L518.321 309.927L514.5 306.15L510.679 309.927L512.139 303.816L508.318 300.038H513.041L514.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 293.927L75.9593 300.038H80.6819L76.8613 303.816L78.3206 309.927L74.5 306.15L70.6794 309.927L72.1387 303.816L68.3181 300.038H73.0407L74.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 293.927L427.959 300.038H432.682L428.861 303.816L430.321 309.927L426.5 306.15L422.679 309.927L424.139 303.816L420.318 300.038H425.041L426.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 293.927L251.959 300.038H256.682L252.861 303.816L254.321 309.927L250.5 306.15L246.679 309.927L248.139 303.816L244.318 300.038H249.041L250.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 293.927L603.959 300.038H608.682L604.861 303.816L606.321 309.927L602.5 306.15L598.679 309.927L600.139 303.816L596.318 300.038H601.041L602.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 293.927L31.9593 300.038H36.6819L32.8613 303.816L34.3206 309.927L30.5 306.15L26.6794 309.927L28.1387 303.816L24.3181 300.038H29.0407L30.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 293.927L383.959 300.038H388.682L384.861 303.816L386.321 309.927L382.5 306.15L378.679 309.927L380.139 303.816L376.318 300.038H381.041L382.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 293.927L207.959 300.038H212.682L208.861 303.816L210.321 309.927L206.5 306.15L202.679 309.927L204.139 303.816L200.318 300.038H205.041L206.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 293.927L559.959 300.038H564.682L560.861 303.816L562.321 309.927L558.5 306.15L554.679 309.927L556.139 303.816L552.318 300.038H557.041L558.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 293.927L119.959 300.038H124.682L120.861 303.816L122.321 309.927L118.5 306.15L114.679 309.927L116.139 303.816L112.318 300.038H117.041L118.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 293.927L471.959 300.038H476.682L472.861 303.816L474.321 309.927L470.5 306.15L466.679 309.927L468.139 303.816L464.318 300.038H469.041L470.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 293.927L295.959 300.038H300.682L296.861 303.816L298.321 309.927L294.5 306.15L290.679 309.927L292.139 303.816L288.318 300.038H293.041L294.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 293.927L647.959 300.038H652.682L648.861 303.816L650.321 309.927L646.5 306.15L642.679 309.927L644.139 303.816L640.318 300.038H645.041L646.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 293.927L9.95934 300.038H14.6819L10.8613 303.816L12.3206 309.927L8.5 306.15L4.6794 309.927L6.13874 303.816L2.31813 300.038H7.04066L8.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 293.927L361.959 300.038H366.682L362.861 303.816L364.321 309.927L360.5 306.15L356.679 309.927L358.139 303.816L354.318 300.038H359.041L360.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 293.927L185.959 300.038H190.682L186.861 303.816L188.321 309.927L184.5 306.15L180.679 309.927L182.139 303.816L178.318 300.038H183.041L184.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 293.927L537.959 300.038H542.682L538.861 303.816L540.321 309.927L536.5 306.15L532.679 309.927L534.139 303.816L530.318 300.038H535.041L536.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 293.927L97.9593 300.038H102.682L98.8613 303.816L100.321 309.927L96.5 306.15L92.6794 309.927L94.1387 303.816L90.3181 300.038H95.0407L96.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 293.927L449.959 300.038H454.682L450.861 303.816L452.321 309.927L448.5 306.15L444.679 309.927L446.139 303.816L442.318 300.038H447.041L448.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 293.927L273.959 300.038H278.682L274.861 303.816L276.321 309.927L272.5 306.15L268.679 309.927L270.139 303.816L266.318 300.038H271.041L272.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 293.927L625.959 300.038H630.682L626.861 303.816L628.321 309.927L624.5 306.15L620.679 309.927L622.139 303.816L618.318 300.038H623.041L624.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 293.927L53.9593 300.038H58.6819L54.8613 303.816L56.3206 309.927L52.5 306.15L48.6794 309.927L50.1387 303.816L46.3181 300.038H51.0407L52.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 293.927L405.959 300.038H410.682L406.861 303.816L408.321 309.927L404.5 306.15L400.679 309.927L402.139 303.816L398.318 300.038H403.041L404.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 293.927L229.959 300.038H234.682L230.861 303.816L232.321 309.927L228.5 306.15L224.679 309.927L226.139 303.816L222.318 300.038H227.041L228.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 293.927L581.959 300.038H586.682L582.861 303.816L584.321 309.927L580.5 306.15L576.679 309.927L578.139 303.816L574.318 300.038H579.041L580.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 293.927L141.959 300.038H146.682L142.861 303.816L144.321 309.927L140.5 306.15L136.679 309.927L138.139 303.816L134.318 300.038H139.041L140.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 293.927L493.959 300.038H498.682L494.861 303.816L496.321 309.927L492.5 306.15L488.679 309.927L490.139 303.816L486.318 300.038H491.041L492.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 293.927L317.959 300.038H322.682L318.861 303.816L320.321 309.927L316.5 306.15L312.679 309.927L314.139 303.816L310.318 300.038H315.041L316.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 293.927L669.959 300.038H674.682L670.861 303.816L672.321 309.927L668.5 306.15L664.679 309.927L666.139 303.816L662.318 300.038H667.041L668.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 48.9878L339.959 55.0995H344.682L340.861 58.8768L342.321 64.9886L338.5 61.2113L334.679 64.9886L336.139 58.8768L332.318 55.0995H337.041L338.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 48.9878L163.959 55.0995H168.682L164.861 58.8768L166.321 64.9886L162.5 61.2113L158.679 64.9886L160.139 58.8768L156.318 55.0995H161.041L162.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 48.9878L515.959 55.0995H520.682L516.861 58.8768L518.321 64.9886L514.5 61.2113L510.679 64.9886L512.139 58.8768L508.318 55.0995H513.041L514.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 48.9878L75.9593 55.0995H80.6819L76.8613 58.8768L78.3206 64.9886L74.5 61.2113L70.6794 64.9886L72.1387 58.8768L68.3181 55.0995H73.0407L74.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 48.9878L427.959 55.0995H432.682L428.861 58.8768L430.321 64.9886L426.5 61.2113L422.679 64.9886L424.139 58.8768L420.318 55.0995H425.041L426.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 48.9878L251.959 55.0995H256.682L252.861 58.8768L254.321 64.9886L250.5 61.2113L246.679 64.9886L248.139 58.8768L244.318 55.0995H249.041L250.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 48.9878L603.959 55.0995H608.682L604.861 58.8768L606.321 64.9886L602.5 61.2113L598.679 64.9886L600.139 58.8768L596.318 55.0995H601.041L602.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 48.9878L31.9593 55.0995H36.6819L32.8613 58.8768L34.3206 64.9886L30.5 61.2113L26.6794 64.9886L28.1387 58.8768L24.3181 55.0995H29.0407L30.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 48.9878L383.959 55.0995H388.682L384.861 58.8768L386.321 64.9886L382.5 61.2113L378.679 64.9886L380.139 58.8768L376.318 55.0995H381.041L382.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 48.9878L207.959 55.0995H212.682L208.861 58.8768L210.321 64.9886L206.5 61.2113L202.679 64.9886L204.139 58.8768L200.318 55.0995H205.041L206.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 48.9878L559.959 55.0995H564.682L560.861 58.8768L562.321 64.9886L558.5 61.2113L554.679 64.9886L556.139 58.8768L552.318 55.0995H557.041L558.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 48.9878L119.959 55.0995H124.682L120.861 58.8768L122.321 64.9886L118.5 61.2113L114.679 64.9886L116.139 58.8768L112.318 55.0995H117.041L118.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 48.9878L471.959 55.0995H476.682L472.861 58.8768L474.321 64.9886L470.5 61.2113L466.679 64.9886L468.139 58.8768L464.318 55.0995H469.041L470.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 48.9878L295.959 55.0995H300.682L296.861 58.8768L298.321 64.9886L294.5 61.2113L290.679 64.9886L292.139 58.8768L288.318 55.0995H293.041L294.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 48.9878L647.959 55.0995H652.682L648.861 58.8768L650.321 64.9886L646.5 61.2113L642.679 64.9886L644.139 58.8768L640.318 55.0995H645.041L646.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 48.9878L9.95934 55.0995H14.6819L10.8613 58.8768L12.3206 64.9886L8.5 61.2113L4.6794 64.9886L6.13874 58.8768L2.31813 55.0995H7.04066L8.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 48.9878L361.959 55.0995H366.682L362.861 58.8768L364.321 64.9886L360.5 61.2113L356.679 64.9886L358.139 58.8768L354.318 55.0995H359.041L360.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 48.9878L185.959 55.0995H190.682L186.861 58.8768L188.321 64.9886L184.5 61.2113L180.679 64.9886L182.139 58.8768L178.318 55.0995H183.041L184.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 48.9878L537.959 55.0995H542.682L538.861 58.8768L540.321 64.9886L536.5 61.2113L532.679 64.9886L534.139 58.8768L530.318 55.0995H535.041L536.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 48.9878L97.9593 55.0995H102.682L98.8613 58.8768L100.321 64.9886L96.5 61.2113L92.6794 64.9886L94.1387 58.8768L90.3181 55.0995H95.0407L96.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 48.9878L449.959 55.0995H454.682L450.861 58.8768L452.321 64.9886L448.5 61.2113L444.679 64.9886L446.139 58.8768L442.318 55.0995H447.041L448.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 48.9878L273.959 55.0995H278.682L274.861 58.8768L276.321 64.9886L272.5 61.2113L268.679 64.9886L270.139 58.8768L266.318 55.0995H271.041L272.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 48.9878L625.959 55.0995H630.682L626.861 58.8768L628.321 64.9886L624.5 61.2113L620.679 64.9886L622.139 58.8768L618.318 55.0995H623.041L624.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 48.9878L53.9593 55.0995H58.6819L54.8613 58.8768L56.3206 64.9886L52.5 61.2113L48.6794 64.9886L50.1387 58.8768L46.3181 55.0995H51.0407L52.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 48.9878L405.959 55.0995H410.682L406.861 58.8768L408.321 64.9886L404.5 61.2113L400.679 64.9886L402.139 58.8768L398.318 55.0995H403.041L404.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 48.9878L229.959 55.0995H234.682L230.861 58.8768L232.321 64.9886L228.5 61.2113L224.679 64.9886L226.139 58.8768L222.318 55.0995H227.041L228.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 48.9878L581.959 55.0995H586.682L582.861 58.8768L584.321 64.9886L580.5 61.2113L576.679 64.9886L578.139 58.8768L574.318 55.0995H579.041L580.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 48.9878L141.959 55.0995H146.682L142.861 58.8768L144.321 64.9886L140.5 61.2113L136.679 64.9886L138.139 58.8768L134.318 55.0995H139.041L140.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 48.9878L493.959 55.0995H498.682L494.861 58.8768L496.321 64.9886L492.5 61.2113L488.679 64.9886L490.139 58.8768L486.318 55.0995H491.041L492.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 48.9878L317.959 55.0995H322.682L318.861 58.8768L320.321 64.9886L316.5 61.2113L312.679 64.9886L314.139 58.8768L310.318 55.0995H315.041L316.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 48.9878L669.959 55.0995H674.682L670.861 58.8768L672.321 64.9886L668.5 61.2113L664.679 64.9886L666.139 58.8768L662.318 55.0995H667.041L668.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 244.938L339.959 251.05H344.682L340.861 254.827L342.321 260.939L338.5 257.162L334.679 260.939L336.139 254.827L332.318 251.05H337.041L338.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 244.938L163.959 251.05H168.682L164.861 254.827L166.321 260.939L162.5 257.162L158.679 260.939L160.139 254.827L156.318 251.05H161.041L162.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 244.938L515.959 251.05H520.682L516.861 254.827L518.321 260.939L514.5 257.162L510.679 260.939L512.139 254.827L508.318 251.05H513.041L514.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 244.938L75.9593 251.05H80.6819L76.8613 254.827L78.3206 260.939L74.5 257.162L70.6794 260.939L72.1387 254.827L68.3181 251.05H73.0407L74.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 244.938L427.959 251.05H432.682L428.861 254.827L430.321 260.939L426.5 257.162L422.679 260.939L424.139 254.827L420.318 251.05H425.041L426.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 244.938L251.959 251.05H256.682L252.861 254.827L254.321 260.939L250.5 257.162L246.679 260.939L248.139 254.827L244.318 251.05H249.041L250.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 244.938L603.959 251.05H608.682L604.861 254.827L606.321 260.939L602.5 257.162L598.679 260.939L600.139 254.827L596.318 251.05H601.041L602.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 244.938L31.9593 251.05H36.6819L32.8613 254.827L34.3206 260.939L30.5 257.162L26.6794 260.939L28.1387 254.827L24.3181 251.05H29.0407L30.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 244.938L383.959 251.05H388.682L384.861 254.827L386.321 260.939L382.5 257.162L378.679 260.939L380.139 254.827L376.318 251.05H381.041L382.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 244.938L207.959 251.05H212.682L208.861 254.827L210.321 260.939L206.5 257.162L202.679 260.939L204.139 254.827L200.318 251.05H205.041L206.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 244.938L559.959 251.05H564.682L560.861 254.827L562.321 260.939L558.5 257.162L554.679 260.939L556.139 254.827L552.318 251.05H557.041L558.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 244.938L119.959 251.05H124.682L120.861 254.827L122.321 260.939L118.5 257.162L114.679 260.939L116.139 254.827L112.318 251.05H117.041L118.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 244.938L471.959 251.05H476.682L472.861 254.827L474.321 260.939L470.5 257.162L466.679 260.939L468.139 254.827L464.318 251.05H469.041L470.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 244.938L295.959 251.05H300.682L296.861 254.827L298.321 260.939L294.5 257.162L290.679 260.939L292.139 254.827L288.318 251.05H293.041L294.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 244.938L647.959 251.05H652.682L648.861 254.827L650.321 260.939L646.5 257.162L642.679 260.939L644.139 254.827L640.318 251.05H645.041L646.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 244.938L9.95934 251.05H14.6819L10.8613 254.827L12.3206 260.939L8.5 257.162L4.6794 260.939L6.13874 254.827L2.31813 251.05H7.04066L8.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 244.938L361.959 251.05H366.682L362.861 254.827L364.321 260.939L360.5 257.162L356.679 260.939L358.139 254.827L354.318 251.05H359.041L360.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 244.938L185.959 251.05H190.682L186.861 254.827L188.321 260.939L184.5 257.162L180.679 260.939L182.139 254.827L178.318 251.05H183.041L184.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 244.938L537.959 251.05H542.682L538.861 254.827L540.321 260.939L536.5 257.162L532.679 260.939L534.139 254.827L530.318 251.05H535.041L536.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 244.938L97.9593 251.05H102.682L98.8613 254.827L100.321 260.939L96.5 257.162L92.6794 260.939L94.1387 254.827L90.3181 251.05H95.0407L96.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 244.938L449.959 251.05H454.682L450.861 254.827L452.321 260.939L448.5 257.162L444.679 260.939L446.139 254.827L442.318 251.05H447.041L448.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 244.938L273.959 251.05H278.682L274.861 254.827L276.321 260.939L272.5 257.162L268.679 260.939L270.139 254.827L266.318 251.05H271.041L272.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 244.938L625.959 251.05H630.682L626.861 254.827L628.321 260.939L624.5 257.162L620.679 260.939L622.139 254.827L618.318 251.05H623.041L624.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 244.938L53.9593 251.05H58.6819L54.8613 254.827L56.3206 260.939L52.5 257.162L48.6794 260.939L50.1387 254.827L46.3181 251.05H51.0407L52.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 244.938L405.959 251.05H410.682L406.861 254.827L408.321 260.939L404.5 257.162L400.679 260.939L402.139 254.827L398.318 251.05H403.041L404.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 244.938L229.959 251.05H234.682L230.861 254.827L232.321 260.939L228.5 257.162L224.679 260.939L226.139 254.827L222.318 251.05H227.041L228.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 244.938L581.959 251.05H586.682L582.861 254.827L584.321 260.939L580.5 257.162L576.679 260.939L578.139 254.827L574.318 251.05H579.041L580.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 244.938L141.959 251.05H146.682L142.861 254.827L144.321 260.939L140.5 257.162L136.679 260.939L138.139 254.827L134.318 251.05H139.041L140.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 244.938L493.959 251.05H498.682L494.861 254.827L496.321 260.939L492.5 257.162L488.679 260.939L490.139 254.827L486.318 251.05H491.041L492.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 244.938L317.959 251.05H322.682L318.861 254.827L320.321 260.939L316.5 257.162L312.679 260.939L314.139 254.827L310.318 251.05H315.041L316.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 244.938L669.959 251.05H674.682L670.861 254.827L672.321 260.939L668.5 257.162L664.679 260.939L666.139 254.827L662.318 251.05H667.041L668.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 146.963L339.959 153.075H344.682L340.861 156.852L342.321 162.964L338.5 159.187L334.679 162.964L336.139 156.852L332.318 153.075H337.041L338.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 146.963L163.959 153.075H168.682L164.861 156.852L166.321 162.964L162.5 159.187L158.679 162.964L160.139 156.852L156.318 153.075H161.041L162.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 146.963L515.959 153.075H520.682L516.861 156.852L518.321 162.964L514.5 159.187L510.679 162.964L512.139 156.852L508.318 153.075H513.041L514.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 146.963L75.9593 153.075H80.6819L76.8613 156.852L78.3206 162.964L74.5 159.187L70.6794 162.964L72.1387 156.852L68.3181 153.075H73.0407L74.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 146.963L427.959 153.075H432.682L428.861 156.852L430.321 162.964L426.5 159.187L422.679 162.964L424.139 156.852L420.318 153.075H425.041L426.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 146.963L251.959 153.075H256.682L252.861 156.852L254.321 162.964L250.5 159.187L246.679 162.964L248.139 156.852L244.318 153.075H249.041L250.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 146.963L603.959 153.075H608.682L604.861 156.852L606.321 162.964L602.5 159.187L598.679 162.964L600.139 156.852L596.318 153.075H601.041L602.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 146.963L31.9593 153.075H36.6819L32.8613 156.852L34.3206 162.964L30.5 159.187L26.6794 162.964L28.1387 156.852L24.3181 153.075H29.0407L30.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 146.963L383.959 153.075H388.682L384.861 156.852L386.321 162.964L382.5 159.187L378.679 162.964L380.139 156.852L376.318 153.075H381.041L382.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 146.963L207.959 153.075H212.682L208.861 156.852L210.321 162.964L206.5 159.187L202.679 162.964L204.139 156.852L200.318 153.075H205.041L206.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 146.963L559.959 153.075H564.682L560.861 156.852L562.321 162.964L558.5 159.187L554.679 162.964L556.139 156.852L552.318 153.075H557.041L558.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 146.963L119.959 153.075H124.682L120.861 156.852L122.321 162.964L118.5 159.187L114.679 162.964L116.139 156.852L112.318 153.075H117.041L118.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 146.963L471.959 153.075H476.682L472.861 156.852L474.321 162.964L470.5 159.187L466.679 162.964L468.139 156.852L464.318 153.075H469.041L470.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 146.963L295.959 153.075H300.682L296.861 156.852L298.321 162.964L294.5 159.187L290.679 162.964L292.139 156.852L288.318 153.075H293.041L294.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 146.963L647.959 153.075H652.682L648.861 156.852L650.321 162.964L646.5 159.187L642.679 162.964L644.139 156.852L640.318 153.075H645.041L646.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 146.963L9.95934 153.075H14.6819L10.8613 156.852L12.3206 162.964L8.5 159.187L4.6794 162.964L6.13874 156.852L2.31813 153.075H7.04066L8.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 146.963L361.959 153.075H366.682L362.861 156.852L364.321 162.964L360.5 159.187L356.679 162.964L358.139 156.852L354.318 153.075H359.041L360.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 146.963L185.959 153.075H190.682L186.861 156.852L188.321 162.964L184.5 159.187L180.679 162.964L182.139 156.852L178.318 153.075H183.041L184.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 146.963L537.959 153.075H542.682L538.861 156.852L540.321 162.964L536.5 159.187L532.679 162.964L534.139 156.852L530.318 153.075H535.041L536.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 146.963L97.9593 153.075H102.682L98.8613 156.852L100.321 162.964L96.5 159.187L92.6794 162.964L94.1387 156.852L90.3181 153.075H95.0407L96.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 146.963L449.959 153.075H454.682L450.861 156.852L452.321 162.964L448.5 159.187L444.679 162.964L446.139 156.852L442.318 153.075H447.041L448.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 146.963L273.959 153.075H278.682L274.861 156.852L276.321 162.964L272.5 159.187L268.679 162.964L270.139 156.852L266.318 153.075H271.041L272.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 146.963L625.959 153.075H630.682L626.861 156.852L628.321 162.964L624.5 159.187L620.679 162.964L622.139 156.852L618.318 153.075H623.041L624.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 146.963L53.9593 153.075H58.6819L54.8613 156.852L56.3206 162.964L52.5 159.187L48.6794 162.964L50.1387 156.852L46.3181 153.075H51.0407L52.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 146.963L405.959 153.075H410.682L406.861 156.852L408.321 162.964L404.5 159.187L400.679 162.964L402.139 156.852L398.318 153.075H403.041L404.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 146.963L229.959 153.075H234.682L230.861 156.852L232.321 162.964L228.5 159.187L224.679 162.964L226.139 156.852L222.318 153.075H227.041L228.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 146.963L581.959 153.075H586.682L582.861 156.852L584.321 162.964L580.5 159.187L576.679 162.964L578.139 156.852L574.318 153.075H579.041L580.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 146.963L141.959 153.075H146.682L142.861 156.852L144.321 162.964L140.5 159.187L136.679 162.964L138.139 156.852L134.318 153.075H139.041L140.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 146.963L493.959 153.075H498.682L494.861 156.852L496.321 162.964L492.5 159.187L488.679 162.964L490.139 156.852L486.318 153.075H491.041L492.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 146.963L317.959 153.075H322.682L318.861 156.852L320.321 162.964L316.5 159.187L312.679 162.964L314.139 156.852L310.318 153.075H315.041L316.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 146.963L669.959 153.075H674.682L670.861 156.852L672.321 162.964L668.5 159.187L664.679 162.964L666.139 156.852L662.318 153.075H667.041L668.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 342.914L339.959 349.026H344.682L340.861 352.803L342.321 358.915L338.5 355.138L334.679 358.915L336.139 352.803L332.318 349.026H337.041L338.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 342.914L163.959 349.026H168.682L164.861 352.803L166.321 358.915L162.5 355.138L158.679 358.915L160.139 352.803L156.318 349.026H161.041L162.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 342.914L515.959 349.026H520.682L516.861 352.803L518.321 358.915L514.5 355.138L510.679 358.915L512.139 352.803L508.318 349.026H513.041L514.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 342.914L75.9593 349.026H80.6819L76.8613 352.803L78.3206 358.915L74.5 355.138L70.6794 358.915L72.1387 352.803L68.3181 349.026H73.0407L74.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 342.914L427.959 349.026H432.682L428.861 352.803L430.321 358.915L426.5 355.138L422.679 358.915L424.139 352.803L420.318 349.026H425.041L426.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 342.914L251.959 349.026H256.682L252.861 352.803L254.321 358.915L250.5 355.138L246.679 358.915L248.139 352.803L244.318 349.026H249.041L250.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 342.914L603.959 349.026H608.682L604.861 352.803L606.321 358.915L602.5 355.138L598.679 358.915L600.139 352.803L596.318 349.026H601.041L602.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 342.914L31.9593 349.026H36.6819L32.8613 352.803L34.3206 358.915L30.5 355.138L26.6794 358.915L28.1387 352.803L24.3181 349.026H29.0407L30.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 342.914L383.959 349.026H388.682L384.861 352.803L386.321 358.915L382.5 355.138L378.679 358.915L380.139 352.803L376.318 349.026H381.041L382.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 342.914L207.959 349.026H212.682L208.861 352.803L210.321 358.915L206.5 355.138L202.679 358.915L204.139 352.803L200.318 349.026H205.041L206.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 342.914L559.959 349.026H564.682L560.861 352.803L562.321 358.915L558.5 355.138L554.679 358.915L556.139 352.803L552.318 349.026H557.041L558.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 342.914L119.959 349.026H124.682L120.861 352.803L122.321 358.915L118.5 355.138L114.679 358.915L116.139 352.803L112.318 349.026H117.041L118.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 342.914L471.959 349.026H476.682L472.861 352.803L474.321 358.915L470.5 355.138L466.679 358.915L468.139 352.803L464.318 349.026H469.041L470.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 342.914L295.959 349.026H300.682L296.861 352.803L298.321 358.915L294.5 355.138L290.679 358.915L292.139 352.803L288.318 349.026H293.041L294.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 342.914L647.959 349.026H652.682L648.861 352.803L650.321 358.915L646.5 355.138L642.679 358.915L644.139 352.803L640.318 349.026H645.041L646.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 342.914L9.95934 349.026H14.6819L10.8613 352.803L12.3206 358.915L8.5 355.138L4.6794 358.915L6.13874 352.803L2.31813 349.026H7.04066L8.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 342.914L361.959 349.026H366.682L362.861 352.803L364.321 358.915L360.5 355.138L356.679 358.915L358.139 352.803L354.318 349.026H359.041L360.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 342.914L185.959 349.026H190.682L186.861 352.803L188.321 358.915L184.5 355.138L180.679 358.915L182.139 352.803L178.318 349.026H183.041L184.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 342.914L537.959 349.026H542.682L538.861 352.803L540.321 358.915L536.5 355.138L532.679 358.915L534.139 352.803L530.318 349.026H535.041L536.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 342.914L97.9593 349.026H102.682L98.8613 352.803L100.321 358.915L96.5 355.138L92.6794 358.915L94.1387 352.803L90.3181 349.026H95.0407L96.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 342.914L449.959 349.026H454.682L450.861 352.803L452.321 358.915L448.5 355.138L444.679 358.915L446.139 352.803L442.318 349.026H447.041L448.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 342.914L273.959 349.026H278.682L274.861 352.803L276.321 358.915L272.5 355.138L268.679 358.915L270.139 352.803L266.318 349.026H271.041L272.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 342.914L625.959 349.026H630.682L626.861 352.803L628.321 358.915L624.5 355.138L620.679 358.915L622.139 352.803L618.318 349.026H623.041L624.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 342.914L53.9593 349.026H58.6819L54.8613 352.803L56.3206 358.915L52.5 355.138L48.6794 358.915L50.1387 352.803L46.3181 349.026H51.0407L52.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 342.914L405.959 349.026H410.682L406.861 352.803L408.321 358.915L404.5 355.138L400.679 358.915L402.139 352.803L398.318 349.026H403.041L404.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 342.914L229.959 349.026H234.682L230.861 352.803L232.321 358.915L228.5 355.138L224.679 358.915L226.139 352.803L222.318 349.026H227.041L228.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 342.914L581.959 349.026H586.682L582.861 352.803L584.321 358.915L580.5 355.138L576.679 358.915L578.139 352.803L574.318 349.026H579.041L580.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 342.914L141.959 349.026H146.682L142.861 352.803L144.321 358.915L140.5 355.138L136.679 358.915L138.139 352.803L134.318 349.026H139.041L140.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 342.914L493.959 349.026H498.682L494.861 352.803L496.321 358.915L492.5 355.138L488.679 358.915L490.139 352.803L486.318 349.026H491.041L492.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 342.914L317.959 349.026H322.682L318.861 352.803L320.321 358.915L316.5 355.138L312.679 358.915L314.139 352.803L310.318 349.026H315.041L316.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 342.914L669.959 349.026H674.682L670.861 352.803L672.321 358.915L668.5 355.138L664.679 358.915L666.139 352.803L662.318 349.026H667.041L668.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 24.4939L339.959 30.6056H344.682L340.861 34.3829L342.321 40.4947L338.5 36.7174L334.679 40.4947L336.139 34.3829L332.318 30.6056H337.041L338.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 24.4939L163.959 30.6056H168.682L164.861 34.3829L166.321 40.4947L162.5 36.7174L158.679 40.4947L160.139 34.3829L156.318 30.6056H161.041L162.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 24.4939L515.959 30.6056H520.682L516.861 34.3829L518.321 40.4947L514.5 36.7174L510.679 40.4947L512.139 34.3829L508.318 30.6056H513.041L514.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 24.4939L75.9593 30.6056H80.6819L76.8613 34.3829L78.3206 40.4947L74.5 36.7174L70.6794 40.4947L72.1387 34.3829L68.3181 30.6056H73.0407L74.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 24.4939L427.959 30.6056H432.682L428.861 34.3829L430.321 40.4947L426.5 36.7174L422.679 40.4947L424.139 34.3829L420.318 30.6056H425.041L426.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 24.4939L251.959 30.6056H256.682L252.861 34.3829L254.321 40.4947L250.5 36.7174L246.679 40.4947L248.139 34.3829L244.318 30.6056H249.041L250.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 24.4939L603.959 30.6056H608.682L604.861 34.3829L606.321 40.4947L602.5 36.7174L598.679 40.4947L600.139 34.3829L596.318 30.6056H601.041L602.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 24.4939L31.9593 30.6056H36.6819L32.8613 34.3829L34.3206 40.4947L30.5 36.7174L26.6794 40.4947L28.1387 34.3829L24.3181 30.6056H29.0407L30.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 24.4939L383.959 30.6056H388.682L384.861 34.3829L386.321 40.4947L382.5 36.7174L378.679 40.4947L380.139 34.3829L376.318 30.6056H381.041L382.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 24.4939L207.959 30.6056H212.682L208.861 34.3829L210.321 40.4947L206.5 36.7174L202.679 40.4947L204.139 34.3829L200.318 30.6056H205.041L206.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 24.4939L559.959 30.6056H564.682L560.861 34.3829L562.321 40.4947L558.5 36.7174L554.679 40.4947L556.139 34.3829L552.318 30.6056H557.041L558.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 24.4939L119.959 30.6056H124.682L120.861 34.3829L122.321 40.4947L118.5 36.7174L114.679 40.4947L116.139 34.3829L112.318 30.6056H117.041L118.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 24.4939L471.959 30.6056H476.682L472.861 34.3829L474.321 40.4947L470.5 36.7174L466.679 40.4947L468.139 34.3829L464.318 30.6056H469.041L470.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 24.4939L295.959 30.6056H300.682L296.861 34.3829L298.321 40.4947L294.5 36.7174L290.679 40.4947L292.139 34.3829L288.318 30.6056H293.041L294.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 24.4939L647.959 30.6056H652.682L648.861 34.3829L650.321 40.4947L646.5 36.7174L642.679 40.4947L644.139 34.3829L640.318 30.6056H645.041L646.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 24.4939L9.95934 30.6056H14.6819L10.8613 34.3829L12.3206 40.4947L8.5 36.7174L4.6794 40.4947L6.13874 34.3829L2.31813 30.6056H7.04066L8.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 24.4939L361.959 30.6056H366.682L362.861 34.3829L364.321 40.4947L360.5 36.7174L356.679 40.4947L358.139 34.3829L354.318 30.6056H359.041L360.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 24.4939L185.959 30.6056H190.682L186.861 34.3829L188.321 40.4947L184.5 36.7174L180.679 40.4947L182.139 34.3829L178.318 30.6056H183.041L184.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 24.4939L537.959 30.6056H542.682L538.861 34.3829L540.321 40.4947L536.5 36.7174L532.679 40.4947L534.139 34.3829L530.318 30.6056H535.041L536.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 24.4939L97.9593 30.6056H102.682L98.8613 34.3829L100.321 40.4947L96.5 36.7174L92.6794 40.4947L94.1387 34.3829L90.3181 30.6056H95.0407L96.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 24.4939L449.959 30.6056H454.682L450.861 34.3829L452.321 40.4947L448.5 36.7174L444.679 40.4947L446.139 34.3829L442.318 30.6056H447.041L448.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 24.4939L273.959 30.6056H278.682L274.861 34.3829L276.321 40.4947L272.5 36.7174L268.679 40.4947L270.139 34.3829L266.318 30.6056H271.041L272.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 24.4939L625.959 30.6056H630.682L626.861 34.3829L628.321 40.4947L624.5 36.7174L620.679 40.4947L622.139 34.3829L618.318 30.6056H623.041L624.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 24.4939L53.9593 30.6056H58.6819L54.8613 34.3829L56.3206 40.4947L52.5 36.7174L48.6794 40.4947L50.1387 34.3829L46.3181 30.6056H51.0407L52.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 24.4939L405.959 30.6056H410.682L406.861 34.3829L408.321 40.4947L404.5 36.7174L400.679 40.4947L402.139 34.3829L398.318 30.6056H403.041L404.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 24.4939L229.959 30.6056H234.682L230.861 34.3829L232.321 40.4947L228.5 36.7174L224.679 40.4947L226.139 34.3829L222.318 30.6056H227.041L228.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 24.4939L581.959 30.6056H586.682L582.861 34.3829L584.321 40.4947L580.5 36.7174L576.679 40.4947L578.139 34.3829L574.318 30.6056H579.041L580.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 24.4939L141.959 30.6056H146.682L142.861 34.3829L144.321 40.4947L140.5 36.7174L136.679 40.4947L138.139 34.3829L134.318 30.6056H139.041L140.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 24.4939L493.959 30.6056H498.682L494.861 34.3829L496.321 40.4947L492.5 36.7174L488.679 40.4947L490.139 34.3829L486.318 30.6056H491.041L492.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 24.4939L317.959 30.6056H322.682L318.861 34.3829L320.321 40.4947L316.5 36.7174L312.679 40.4947L314.139 34.3829L310.318 30.6056H315.041L316.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 24.4939L669.959 30.6056H674.682L670.861 34.3829L672.321 40.4947L668.5 36.7174L664.679 40.4947L666.139 34.3829L662.318 30.6056H667.041L668.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 220.445L339.959 226.557H344.682L340.861 230.334L342.321 236.446L338.5 232.669L334.679 236.446L336.139 230.334L332.318 226.557H337.041L338.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 220.445L163.959 226.557H168.682L164.861 230.334L166.321 236.446L162.5 232.669L158.679 236.446L160.139 230.334L156.318 226.557H161.041L162.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 220.445L515.959 226.557H520.682L516.861 230.334L518.321 236.446L514.5 232.669L510.679 236.446L512.139 230.334L508.318 226.557H513.041L514.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 220.445L75.9593 226.557H80.6819L76.8613 230.334L78.3206 236.446L74.5 232.669L70.6794 236.446L72.1387 230.334L68.3181 226.557H73.0407L74.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 220.445L427.959 226.557H432.682L428.861 230.334L430.321 236.446L426.5 232.669L422.679 236.446L424.139 230.334L420.318 226.557H425.041L426.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 220.445L251.959 226.557H256.682L252.861 230.334L254.321 236.446L250.5 232.669L246.679 236.446L248.139 230.334L244.318 226.557H249.041L250.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 220.445L603.959 226.557H608.682L604.861 230.334L606.321 236.446L602.5 232.669L598.679 236.446L600.139 230.334L596.318 226.557H601.041L602.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 220.445L31.9593 226.557H36.6819L32.8613 230.334L34.3206 236.446L30.5 232.669L26.6794 236.446L28.1387 230.334L24.3181 226.557H29.0407L30.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 220.445L383.959 226.557H388.682L384.861 230.334L386.321 236.446L382.5 232.669L378.679 236.446L380.139 230.334L376.318 226.557H381.041L382.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 220.445L207.959 226.557H212.682L208.861 230.334L210.321 236.446L206.5 232.669L202.679 236.446L204.139 230.334L200.318 226.557H205.041L206.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 220.445L559.959 226.557H564.682L560.861 230.334L562.321 236.446L558.5 232.669L554.679 236.446L556.139 230.334L552.318 226.557H557.041L558.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 220.445L119.959 226.557H124.682L120.861 230.334L122.321 236.446L118.5 232.669L114.679 236.446L116.139 230.334L112.318 226.557H117.041L118.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 220.445L471.959 226.557H476.682L472.861 230.334L474.321 236.446L470.5 232.669L466.679 236.446L468.139 230.334L464.318 226.557H469.041L470.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 220.445L295.959 226.557H300.682L296.861 230.334L298.321 236.446L294.5 232.669L290.679 236.446L292.139 230.334L288.318 226.557H293.041L294.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 220.445L647.959 226.557H652.682L648.861 230.334L650.321 236.446L646.5 232.669L642.679 236.446L644.139 230.334L640.318 226.557H645.041L646.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 220.445L9.95934 226.557H14.6819L10.8613 230.334L12.3206 236.446L8.5 232.669L4.6794 236.446L6.13874 230.334L2.31813 226.557H7.04066L8.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 220.445L361.959 226.557H366.682L362.861 230.334L364.321 236.446L360.5 232.669L356.679 236.446L358.139 230.334L354.318 226.557H359.041L360.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 220.445L185.959 226.557H190.682L186.861 230.334L188.321 236.446L184.5 232.669L180.679 236.446L182.139 230.334L178.318 226.557H183.041L184.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 220.445L537.959 226.557H542.682L538.861 230.334L540.321 236.446L536.5 232.669L532.679 236.446L534.139 230.334L530.318 226.557H535.041L536.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 220.445L97.9593 226.557H102.682L98.8613 230.334L100.321 236.446L96.5 232.669L92.6794 236.446L94.1387 230.334L90.3181 226.557H95.0407L96.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 220.445L449.959 226.557H454.682L450.861 230.334L452.321 236.446L448.5 232.669L444.679 236.446L446.139 230.334L442.318 226.557H447.041L448.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 220.445L273.959 226.557H278.682L274.861 230.334L276.321 236.446L272.5 232.669L268.679 236.446L270.139 230.334L266.318 226.557H271.041L272.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 220.445L625.959 226.557H630.682L626.861 230.334L628.321 236.446L624.5 232.669L620.679 236.446L622.139 230.334L618.318 226.557H623.041L624.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 220.445L53.9593 226.557H58.6819L54.8613 230.334L56.3206 236.446L52.5 232.669L48.6794 236.446L50.1387 230.334L46.3181 226.557H51.0407L52.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 220.445L405.959 226.557H410.682L406.861 230.334L408.321 236.446L404.5 232.669L400.679 236.446L402.139 230.334L398.318 226.557H403.041L404.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 220.445L229.959 226.557H234.682L230.861 230.334L232.321 236.446L228.5 232.669L224.679 236.446L226.139 230.334L222.318 226.557H227.041L228.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 220.445L581.959 226.557H586.682L582.861 230.334L584.321 236.446L580.5 232.669L576.679 236.446L578.139 230.334L574.318 226.557H579.041L580.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 220.445L141.959 226.557H146.682L142.861 230.334L144.321 236.446L140.5 232.669L136.679 236.446L138.139 230.334L134.318 226.557H139.041L140.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 220.445L493.959 226.557H498.682L494.861 230.334L496.321 236.446L492.5 232.669L488.679 236.446L490.139 230.334L486.318 226.557H491.041L492.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 220.445L317.959 226.557H322.682L318.861 230.334L320.321 236.446L316.5 232.669L312.679 236.446L314.139 230.334L310.318 226.557H315.041L316.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 220.445L669.959 226.557H674.682L670.861 230.334L672.321 236.446L668.5 232.669L664.679 236.446L666.139 230.334L662.318 226.557H667.041L668.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 122.469L339.959 128.581H344.682L340.861 132.358L342.321 138.47L338.5 134.693L334.679 138.47L336.139 132.358L332.318 128.581H337.041L338.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 122.469L163.959 128.581H168.682L164.861 132.358L166.321 138.47L162.5 134.693L158.679 138.47L160.139 132.358L156.318 128.581H161.041L162.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 122.469L515.959 128.581H520.682L516.861 132.358L518.321 138.47L514.5 134.693L510.679 138.47L512.139 132.358L508.318 128.581H513.041L514.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 122.469L75.9593 128.581H80.6819L76.8613 132.358L78.3206 138.47L74.5 134.693L70.6794 138.47L72.1387 132.358L68.3181 128.581H73.0407L74.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 122.469L427.959 128.581H432.682L428.861 132.358L430.321 138.47L426.5 134.693L422.679 138.47L424.139 132.358L420.318 128.581H425.041L426.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 122.469L251.959 128.581H256.682L252.861 132.358L254.321 138.47L250.5 134.693L246.679 138.47L248.139 132.358L244.318 128.581H249.041L250.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 122.469L603.959 128.581H608.682L604.861 132.358L606.321 138.47L602.5 134.693L598.679 138.47L600.139 132.358L596.318 128.581H601.041L602.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 122.469L31.9593 128.581H36.6819L32.8613 132.358L34.3206 138.47L30.5 134.693L26.6794 138.47L28.1387 132.358L24.3181 128.581H29.0407L30.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 122.469L383.959 128.581H388.682L384.861 132.358L386.321 138.47L382.5 134.693L378.679 138.47L380.139 132.358L376.318 128.581H381.041L382.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 122.469L207.959 128.581H212.682L208.861 132.358L210.321 138.47L206.5 134.693L202.679 138.47L204.139 132.358L200.318 128.581H205.041L206.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 122.469L559.959 128.581H564.682L560.861 132.358L562.321 138.47L558.5 134.693L554.679 138.47L556.139 132.358L552.318 128.581H557.041L558.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 122.469L119.959 128.581H124.682L120.861 132.358L122.321 138.47L118.5 134.693L114.679 138.47L116.139 132.358L112.318 128.581H117.041L118.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 122.469L471.959 128.581H476.682L472.861 132.358L474.321 138.47L470.5 134.693L466.679 138.47L468.139 132.358L464.318 128.581H469.041L470.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 122.469L295.959 128.581H300.682L296.861 132.358L298.321 138.47L294.5 134.693L290.679 138.47L292.139 132.358L288.318 128.581H293.041L294.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 122.469L647.959 128.581H652.682L648.861 132.358L650.321 138.47L646.5 134.693L642.679 138.47L644.139 132.358L640.318 128.581H645.041L646.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 122.469L9.95934 128.581H14.6819L10.8613 132.358L12.3206 138.47L8.5 134.693L4.6794 138.47L6.13874 132.358L2.31813 128.581H7.04066L8.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 122.469L361.959 128.581H366.682L362.861 132.358L364.321 138.47L360.5 134.693L356.679 138.47L358.139 132.358L354.318 128.581H359.041L360.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 122.469L185.959 128.581H190.682L186.861 132.358L188.321 138.47L184.5 134.693L180.679 138.47L182.139 132.358L178.318 128.581H183.041L184.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 122.469L537.959 128.581H542.682L538.861 132.358L540.321 138.47L536.5 134.693L532.679 138.47L534.139 132.358L530.318 128.581H535.041L536.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 122.469L97.9593 128.581H102.682L98.8613 132.358L100.321 138.47L96.5 134.693L92.6794 138.47L94.1387 132.358L90.3181 128.581H95.0407L96.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 122.469L449.959 128.581H454.682L450.861 132.358L452.321 138.47L448.5 134.693L444.679 138.47L446.139 132.358L442.318 128.581H447.041L448.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 122.469L273.959 128.581H278.682L274.861 132.358L276.321 138.47L272.5 134.693L268.679 138.47L270.139 132.358L266.318 128.581H271.041L272.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 122.469L625.959 128.581H630.682L626.861 132.358L628.321 138.47L624.5 134.693L620.679 138.47L622.139 132.358L618.318 128.581H623.041L624.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 122.469L53.9593 128.581H58.6819L54.8613 132.358L56.3206 138.47L52.5 134.693L48.6794 138.47L50.1387 132.358L46.3181 128.581H51.0407L52.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 122.469L405.959 128.581H410.682L406.861 132.358L408.321 138.47L404.5 134.693L400.679 138.47L402.139 132.358L398.318 128.581H403.041L404.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 122.469L229.959 128.581H234.682L230.861 132.358L232.321 138.47L228.5 134.693L224.679 138.47L226.139 132.358L222.318 128.581H227.041L228.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 122.469L581.959 128.581H586.682L582.861 132.358L584.321 138.47L580.5 134.693L576.679 138.47L578.139 132.358L574.318 128.581H579.041L580.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 122.469L141.959 128.581H146.682L142.861 132.358L144.321 138.47L140.5 134.693L136.679 138.47L138.139 132.358L134.318 128.581H139.041L140.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 122.469L493.959 128.581H498.682L494.861 132.358L496.321 138.47L492.5 134.693L488.679 138.47L490.139 132.358L486.318 128.581H491.041L492.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 122.469L317.959 128.581H322.682L318.861 132.358L320.321 138.47L316.5 134.693L312.679 138.47L314.139 132.358L310.318 128.581H315.041L316.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 122.469L669.959 128.581H674.682L670.861 132.358L672.321 138.47L668.5 134.693L664.679 138.47L666.139 132.358L662.318 128.581H667.041L668.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 318.42L339.959 324.532H344.682L340.861 328.309L342.321 334.421L338.5 330.644L334.679 334.421L336.139 328.309L332.318 324.532H337.041L338.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 318.42L163.959 324.532H168.682L164.861 328.309L166.321 334.421L162.5 330.644L158.679 334.421L160.139 328.309L156.318 324.532H161.041L162.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 318.42L515.959 324.532H520.682L516.861 328.309L518.321 334.421L514.5 330.644L510.679 334.421L512.139 328.309L508.318 324.532H513.041L514.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 318.42L75.9593 324.532H80.6819L76.8613 328.309L78.3206 334.421L74.5 330.644L70.6794 334.421L72.1387 328.309L68.3181 324.532H73.0407L74.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 318.42L427.959 324.532H432.682L428.861 328.309L430.321 334.421L426.5 330.644L422.679 334.421L424.139 328.309L420.318 324.532H425.041L426.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 318.42L251.959 324.532H256.682L252.861 328.309L254.321 334.421L250.5 330.644L246.679 334.421L248.139 328.309L244.318 324.532H249.041L250.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 318.42L603.959 324.532H608.682L604.861 328.309L606.321 334.421L602.5 330.644L598.679 334.421L600.139 328.309L596.318 324.532H601.041L602.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 318.42L31.9593 324.532H36.6819L32.8613 328.309L34.3206 334.421L30.5 330.644L26.6794 334.421L28.1387 328.309L24.3181 324.532H29.0407L30.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 318.42L383.959 324.532H388.682L384.861 328.309L386.321 334.421L382.5 330.644L378.679 334.421L380.139 328.309L376.318 324.532H381.041L382.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 318.42L207.959 324.532H212.682L208.861 328.309L210.321 334.421L206.5 330.644L202.679 334.421L204.139 328.309L200.318 324.532H205.041L206.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 318.42L559.959 324.532H564.682L560.861 328.309L562.321 334.421L558.5 330.644L554.679 334.421L556.139 328.309L552.318 324.532H557.041L558.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 318.42L119.959 324.532H124.682L120.861 328.309L122.321 334.421L118.5 330.644L114.679 334.421L116.139 328.309L112.318 324.532H117.041L118.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 318.42L471.959 324.532H476.682L472.861 328.309L474.321 334.421L470.5 330.644L466.679 334.421L468.139 328.309L464.318 324.532H469.041L470.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 318.42L295.959 324.532H300.682L296.861 328.309L298.321 334.421L294.5 330.644L290.679 334.421L292.139 328.309L288.318 324.532H293.041L294.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 318.42L647.959 324.532H652.682L648.861 328.309L650.321 334.421L646.5 330.644L642.679 334.421L644.139 328.309L640.318 324.532H645.041L646.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 318.42L9.95934 324.532H14.6819L10.8613 328.309L12.3206 334.421L8.5 330.644L4.6794 334.421L6.13874 328.309L2.31813 324.532H7.04066L8.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 318.42L361.959 324.532H366.682L362.861 328.309L364.321 334.421L360.5 330.644L356.679 334.421L358.139 328.309L354.318 324.532H359.041L360.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 318.42L185.959 324.532H190.682L186.861 328.309L188.321 334.421L184.5 330.644L180.679 334.421L182.139 328.309L178.318 324.532H183.041L184.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 318.42L537.959 324.532H542.682L538.861 328.309L540.321 334.421L536.5 330.644L532.679 334.421L534.139 328.309L530.318 324.532H535.041L536.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 318.42L97.9593 324.532H102.682L98.8613 328.309L100.321 334.421L96.5 330.644L92.6794 334.421L94.1387 328.309L90.3181 324.532H95.0407L96.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 318.42L449.959 324.532H454.682L450.861 328.309L452.321 334.421L448.5 330.644L444.679 334.421L446.139 328.309L442.318 324.532H447.041L448.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 318.42L273.959 324.532H278.682L274.861 328.309L276.321 334.421L272.5 330.644L268.679 334.421L270.139 328.309L266.318 324.532H271.041L272.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 318.42L625.959 324.532H630.682L626.861 328.309L628.321 334.421L624.5 330.644L620.679 334.421L622.139 328.309L618.318 324.532H623.041L624.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 318.42L53.9593 324.532H58.6819L54.8613 328.309L56.3206 334.421L52.5 330.644L48.6794 334.421L50.1387 328.309L46.3181 324.532H51.0407L52.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 318.42L405.959 324.532H410.682L406.861 328.309L408.321 334.421L404.5 330.644L400.679 334.421L402.139 328.309L398.318 324.532H403.041L404.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 318.42L229.959 324.532H234.682L230.861 328.309L232.321 334.421L228.5 330.644L224.679 334.421L226.139 328.309L222.318 324.532H227.041L228.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 318.42L581.959 324.532H586.682L582.861 328.309L584.321 334.421L580.5 330.644L576.679 334.421L578.139 328.309L574.318 324.532H579.041L580.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 318.42L141.959 324.532H146.682L142.861 328.309L144.321 334.421L140.5 330.644L136.679 334.421L138.139 328.309L134.318 324.532H139.041L140.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 318.42L493.959 324.532H498.682L494.861 328.309L496.321 334.421L492.5 330.644L488.679 334.421L490.139 328.309L486.318 324.532H491.041L492.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 318.42L317.959 324.532H322.682L318.861 328.309L320.321 334.421L316.5 330.644L312.679 334.421L314.139 328.309L310.318 324.532H315.041L316.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 318.42L669.959 324.532H674.682L670.861 328.309L672.321 334.421L668.5 330.644L664.679 334.421L666.139 328.309L662.318 324.532H667.041L668.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 73.4814L339.959 79.5932H344.682L340.861 83.3705L342.321 89.4822L338.5 85.7049L334.679 89.4822L336.139 83.3705L332.318 79.5932H337.041L338.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 73.4814L163.959 79.5932H168.682L164.861 83.3705L166.321 89.4822L162.5 85.7049L158.679 89.4822L160.139 83.3705L156.318 79.5932H161.041L162.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 73.4814L515.959 79.5932H520.682L516.861 83.3705L518.321 89.4822L514.5 85.7049L510.679 89.4822L512.139 83.3705L508.318 79.5932H513.041L514.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 73.4814L75.9593 79.5932H80.6819L76.8613 83.3705L78.3206 89.4822L74.5 85.7049L70.6794 89.4822L72.1387 83.3705L68.3181 79.5932H73.0407L74.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 73.4814L427.959 79.5932H432.682L428.861 83.3705L430.321 89.4822L426.5 85.7049L422.679 89.4822L424.139 83.3705L420.318 79.5932H425.041L426.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 73.4814L251.959 79.5932H256.682L252.861 83.3705L254.321 89.4822L250.5 85.7049L246.679 89.4822L248.139 83.3705L244.318 79.5932H249.041L250.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 73.4814L603.959 79.5932H608.682L604.861 83.3705L606.321 89.4822L602.5 85.7049L598.679 89.4822L600.139 83.3705L596.318 79.5932H601.041L602.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 73.4814L31.9593 79.5932H36.6819L32.8613 83.3705L34.3206 89.4822L30.5 85.7049L26.6794 89.4822L28.1387 83.3705L24.3181 79.5932H29.0407L30.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 73.4814L383.959 79.5932H388.682L384.861 83.3705L386.321 89.4822L382.5 85.7049L378.679 89.4822L380.139 83.3705L376.318 79.5932H381.041L382.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 73.4814L207.959 79.5932H212.682L208.861 83.3705L210.321 89.4822L206.5 85.7049L202.679 89.4822L204.139 83.3705L200.318 79.5932H205.041L206.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 73.4814L559.959 79.5932H564.682L560.861 83.3705L562.321 89.4822L558.5 85.7049L554.679 89.4822L556.139 83.3705L552.318 79.5932H557.041L558.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 73.4814L119.959 79.5932H124.682L120.861 83.3705L122.321 89.4822L118.5 85.7049L114.679 89.4822L116.139 83.3705L112.318 79.5932H117.041L118.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 73.4814L471.959 79.5932H476.682L472.861 83.3705L474.321 89.4822L470.5 85.7049L466.679 89.4822L468.139 83.3705L464.318 79.5932H469.041L470.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 73.4814L295.959 79.5932H300.682L296.861 83.3705L298.321 89.4822L294.5 85.7049L290.679 89.4822L292.139 83.3705L288.318 79.5932H293.041L294.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 73.4814L647.959 79.5932H652.682L648.861 83.3705L650.321 89.4822L646.5 85.7049L642.679 89.4822L644.139 83.3705L640.318 79.5932H645.041L646.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 73.4814L9.95934 79.5932H14.6819L10.8613 83.3705L12.3206 89.4822L8.5 85.7049L4.6794 89.4822L6.13874 83.3705L2.31813 79.5932H7.04066L8.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 73.4814L361.959 79.5932H366.682L362.861 83.3705L364.321 89.4822L360.5 85.7049L356.679 89.4822L358.139 83.3705L354.318 79.5932H359.041L360.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 73.4814L185.959 79.5932H190.682L186.861 83.3705L188.321 89.4822L184.5 85.7049L180.679 89.4822L182.139 83.3705L178.318 79.5932H183.041L184.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 73.4814L537.959 79.5932H542.682L538.861 83.3705L540.321 89.4822L536.5 85.7049L532.679 89.4822L534.139 83.3705L530.318 79.5932H535.041L536.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 73.4814L97.9593 79.5932H102.682L98.8613 83.3705L100.321 89.4822L96.5 85.7049L92.6794 89.4822L94.1387 83.3705L90.3181 79.5932H95.0407L96.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 73.4814L449.959 79.5932H454.682L450.861 83.3705L452.321 89.4822L448.5 85.7049L444.679 89.4822L446.139 83.3705L442.318 79.5932H447.041L448.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 73.4814L273.959 79.5932H278.682L274.861 83.3705L276.321 89.4822L272.5 85.7049L268.679 89.4822L270.139 83.3705L266.318 79.5932H271.041L272.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 73.4814L625.959 79.5932H630.682L626.861 83.3705L628.321 89.4822L624.5 85.7049L620.679 89.4822L622.139 83.3705L618.318 79.5932H623.041L624.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 73.4814L53.9593 79.5932H58.6819L54.8613 83.3705L56.3206 89.4822L52.5 85.7049L48.6794 89.4822L50.1387 83.3705L46.3181 79.5932H51.0407L52.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 73.4814L405.959 79.5932H410.682L406.861 83.3705L408.321 89.4822L404.5 85.7049L400.679 89.4822L402.139 83.3705L398.318 79.5932H403.041L404.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 73.4814L229.959 79.5932H234.682L230.861 83.3705L232.321 89.4822L228.5 85.7049L224.679 89.4822L226.139 83.3705L222.318 79.5932H227.041L228.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 73.4814L581.959 79.5932H586.682L582.861 83.3705L584.321 89.4822L580.5 85.7049L576.679 89.4822L578.139 83.3705L574.318 79.5932H579.041L580.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 73.4814L141.959 79.5932H146.682L142.861 83.3705L144.321 89.4822L140.5 85.7049L136.679 89.4822L138.139 83.3705L134.318 79.5932H139.041L140.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 73.4814L493.959 79.5932H498.682L494.861 83.3705L496.321 89.4822L492.5 85.7049L488.679 89.4822L490.139 83.3705L486.318 79.5932H491.041L492.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 73.4814L317.959 79.5932H322.682L318.861 83.3705L320.321 89.4822L316.5 85.7049L312.679 89.4822L314.139 83.3705L310.318 79.5932H315.041L316.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 73.4814L669.959 79.5932H674.682L670.861 83.3705L672.321 89.4822L668.5 85.7049L664.679 89.4822L666.139 83.3705L662.318 79.5932H667.041L668.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 269.433L339.959 275.544H344.682L340.861 279.322L342.321 285.433L338.5 281.656L334.679 285.433L336.139 279.322L332.318 275.544H337.041L338.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 269.433L163.959 275.544H168.682L164.861 279.322L166.321 285.433L162.5 281.656L158.679 285.433L160.139 279.322L156.318 275.544H161.041L162.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 269.433L515.959 275.544H520.682L516.861 279.322L518.321 285.433L514.5 281.656L510.679 285.433L512.139 279.322L508.318 275.544H513.041L514.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 269.433L75.9593 275.544H80.6819L76.8613 279.322L78.3206 285.433L74.5 281.656L70.6794 285.433L72.1387 279.322L68.3181 275.544H73.0407L74.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 269.433L427.959 275.544H432.682L428.861 279.322L430.321 285.433L426.5 281.656L422.679 285.433L424.139 279.322L420.318 275.544H425.041L426.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 269.433L251.959 275.544H256.682L252.861 279.322L254.321 285.433L250.5 281.656L246.679 285.433L248.139 279.322L244.318 275.544H249.041L250.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 269.433L603.959 275.544H608.682L604.861 279.322L606.321 285.433L602.5 281.656L598.679 285.433L600.139 279.322L596.318 275.544H601.041L602.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 269.433L31.9593 275.544H36.6819L32.8613 279.322L34.3206 285.433L30.5 281.656L26.6794 285.433L28.1387 279.322L24.3181 275.544H29.0407L30.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 269.433L383.959 275.544H388.682L384.861 279.322L386.321 285.433L382.5 281.656L378.679 285.433L380.139 279.322L376.318 275.544H381.041L382.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 269.433L207.959 275.544H212.682L208.861 279.322L210.321 285.433L206.5 281.656L202.679 285.433L204.139 279.322L200.318 275.544H205.041L206.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 269.433L559.959 275.544H564.682L560.861 279.322L562.321 285.433L558.5 281.656L554.679 285.433L556.139 279.322L552.318 275.544H557.041L558.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 269.433L119.959 275.544H124.682L120.861 279.322L122.321 285.433L118.5 281.656L114.679 285.433L116.139 279.322L112.318 275.544H117.041L118.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 269.433L471.959 275.544H476.682L472.861 279.322L474.321 285.433L470.5 281.656L466.679 285.433L468.139 279.322L464.318 275.544H469.041L470.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 269.433L295.959 275.544H300.682L296.861 279.322L298.321 285.433L294.5 281.656L290.679 285.433L292.139 279.322L288.318 275.544H293.041L294.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 269.433L647.959 275.544H652.682L648.861 279.322L650.321 285.433L646.5 281.656L642.679 285.433L644.139 279.322L640.318 275.544H645.041L646.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 269.433L9.95934 275.544H14.6819L10.8613 279.322L12.3206 285.433L8.5 281.656L4.6794 285.433L6.13874 279.322L2.31813 275.544H7.04066L8.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 269.433L361.959 275.544H366.682L362.861 279.322L364.321 285.433L360.5 281.656L356.679 285.433L358.139 279.322L354.318 275.544H359.041L360.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 269.433L185.959 275.544H190.682L186.861 279.322L188.321 285.433L184.5 281.656L180.679 285.433L182.139 279.322L178.318 275.544H183.041L184.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 269.433L537.959 275.544H542.682L538.861 279.322L540.321 285.433L536.5 281.656L532.679 285.433L534.139 279.322L530.318 275.544H535.041L536.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 269.433L97.9593 275.544H102.682L98.8613 279.322L100.321 285.433L96.5 281.656L92.6794 285.433L94.1387 279.322L90.3181 275.544H95.0407L96.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 269.433L449.959 275.544H454.682L450.861 279.322L452.321 285.433L448.5 281.656L444.679 285.433L446.139 279.322L442.318 275.544H447.041L448.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 269.433L273.959 275.544H278.682L274.861 279.322L276.321 285.433L272.5 281.656L268.679 285.433L270.139 279.322L266.318 275.544H271.041L272.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 269.433L625.959 275.544H630.682L626.861 279.322L628.321 285.433L624.5 281.656L620.679 285.433L622.139 279.322L618.318 275.544H623.041L624.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 269.433L53.9593 275.544H58.6819L54.8613 279.322L56.3206 285.433L52.5 281.656L48.6794 285.433L50.1387 279.322L46.3181 275.544H51.0407L52.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 269.433L405.959 275.544H410.682L406.861 279.322L408.321 285.433L404.5 281.656L400.679 285.433L402.139 279.322L398.318 275.544H403.041L404.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 269.433L229.959 275.544H234.682L230.861 279.322L232.321 285.433L228.5 281.656L224.679 285.433L226.139 279.322L222.318 275.544H227.041L228.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 269.433L581.959 275.544H586.682L582.861 279.322L584.321 285.433L580.5 281.656L576.679 285.433L578.139 279.322L574.318 275.544H579.041L580.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 269.433L141.959 275.544H146.682L142.861 279.322L144.321 285.433L140.5 281.656L136.679 285.433L138.139 279.322L134.318 275.544H139.041L140.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 269.433L493.959 275.544H498.682L494.861 279.322L496.321 285.433L492.5 281.656L488.679 285.433L490.139 279.322L486.318 275.544H491.041L492.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 269.433L317.959 275.544H322.682L318.861 279.322L320.321 285.433L316.5 281.656L312.679 285.433L314.139 279.322L310.318 275.544H315.041L316.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 269.433L669.959 275.544H674.682L670.861 279.322L672.321 285.433L668.5 281.656L664.679 285.433L666.139 279.322L662.318 275.544H667.041L668.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 171.457L339.959 177.569H344.682L340.861 181.346L342.321 187.458L338.5 183.681L334.679 187.458L336.139 181.346L332.318 177.569H337.041L338.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 171.457L163.959 177.569H168.682L164.861 181.346L166.321 187.458L162.5 183.681L158.679 187.458L160.139 181.346L156.318 177.569H161.041L162.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 171.457L515.959 177.569H520.682L516.861 181.346L518.321 187.458L514.5 183.681L510.679 187.458L512.139 181.346L508.318 177.569H513.041L514.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 171.457L75.9593 177.569H80.6819L76.8613 181.346L78.3206 187.458L74.5 183.681L70.6794 187.458L72.1387 181.346L68.3181 177.569H73.0407L74.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 171.457L427.959 177.569H432.682L428.861 181.346L430.321 187.458L426.5 183.681L422.679 187.458L424.139 181.346L420.318 177.569H425.041L426.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 171.457L251.959 177.569H256.682L252.861 181.346L254.321 187.458L250.5 183.681L246.679 187.458L248.139 181.346L244.318 177.569H249.041L250.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 171.457L603.959 177.569H608.682L604.861 181.346L606.321 187.458L602.5 183.681L598.679 187.458L600.139 181.346L596.318 177.569H601.041L602.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 171.457L31.9593 177.569H36.6819L32.8613 181.346L34.3206 187.458L30.5 183.681L26.6794 187.458L28.1387 181.346L24.3181 177.569H29.0407L30.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 171.457L383.959 177.569H388.682L384.861 181.346L386.321 187.458L382.5 183.681L378.679 187.458L380.139 181.346L376.318 177.569H381.041L382.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 171.457L207.959 177.569H212.682L208.861 181.346L210.321 187.458L206.5 183.681L202.679 187.458L204.139 181.346L200.318 177.569H205.041L206.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 171.457L559.959 177.569H564.682L560.861 181.346L562.321 187.458L558.5 183.681L554.679 187.458L556.139 181.346L552.318 177.569H557.041L558.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 171.457L119.959 177.569H124.682L120.861 181.346L122.321 187.458L118.5 183.681L114.679 187.458L116.139 181.346L112.318 177.569H117.041L118.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 171.457L471.959 177.569H476.682L472.861 181.346L474.321 187.458L470.5 183.681L466.679 187.458L468.139 181.346L464.318 177.569H469.041L470.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 171.457L295.959 177.569H300.682L296.861 181.346L298.321 187.458L294.5 183.681L290.679 187.458L292.139 181.346L288.318 177.569H293.041L294.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 171.457L647.959 177.569H652.682L648.861 181.346L650.321 187.458L646.5 183.681L642.679 187.458L644.139 181.346L640.318 177.569H645.041L646.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 171.457L9.95934 177.569H14.6819L10.8613 181.346L12.3206 187.458L8.5 183.681L4.6794 187.458L6.13874 181.346L2.31813 177.569H7.04066L8.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 171.457L361.959 177.569H366.682L362.861 181.346L364.321 187.458L360.5 183.681L356.679 187.458L358.139 181.346L354.318 177.569H359.041L360.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 171.457L185.959 177.569H190.682L186.861 181.346L188.321 187.458L184.5 183.681L180.679 187.458L182.139 181.346L178.318 177.569H183.041L184.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 171.457L537.959 177.569H542.682L538.861 181.346L540.321 187.458L536.5 183.681L532.679 187.458L534.139 181.346L530.318 177.569H535.041L536.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 171.457L97.9593 177.569H102.682L98.8613 181.346L100.321 187.458L96.5 183.681L92.6794 187.458L94.1387 181.346L90.3181 177.569H95.0407L96.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 171.457L449.959 177.569H454.682L450.861 181.346L452.321 187.458L448.5 183.681L444.679 187.458L446.139 181.346L442.318 177.569H447.041L448.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 171.457L273.959 177.569H278.682L274.861 181.346L276.321 187.458L272.5 183.681L268.679 187.458L270.139 181.346L266.318 177.569H271.041L272.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 171.457L625.959 177.569H630.682L626.861 181.346L628.321 187.458L624.5 183.681L620.679 187.458L622.139 181.346L618.318 177.569H623.041L624.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 171.457L53.9593 177.569H58.6819L54.8613 181.346L56.3206 187.458L52.5 183.681L48.6794 187.458L50.1387 181.346L46.3181 177.569H51.0407L52.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 171.457L405.959 177.569H410.682L406.861 181.346L408.321 187.458L404.5 183.681L400.679 187.458L402.139 181.346L398.318 177.569H403.041L404.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 171.457L229.959 177.569H234.682L230.861 181.346L232.321 187.458L228.5 183.681L224.679 187.458L226.139 181.346L222.318 177.569H227.041L228.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 171.457L581.959 177.569H586.682L582.861 181.346L584.321 187.458L580.5 183.681L576.679 187.458L578.139 181.346L574.318 177.569H579.041L580.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 171.457L141.959 177.569H146.682L142.861 181.346L144.321 187.458L140.5 183.681L136.679 187.458L138.139 181.346L134.318 177.569H139.041L140.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 171.457L493.959 177.569H498.682L494.861 181.346L496.321 187.458L492.5 183.681L488.679 187.458L490.139 181.346L486.318 177.569H491.041L492.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 171.457L317.959 177.569H322.682L318.861 181.346L320.321 187.458L316.5 183.681L312.679 187.458L314.139 181.346L310.318 177.569H315.041L316.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 171.457L669.959 177.569H674.682L670.861 181.346L672.321 187.458L668.5 183.681L664.679 187.458L666.139 181.346L662.318 177.569H667.041L668.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 367.408L339.959 373.52H344.682L340.861 377.297L342.321 383.409L338.5 379.631L334.679 383.409L336.139 377.297L332.318 373.52H337.041L338.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 367.408L163.959 373.52H168.682L164.861 377.297L166.321 383.409L162.5 379.631L158.679 383.409L160.139 377.297L156.318 373.52H161.041L162.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 367.408L515.959 373.52H520.682L516.861 377.297L518.321 383.409L514.5 379.631L510.679 383.409L512.139 377.297L508.318 373.52H513.041L514.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 367.408L75.9593 373.52H80.6819L76.8613 377.297L78.3206 383.409L74.5 379.631L70.6794 383.409L72.1387 377.297L68.3181 373.52H73.0407L74.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 367.408L427.959 373.52H432.682L428.861 377.297L430.321 383.409L426.5 379.631L422.679 383.409L424.139 377.297L420.318 373.52H425.041L426.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 367.408L251.959 373.52H256.682L252.861 377.297L254.321 383.409L250.5 379.631L246.679 383.409L248.139 377.297L244.318 373.52H249.041L250.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 367.408L603.959 373.52H608.682L604.861 377.297L606.321 383.409L602.5 379.631L598.679 383.409L600.139 377.297L596.318 373.52H601.041L602.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 367.408L31.9593 373.52H36.6819L32.8613 377.297L34.3206 383.409L30.5 379.631L26.6794 383.409L28.1387 377.297L24.3181 373.52H29.0407L30.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 367.408L383.959 373.52H388.682L384.861 377.297L386.321 383.409L382.5 379.631L378.679 383.409L380.139 377.297L376.318 373.52H381.041L382.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 367.408L207.959 373.52H212.682L208.861 377.297L210.321 383.409L206.5 379.631L202.679 383.409L204.139 377.297L200.318 373.52H205.041L206.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 367.408L559.959 373.52H564.682L560.861 377.297L562.321 383.409L558.5 379.631L554.679 383.409L556.139 377.297L552.318 373.52H557.041L558.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 367.408L119.959 373.52H124.682L120.861 377.297L122.321 383.409L118.5 379.631L114.679 383.409L116.139 377.297L112.318 373.52H117.041L118.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 367.408L471.959 373.52H476.682L472.861 377.297L474.321 383.409L470.5 379.631L466.679 383.409L468.139 377.297L464.318 373.52H469.041L470.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 367.408L295.959 373.52H300.682L296.861 377.297L298.321 383.409L294.5 379.631L290.679 383.409L292.139 377.297L288.318 373.52H293.041L294.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 367.408L647.959 373.52H652.682L648.861 377.297L650.321 383.409L646.5 379.631L642.679 383.409L644.139 377.297L640.318 373.52H645.041L646.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 367.408L9.95934 373.52H14.6819L10.8613 377.297L12.3206 383.409L8.5 379.631L4.6794 383.409L6.13874 377.297L2.31813 373.52H7.04066L8.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 367.408L361.959 373.52H366.682L362.861 377.297L364.321 383.409L360.5 379.631L356.679 383.409L358.139 377.297L354.318 373.52H359.041L360.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 367.408L185.959 373.52H190.682L186.861 377.297L188.321 383.409L184.5 379.631L180.679 383.409L182.139 377.297L178.318 373.52H183.041L184.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 367.408L537.959 373.52H542.682L538.861 377.297L540.321 383.409L536.5 379.631L532.679 383.409L534.139 377.297L530.318 373.52H535.041L536.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 367.408L97.9593 373.52H102.682L98.8613 377.297L100.321 383.409L96.5 379.631L92.6794 383.409L94.1387 377.297L90.3181 373.52H95.0407L96.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 367.408L449.959 373.52H454.682L450.861 377.297L452.321 383.409L448.5 379.631L444.679 383.409L446.139 377.297L442.318 373.52H447.041L448.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 367.408L273.959 373.52H278.682L274.861 377.297L276.321 383.409L272.5 379.631L268.679 383.409L270.139 377.297L266.318 373.52H271.041L272.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 367.408L625.959 373.52H630.682L626.861 377.297L628.321 383.409L624.5 379.631L620.679 383.409L622.139 377.297L618.318 373.52H623.041L624.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 367.408L53.9593 373.52H58.6819L54.8613 377.297L56.3206 383.409L52.5 379.631L48.6794 383.409L50.1387 377.297L46.3181 373.52H51.0407L52.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 367.408L405.959 373.52H410.682L406.861 377.297L408.321 383.409L404.5 379.631L400.679 383.409L402.139 377.297L398.318 373.52H403.041L404.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 367.408L229.959 373.52H234.682L230.861 377.297L232.321 383.409L228.5 379.631L224.679 383.409L226.139 377.297L222.318 373.52H227.041L228.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 367.408L581.959 373.52H586.682L582.861 377.297L584.321 383.409L580.5 379.631L576.679 383.409L578.139 377.297L574.318 373.52H579.041L580.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 367.408L141.959 373.52H146.682L142.861 377.297L144.321 383.409L140.5 379.631L136.679 383.409L138.139 377.297L134.318 373.52H139.041L140.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 367.408L493.959 373.52H498.682L494.861 377.297L496.321 383.409L492.5 379.631L488.679 383.409L490.139 377.297L486.318 373.52H491.041L492.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 367.408L317.959 373.52H322.682L318.861 377.297L320.321 383.409L316.5 379.631L312.679 383.409L314.139 377.297L310.318 373.52H315.041L316.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 367.408L669.959 373.52H674.682L670.861 377.297L672.321 383.409L668.5 379.631L664.679 383.409L666.139 377.297L662.318 373.52H667.041L668.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 391.902L339.959 398.014H344.682L340.861 401.791L342.321 407.903L338.5 404.125L334.679 407.903L336.139 401.791L332.318 398.014H337.041L338.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 391.902L163.959 398.014H168.682L164.861 401.791L166.321 407.903L162.5 404.125L158.679 407.903L160.139 401.791L156.318 398.014H161.041L162.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 391.902L515.959 398.014H520.682L516.861 401.791L518.321 407.903L514.5 404.125L510.679 407.903L512.139 401.791L508.318 398.014H513.041L514.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 391.902L75.9593 398.014H80.6819L76.8613 401.791L78.3206 407.903L74.5 404.125L70.6794 407.903L72.1387 401.791L68.3181 398.014H73.0407L74.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 391.902L427.959 398.014H432.682L428.861 401.791L430.321 407.903L426.5 404.125L422.679 407.903L424.139 401.791L420.318 398.014H425.041L426.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 391.902L251.959 398.014H256.682L252.861 401.791L254.321 407.903L250.5 404.125L246.679 407.903L248.139 401.791L244.318 398.014H249.041L250.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 391.902L603.959 398.014H608.682L604.861 401.791L606.321 407.903L602.5 404.125L598.679 407.903L600.139 401.791L596.318 398.014H601.041L602.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 391.902L31.9593 398.014H36.6819L32.8613 401.791L34.3206 407.903L30.5 404.125L26.6794 407.903L28.1387 401.791L24.3181 398.014H29.0407L30.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 391.902L383.959 398.014H388.682L384.861 401.791L386.321 407.903L382.5 404.125L378.679 407.903L380.139 401.791L376.318 398.014H381.041L382.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 391.902L207.959 398.014H212.682L208.861 401.791L210.321 407.903L206.5 404.125L202.679 407.903L204.139 401.791L200.318 398.014H205.041L206.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 391.902L559.959 398.014H564.682L560.861 401.791L562.321 407.903L558.5 404.125L554.679 407.903L556.139 401.791L552.318 398.014H557.041L558.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 391.902L119.959 398.014H124.682L120.861 401.791L122.321 407.903L118.5 404.125L114.679 407.903L116.139 401.791L112.318 398.014H117.041L118.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 391.902L471.959 398.014H476.682L472.861 401.791L474.321 407.903L470.5 404.125L466.679 407.903L468.139 401.791L464.318 398.014H469.041L470.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 391.902L295.959 398.014H300.682L296.861 401.791L298.321 407.903L294.5 404.125L290.679 407.903L292.139 401.791L288.318 398.014H293.041L294.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 391.902L647.959 398.014H652.682L648.861 401.791L650.321 407.903L646.5 404.125L642.679 407.903L644.139 401.791L640.318 398.014H645.041L646.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 391.902L9.95934 398.014H14.6819L10.8613 401.791L12.3206 407.903L8.5 404.125L4.6794 407.903L6.13874 401.791L2.31813 398.014H7.04066L8.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 391.902L361.959 398.014H366.682L362.861 401.791L364.321 407.903L360.5 404.125L356.679 407.903L358.139 401.791L354.318 398.014H359.041L360.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 391.902L185.959 398.014H190.682L186.861 401.791L188.321 407.903L184.5 404.125L180.679 407.903L182.139 401.791L178.318 398.014H183.041L184.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 391.902L537.959 398.014H542.682L538.861 401.791L540.321 407.903L536.5 404.125L532.679 407.903L534.139 401.791L530.318 398.014H535.041L536.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 391.902L97.9593 398.014H102.682L98.8613 401.791L100.321 407.903L96.5 404.125L92.6794 407.903L94.1387 401.791L90.3181 398.014H95.0407L96.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 391.902L449.959 398.014H454.682L450.861 401.791L452.321 407.903L448.5 404.125L444.679 407.903L446.139 401.791L442.318 398.014H447.041L448.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 391.902L273.959 398.014H278.682L274.861 401.791L276.321 407.903L272.5 404.125L268.679 407.903L270.139 401.791L266.318 398.014H271.041L272.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 391.902L625.959 398.014H630.682L626.861 401.791L628.321 407.903L624.5 404.125L620.679 407.903L622.139 401.791L618.318 398.014H623.041L624.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 391.902L53.9593 398.014H58.6819L54.8613 401.791L56.3206 407.903L52.5 404.125L48.6794 407.903L50.1387 401.791L46.3181 398.014H51.0407L52.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 391.902L405.959 398.014H410.682L406.861 401.791L408.321 407.903L404.5 404.125L400.679 407.903L402.139 401.791L398.318 398.014H403.041L404.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 391.902L229.959 398.014H234.682L230.861 401.791L232.321 407.903L228.5 404.125L224.679 407.903L226.139 401.791L222.318 398.014H227.041L228.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 391.902L581.959 398.014H586.682L582.861 401.791L584.321 407.903L580.5 404.125L576.679 407.903L578.139 401.791L574.318 398.014H579.041L580.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 391.902L141.959 398.014H146.682L142.861 401.791L144.321 407.903L140.5 404.125L136.679 407.903L138.139 401.791L134.318 398.014H139.041L140.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 391.902L493.959 398.014H498.682L494.861 401.791L496.321 407.903L492.5 404.125L488.679 407.903L490.139 401.791L486.318 398.014H491.041L492.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 391.902L317.959 398.014H322.682L318.861 401.791L320.321 407.903L316.5 404.125L312.679 407.903L314.139 401.791L310.318 398.014H315.041L316.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 391.902L669.959 398.014H674.682L670.861 401.791L672.321 407.903L668.5 404.125L664.679 407.903L666.139 401.791L662.318 398.014H667.041L668.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 587.853L339.959 593.965H344.682L340.861 597.742L342.321 603.854L338.5 600.076L334.679 603.854L336.139 597.742L332.318 593.965H337.041L338.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 587.853L163.959 593.965H168.682L164.861 597.742L166.321 603.854L162.5 600.076L158.679 603.854L160.139 597.742L156.318 593.965H161.041L162.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 587.853L515.959 593.965H520.682L516.861 597.742L518.321 603.854L514.5 600.076L510.679 603.854L512.139 597.742L508.318 593.965H513.041L514.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 587.853L75.9593 593.965H80.6819L76.8613 597.742L78.3206 603.854L74.5 600.076L70.6794 603.854L72.1387 597.742L68.3181 593.965H73.0407L74.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 587.853L427.959 593.965H432.682L428.861 597.742L430.321 603.854L426.5 600.076L422.679 603.854L424.139 597.742L420.318 593.965H425.041L426.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 587.853L251.959 593.965H256.682L252.861 597.742L254.321 603.854L250.5 600.076L246.679 603.854L248.139 597.742L244.318 593.965H249.041L250.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 587.853L603.959 593.965H608.682L604.861 597.742L606.321 603.854L602.5 600.076L598.679 603.854L600.139 597.742L596.318 593.965H601.041L602.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 587.853L31.9593 593.965H36.6819L32.8613 597.742L34.3206 603.854L30.5 600.076L26.6794 603.854L28.1387 597.742L24.3181 593.965H29.0407L30.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 587.853L383.959 593.965H388.682L384.861 597.742L386.321 603.854L382.5 600.076L378.679 603.854L380.139 597.742L376.318 593.965H381.041L382.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 587.853L207.959 593.965H212.682L208.861 597.742L210.321 603.854L206.5 600.076L202.679 603.854L204.139 597.742L200.318 593.965H205.041L206.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 587.853L559.959 593.965H564.682L560.861 597.742L562.321 603.854L558.5 600.076L554.679 603.854L556.139 597.742L552.318 593.965H557.041L558.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 587.853L119.959 593.965H124.682L120.861 597.742L122.321 603.854L118.5 600.076L114.679 603.854L116.139 597.742L112.318 593.965H117.041L118.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 587.853L471.959 593.965H476.682L472.861 597.742L474.321 603.854L470.5 600.076L466.679 603.854L468.139 597.742L464.318 593.965H469.041L470.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 587.853L295.959 593.965H300.682L296.861 597.742L298.321 603.854L294.5 600.076L290.679 603.854L292.139 597.742L288.318 593.965H293.041L294.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 587.853L647.959 593.965H652.682L648.861 597.742L650.321 603.854L646.5 600.076L642.679 603.854L644.139 597.742L640.318 593.965H645.041L646.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 587.853L9.95934 593.965H14.6819L10.8613 597.742L12.3206 603.854L8.5 600.076L4.6794 603.854L6.13874 597.742L2.31813 593.965H7.04066L8.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 587.853L361.959 593.965H366.682L362.861 597.742L364.321 603.854L360.5 600.076L356.679 603.854L358.139 597.742L354.318 593.965H359.041L360.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 587.853L185.959 593.965H190.682L186.861 597.742L188.321 603.854L184.5 600.076L180.679 603.854L182.139 597.742L178.318 593.965H183.041L184.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 587.853L537.959 593.965H542.682L538.861 597.742L540.321 603.854L536.5 600.076L532.679 603.854L534.139 597.742L530.318 593.965H535.041L536.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 587.853L97.9593 593.965H102.682L98.8613 597.742L100.321 603.854L96.5 600.076L92.6794 603.854L94.1387 597.742L90.3181 593.965H95.0407L96.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 587.853L449.959 593.965H454.682L450.861 597.742L452.321 603.854L448.5 600.076L444.679 603.854L446.139 597.742L442.318 593.965H447.041L448.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 587.853L273.959 593.965H278.682L274.861 597.742L276.321 603.854L272.5 600.076L268.679 603.854L270.139 597.742L266.318 593.965H271.041L272.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 587.853L625.959 593.965H630.682L626.861 597.742L628.321 603.854L624.5 600.076L620.679 603.854L622.139 597.742L618.318 593.965H623.041L624.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 587.853L53.9593 593.965H58.6819L54.8613 597.742L56.3206 603.854L52.5 600.076L48.6794 603.854L50.1387 597.742L46.3181 593.965H51.0407L52.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 587.853L405.959 593.965H410.682L406.861 597.742L408.321 603.854L404.5 600.076L400.679 603.854L402.139 597.742L398.318 593.965H403.041L404.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 587.853L229.959 593.965H234.682L230.861 597.742L232.321 603.854L228.5 600.076L224.679 603.854L226.139 597.742L222.318 593.965H227.041L228.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 587.853L581.959 593.965H586.682L582.861 597.742L584.321 603.854L580.5 600.076L576.679 603.854L578.139 597.742L574.318 593.965H579.041L580.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 587.853L141.959 593.965H146.682L142.861 597.742L144.321 603.854L140.5 600.076L136.679 603.854L138.139 597.742L134.318 593.965H139.041L140.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 587.853L493.959 593.965H498.682L494.861 597.742L496.321 603.854L492.5 600.076L488.679 603.854L490.139 597.742L486.318 593.965H491.041L492.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 587.853L317.959 593.965H322.682L318.861 597.742L320.321 603.854L316.5 600.076L312.679 603.854L314.139 597.742L310.318 593.965H315.041L316.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 587.853L669.959 593.965H674.682L670.861 597.742L672.321 603.854L668.5 600.076L664.679 603.854L666.139 597.742L662.318 593.965H667.041L668.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 489.877L339.959 495.989H344.682L340.861 499.766L342.321 505.878L338.5 502.101L334.679 505.878L336.139 499.766L332.318 495.989H337.041L338.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 489.877L163.959 495.989H168.682L164.861 499.766L166.321 505.878L162.5 502.101L158.679 505.878L160.139 499.766L156.318 495.989H161.041L162.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 489.877L515.959 495.989H520.682L516.861 499.766L518.321 505.878L514.5 502.101L510.679 505.878L512.139 499.766L508.318 495.989H513.041L514.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 489.877L75.9593 495.989H80.6819L76.8613 499.766L78.3206 505.878L74.5 502.101L70.6794 505.878L72.1387 499.766L68.3181 495.989H73.0407L74.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 489.877L427.959 495.989H432.682L428.861 499.766L430.321 505.878L426.5 502.101L422.679 505.878L424.139 499.766L420.318 495.989H425.041L426.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 489.877L251.959 495.989H256.682L252.861 499.766L254.321 505.878L250.5 502.101L246.679 505.878L248.139 499.766L244.318 495.989H249.041L250.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 489.877L603.959 495.989H608.682L604.861 499.766L606.321 505.878L602.5 502.101L598.679 505.878L600.139 499.766L596.318 495.989H601.041L602.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 489.877L31.9593 495.989H36.6819L32.8613 499.766L34.3206 505.878L30.5 502.101L26.6794 505.878L28.1387 499.766L24.3181 495.989H29.0407L30.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 489.877L383.959 495.989H388.682L384.861 499.766L386.321 505.878L382.5 502.101L378.679 505.878L380.139 499.766L376.318 495.989H381.041L382.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 489.877L207.959 495.989H212.682L208.861 499.766L210.321 505.878L206.5 502.101L202.679 505.878L204.139 499.766L200.318 495.989H205.041L206.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 489.877L559.959 495.989H564.682L560.861 499.766L562.321 505.878L558.5 502.101L554.679 505.878L556.139 499.766L552.318 495.989H557.041L558.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 489.877L119.959 495.989H124.682L120.861 499.766L122.321 505.878L118.5 502.101L114.679 505.878L116.139 499.766L112.318 495.989H117.041L118.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 489.877L471.959 495.989H476.682L472.861 499.766L474.321 505.878L470.5 502.101L466.679 505.878L468.139 499.766L464.318 495.989H469.041L470.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 489.877L295.959 495.989H300.682L296.861 499.766L298.321 505.878L294.5 502.101L290.679 505.878L292.139 499.766L288.318 495.989H293.041L294.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 489.877L647.959 495.989H652.682L648.861 499.766L650.321 505.878L646.5 502.101L642.679 505.878L644.139 499.766L640.318 495.989H645.041L646.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 489.877L9.95934 495.989H14.6819L10.8613 499.766L12.3206 505.878L8.5 502.101L4.6794 505.878L6.13874 499.766L2.31813 495.989H7.04066L8.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 489.877L361.959 495.989H366.682L362.861 499.766L364.321 505.878L360.5 502.101L356.679 505.878L358.139 499.766L354.318 495.989H359.041L360.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 489.877L185.959 495.989H190.682L186.861 499.766L188.321 505.878L184.5 502.101L180.679 505.878L182.139 499.766L178.318 495.989H183.041L184.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 489.877L537.959 495.989H542.682L538.861 499.766L540.321 505.878L536.5 502.101L532.679 505.878L534.139 499.766L530.318 495.989H535.041L536.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 489.877L97.9593 495.989H102.682L98.8613 499.766L100.321 505.878L96.5 502.101L92.6794 505.878L94.1387 499.766L90.3181 495.989H95.0407L96.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 489.877L449.959 495.989H454.682L450.861 499.766L452.321 505.878L448.5 502.101L444.679 505.878L446.139 499.766L442.318 495.989H447.041L448.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 489.877L273.959 495.989H278.682L274.861 499.766L276.321 505.878L272.5 502.101L268.679 505.878L270.139 499.766L266.318 495.989H271.041L272.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 489.877L625.959 495.989H630.682L626.861 499.766L628.321 505.878L624.5 502.101L620.679 505.878L622.139 499.766L618.318 495.989H623.041L624.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 489.877L53.9593 495.989H58.6819L54.8613 499.766L56.3206 505.878L52.5 502.101L48.6794 505.878L50.1387 499.766L46.3181 495.989H51.0407L52.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 489.877L405.959 495.989H410.682L406.861 499.766L408.321 505.878L404.5 502.101L400.679 505.878L402.139 499.766L398.318 495.989H403.041L404.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 489.877L229.959 495.989H234.682L230.861 499.766L232.321 505.878L228.5 502.101L224.679 505.878L226.139 499.766L222.318 495.989H227.041L228.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 489.877L581.959 495.989H586.682L582.861 499.766L584.321 505.878L580.5 502.101L576.679 505.878L578.139 499.766L574.318 495.989H579.041L580.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 489.877L141.959 495.989H146.682L142.861 499.766L144.321 505.878L140.5 502.101L136.679 505.878L138.139 499.766L134.318 495.989H139.041L140.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 489.877L493.959 495.989H498.682L494.861 499.766L496.321 505.878L492.5 502.101L488.679 505.878L490.139 499.766L486.318 495.989H491.041L492.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 489.877L317.959 495.989H322.682L318.861 499.766L320.321 505.878L316.5 502.101L312.679 505.878L314.139 499.766L310.318 495.989H315.041L316.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 489.877L669.959 495.989H674.682L670.861 499.766L672.321 505.878L668.5 502.101L664.679 505.878L666.139 499.766L662.318 495.989H667.041L668.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 685.828L339.959 691.94H344.682L340.861 695.717L342.321 701.829L338.5 698.052L334.679 701.829L336.139 695.717L332.318 691.94H337.041L338.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 685.828L163.959 691.94H168.682L164.861 695.717L166.321 701.829L162.5 698.052L158.679 701.829L160.139 695.717L156.318 691.94H161.041L162.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 685.828L515.959 691.94H520.682L516.861 695.717L518.321 701.829L514.5 698.052L510.679 701.829L512.139 695.717L508.318 691.94H513.041L514.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 685.828L75.9593 691.94H80.6819L76.8613 695.717L78.3206 701.829L74.5 698.052L70.6794 701.829L72.1387 695.717L68.3181 691.94H73.0407L74.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 685.828L427.959 691.94H432.682L428.861 695.717L430.321 701.829L426.5 698.052L422.679 701.829L424.139 695.717L420.318 691.94H425.041L426.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 685.828L251.959 691.94H256.682L252.861 695.717L254.321 701.829L250.5 698.052L246.679 701.829L248.139 695.717L244.318 691.94H249.041L250.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 685.828L603.959 691.94H608.682L604.861 695.717L606.321 701.829L602.5 698.052L598.679 701.829L600.139 695.717L596.318 691.94H601.041L602.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 685.828L31.9593 691.94H36.6819L32.8613 695.717L34.3206 701.829L30.5 698.052L26.6794 701.829L28.1387 695.717L24.3181 691.94H29.0407L30.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 685.828L383.959 691.94H388.682L384.861 695.717L386.321 701.829L382.5 698.052L378.679 701.829L380.139 695.717L376.318 691.94H381.041L382.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 685.828L207.959 691.94H212.682L208.861 695.717L210.321 701.829L206.5 698.052L202.679 701.829L204.139 695.717L200.318 691.94H205.041L206.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 685.828L559.959 691.94H564.682L560.861 695.717L562.321 701.829L558.5 698.052L554.679 701.829L556.139 695.717L552.318 691.94H557.041L558.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 685.828L119.959 691.94H124.682L120.861 695.717L122.321 701.829L118.5 698.052L114.679 701.829L116.139 695.717L112.318 691.94H117.041L118.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 685.828L471.959 691.94H476.682L472.861 695.717L474.321 701.829L470.5 698.052L466.679 701.829L468.139 695.717L464.318 691.94H469.041L470.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 685.828L295.959 691.94H300.682L296.861 695.717L298.321 701.829L294.5 698.052L290.679 701.829L292.139 695.717L288.318 691.94H293.041L294.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 685.828L647.959 691.94H652.682L648.861 695.717L650.321 701.829L646.5 698.052L642.679 701.829L644.139 695.717L640.318 691.94H645.041L646.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 685.828L9.95934 691.94H14.6819L10.8613 695.717L12.3206 701.829L8.5 698.052L4.6794 701.829L6.13874 695.717L2.31813 691.94H7.04066L8.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 685.828L361.959 691.94H366.682L362.861 695.717L364.321 701.829L360.5 698.052L356.679 701.829L358.139 695.717L354.318 691.94H359.041L360.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 685.828L185.959 691.94H190.682L186.861 695.717L188.321 701.829L184.5 698.052L180.679 701.829L182.139 695.717L178.318 691.94H183.041L184.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 685.828L537.959 691.94H542.682L538.861 695.717L540.321 701.829L536.5 698.052L532.679 701.829L534.139 695.717L530.318 691.94H535.041L536.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 685.828L97.9593 691.94H102.682L98.8613 695.717L100.321 701.829L96.5 698.052L92.6794 701.829L94.1387 695.717L90.3181 691.94H95.0407L96.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 685.828L449.959 691.94H454.682L450.861 695.717L452.321 701.829L448.5 698.052L444.679 701.829L446.139 695.717L442.318 691.94H447.041L448.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 685.828L273.959 691.94H278.682L274.861 695.717L276.321 701.829L272.5 698.052L268.679 701.829L270.139 695.717L266.318 691.94H271.041L272.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 685.828L625.959 691.94H630.682L626.861 695.717L628.321 701.829L624.5 698.052L620.679 701.829L622.139 695.717L618.318 691.94H623.041L624.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 685.828L53.9593 691.94H58.6819L54.8613 695.717L56.3206 701.829L52.5 698.052L48.6794 701.829L50.1387 695.717L46.3181 691.94H51.0407L52.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 685.828L405.959 691.94H410.682L406.861 695.717L408.321 701.829L404.5 698.052L400.679 701.829L402.139 695.717L398.318 691.94H403.041L404.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 685.828L229.959 691.94H234.682L230.861 695.717L232.321 701.829L228.5 698.052L224.679 701.829L226.139 695.717L222.318 691.94H227.041L228.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 685.828L581.959 691.94H586.682L582.861 695.717L584.321 701.829L580.5 698.052L576.679 701.829L578.139 695.717L574.318 691.94H579.041L580.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 685.828L141.959 691.94H146.682L142.861 695.717L144.321 701.829L140.5 698.052L136.679 701.829L138.139 695.717L134.318 691.94H139.041L140.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 685.828L493.959 691.94H498.682L494.861 695.717L496.321 701.829L492.5 698.052L488.679 701.829L490.139 695.717L486.318 691.94H491.041L492.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 685.828L317.959 691.94H322.682L318.861 695.717L320.321 701.829L316.5 698.052L312.679 701.829L314.139 695.717L310.318 691.94H315.041L316.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 685.828L669.959 691.94H674.682L670.861 695.717L672.321 701.829L668.5 698.052L664.679 701.829L666.139 695.717L662.318 691.94H667.041L668.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 440.89L339.959 447.001H344.682L340.861 450.779L342.321 456.89L338.5 453.113L334.679 456.89L336.139 450.779L332.318 447.001H337.041L338.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 440.89L163.959 447.001H168.682L164.861 450.779L166.321 456.89L162.5 453.113L158.679 456.89L160.139 450.779L156.318 447.001H161.041L162.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 440.89L515.959 447.001H520.682L516.861 450.779L518.321 456.89L514.5 453.113L510.679 456.89L512.139 450.779L508.318 447.001H513.041L514.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 440.89L75.9593 447.001H80.6819L76.8613 450.779L78.3206 456.89L74.5 453.113L70.6794 456.89L72.1387 450.779L68.3181 447.001H73.0407L74.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 440.89L427.959 447.001H432.682L428.861 450.779L430.321 456.89L426.5 453.113L422.679 456.89L424.139 450.779L420.318 447.001H425.041L426.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 440.89L251.959 447.001H256.682L252.861 450.779L254.321 456.89L250.5 453.113L246.679 456.89L248.139 450.779L244.318 447.001H249.041L250.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 440.89L603.959 447.001H608.682L604.861 450.779L606.321 456.89L602.5 453.113L598.679 456.89L600.139 450.779L596.318 447.001H601.041L602.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 440.89L31.9593 447.001H36.6819L32.8613 450.779L34.3206 456.89L30.5 453.113L26.6794 456.89L28.1387 450.779L24.3181 447.001H29.0407L30.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 440.89L383.959 447.001H388.682L384.861 450.779L386.321 456.89L382.5 453.113L378.679 456.89L380.139 450.779L376.318 447.001H381.041L382.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 440.89L207.959 447.001H212.682L208.861 450.779L210.321 456.89L206.5 453.113L202.679 456.89L204.139 450.779L200.318 447.001H205.041L206.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 440.89L559.959 447.001H564.682L560.861 450.779L562.321 456.89L558.5 453.113L554.679 456.89L556.139 450.779L552.318 447.001H557.041L558.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 440.89L119.959 447.001H124.682L120.861 450.779L122.321 456.89L118.5 453.113L114.679 456.89L116.139 450.779L112.318 447.001H117.041L118.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 440.89L471.959 447.001H476.682L472.861 450.779L474.321 456.89L470.5 453.113L466.679 456.89L468.139 450.779L464.318 447.001H469.041L470.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 440.89L295.959 447.001H300.682L296.861 450.779L298.321 456.89L294.5 453.113L290.679 456.89L292.139 450.779L288.318 447.001H293.041L294.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 440.89L647.959 447.001H652.682L648.861 450.779L650.321 456.89L646.5 453.113L642.679 456.89L644.139 450.779L640.318 447.001H645.041L646.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 440.89L9.95934 447.001H14.6819L10.8613 450.779L12.3206 456.89L8.5 453.113L4.6794 456.89L6.13874 450.779L2.31813 447.001H7.04066L8.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 440.89L361.959 447.001H366.682L362.861 450.779L364.321 456.89L360.5 453.113L356.679 456.89L358.139 450.779L354.318 447.001H359.041L360.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 440.89L185.959 447.001H190.682L186.861 450.779L188.321 456.89L184.5 453.113L180.679 456.89L182.139 450.779L178.318 447.001H183.041L184.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 440.89L537.959 447.001H542.682L538.861 450.779L540.321 456.89L536.5 453.113L532.679 456.89L534.139 450.779L530.318 447.001H535.041L536.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 440.89L97.9593 447.001H102.682L98.8613 450.779L100.321 456.89L96.5 453.113L92.6794 456.89L94.1387 450.779L90.3181 447.001H95.0407L96.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 440.89L449.959 447.001H454.682L450.861 450.779L452.321 456.89L448.5 453.113L444.679 456.89L446.139 450.779L442.318 447.001H447.041L448.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 440.89L273.959 447.001H278.682L274.861 450.779L276.321 456.89L272.5 453.113L268.679 456.89L270.139 450.779L266.318 447.001H271.041L272.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 440.89L625.959 447.001H630.682L626.861 450.779L628.321 456.89L624.5 453.113L620.679 456.89L622.139 450.779L618.318 447.001H623.041L624.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 440.89L53.9593 447.001H58.6819L54.8613 450.779L56.3206 456.89L52.5 453.113L48.6794 456.89L50.1387 450.779L46.3181 447.001H51.0407L52.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 440.89L405.959 447.001H410.682L406.861 450.779L408.321 456.89L404.5 453.113L400.679 456.89L402.139 450.779L398.318 447.001H403.041L404.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 440.89L229.959 447.001H234.682L230.861 450.779L232.321 456.89L228.5 453.113L224.679 456.89L226.139 450.779L222.318 447.001H227.041L228.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 440.89L581.959 447.001H586.682L582.861 450.779L584.321 456.89L580.5 453.113L576.679 456.89L578.139 450.779L574.318 447.001H579.041L580.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 440.89L141.959 447.001H146.682L142.861 450.779L144.321 456.89L140.5 453.113L136.679 456.89L138.139 450.779L134.318 447.001H139.041L140.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 440.89L493.959 447.001H498.682L494.861 450.779L496.321 456.89L492.5 453.113L488.679 456.89L490.139 450.779L486.318 447.001H491.041L492.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 440.89L317.959 447.001H322.682L318.861 450.779L320.321 456.89L316.5 453.113L312.679 456.89L314.139 450.779L310.318 447.001H315.041L316.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 440.89L669.959 447.001H674.682L670.861 450.779L672.321 456.89L668.5 453.113L664.679 456.89L666.139 450.779L662.318 447.001H667.041L668.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 636.841L339.959 642.952H344.682L340.861 646.73L342.321 652.841L338.5 649.064L334.679 652.841L336.139 646.73L332.318 642.952H337.041L338.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 636.841L163.959 642.952H168.682L164.861 646.73L166.321 652.841L162.5 649.064L158.679 652.841L160.139 646.73L156.318 642.952H161.041L162.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 636.841L515.959 642.952H520.682L516.861 646.73L518.321 652.841L514.5 649.064L510.679 652.841L512.139 646.73L508.318 642.952H513.041L514.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 636.841L75.9593 642.952H80.6819L76.8613 646.73L78.3206 652.841L74.5 649.064L70.6794 652.841L72.1387 646.73L68.3181 642.952H73.0407L74.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 636.841L427.959 642.952H432.682L428.861 646.73L430.321 652.841L426.5 649.064L422.679 652.841L424.139 646.73L420.318 642.952H425.041L426.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 636.841L251.959 642.952H256.682L252.861 646.73L254.321 652.841L250.5 649.064L246.679 652.841L248.139 646.73L244.318 642.952H249.041L250.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 636.841L603.959 642.952H608.682L604.861 646.73L606.321 652.841L602.5 649.064L598.679 652.841L600.139 646.73L596.318 642.952H601.041L602.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 636.841L31.9593 642.952H36.6819L32.8613 646.73L34.3206 652.841L30.5 649.064L26.6794 652.841L28.1387 646.73L24.3181 642.952H29.0407L30.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 636.841L383.959 642.952H388.682L384.861 646.73L386.321 652.841L382.5 649.064L378.679 652.841L380.139 646.73L376.318 642.952H381.041L382.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 636.841L207.959 642.952H212.682L208.861 646.73L210.321 652.841L206.5 649.064L202.679 652.841L204.139 646.73L200.318 642.952H205.041L206.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 636.841L559.959 642.952H564.682L560.861 646.73L562.321 652.841L558.5 649.064L554.679 652.841L556.139 646.73L552.318 642.952H557.041L558.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 636.841L119.959 642.952H124.682L120.861 646.73L122.321 652.841L118.5 649.064L114.679 652.841L116.139 646.73L112.318 642.952H117.041L118.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 636.841L471.959 642.952H476.682L472.861 646.73L474.321 652.841L470.5 649.064L466.679 652.841L468.139 646.73L464.318 642.952H469.041L470.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 636.841L295.959 642.952H300.682L296.861 646.73L298.321 652.841L294.5 649.064L290.679 652.841L292.139 646.73L288.318 642.952H293.041L294.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 636.841L647.959 642.952H652.682L648.861 646.73L650.321 652.841L646.5 649.064L642.679 652.841L644.139 646.73L640.318 642.952H645.041L646.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 636.841L9.95934 642.952H14.6819L10.8613 646.73L12.3206 652.841L8.5 649.064L4.6794 652.841L6.13874 646.73L2.31813 642.952H7.04066L8.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 636.841L361.959 642.952H366.682L362.861 646.73L364.321 652.841L360.5 649.064L356.679 652.841L358.139 646.73L354.318 642.952H359.041L360.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 636.841L185.959 642.952H190.682L186.861 646.73L188.321 652.841L184.5 649.064L180.679 652.841L182.139 646.73L178.318 642.952H183.041L184.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 636.841L537.959 642.952H542.682L538.861 646.73L540.321 652.841L536.5 649.064L532.679 652.841L534.139 646.73L530.318 642.952H535.041L536.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 636.841L97.9593 642.952H102.682L98.8613 646.73L100.321 652.841L96.5 649.064L92.6794 652.841L94.1387 646.73L90.3181 642.952H95.0407L96.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 636.841L449.959 642.952H454.682L450.861 646.73L452.321 652.841L448.5 649.064L444.679 652.841L446.139 646.73L442.318 642.952H447.041L448.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 636.841L273.959 642.952H278.682L274.861 646.73L276.321 652.841L272.5 649.064L268.679 652.841L270.139 646.73L266.318 642.952H271.041L272.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 636.841L625.959 642.952H630.682L626.861 646.73L628.321 652.841L624.5 649.064L620.679 652.841L622.139 646.73L618.318 642.952H623.041L624.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 636.841L53.9593 642.952H58.6819L54.8613 646.73L56.3206 652.841L52.5 649.064L48.6794 652.841L50.1387 646.73L46.3181 642.952H51.0407L52.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 636.841L405.959 642.952H410.682L406.861 646.73L408.321 652.841L404.5 649.064L400.679 652.841L402.139 646.73L398.318 642.952H403.041L404.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 636.841L229.959 642.952H234.682L230.861 646.73L232.321 652.841L228.5 649.064L224.679 652.841L226.139 646.73L222.318 642.952H227.041L228.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 636.841L581.959 642.952H586.682L582.861 646.73L584.321 652.841L580.5 649.064L576.679 652.841L578.139 646.73L574.318 642.952H579.041L580.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 636.841L141.959 642.952H146.682L142.861 646.73L144.321 652.841L140.5 649.064L136.679 652.841L138.139 646.73L134.318 642.952H139.041L140.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 636.841L493.959 642.952H498.682L494.861 646.73L496.321 652.841L492.5 649.064L488.679 652.841L490.139 646.73L486.318 642.952H491.041L492.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 636.841L317.959 642.952H322.682L318.861 646.73L320.321 652.841L316.5 649.064L312.679 652.841L314.139 646.73L310.318 642.952H315.041L316.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 636.841L669.959 642.952H674.682L670.861 646.73L672.321 652.841L668.5 649.064L664.679 652.841L666.139 646.73L662.318 642.952H667.041L668.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 538.865L339.959 544.977H344.682L340.861 548.754L342.321 554.866L338.5 551.088L334.679 554.866L336.139 548.754L332.318 544.977H337.041L338.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 538.865L163.959 544.977H168.682L164.861 548.754L166.321 554.866L162.5 551.088L158.679 554.866L160.139 548.754L156.318 544.977H161.041L162.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 538.865L515.959 544.977H520.682L516.861 548.754L518.321 554.866L514.5 551.088L510.679 554.866L512.139 548.754L508.318 544.977H513.041L514.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 538.865L75.9593 544.977H80.6819L76.8613 548.754L78.3206 554.866L74.5 551.088L70.6794 554.866L72.1387 548.754L68.3181 544.977H73.0407L74.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 538.865L427.959 544.977H432.682L428.861 548.754L430.321 554.866L426.5 551.088L422.679 554.866L424.139 548.754L420.318 544.977H425.041L426.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 538.865L251.959 544.977H256.682L252.861 548.754L254.321 554.866L250.5 551.088L246.679 554.866L248.139 548.754L244.318 544.977H249.041L250.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 538.865L603.959 544.977H608.682L604.861 548.754L606.321 554.866L602.5 551.088L598.679 554.866L600.139 548.754L596.318 544.977H601.041L602.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 538.865L31.9593 544.977H36.6819L32.8613 548.754L34.3206 554.866L30.5 551.088L26.6794 554.866L28.1387 548.754L24.3181 544.977H29.0407L30.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 538.865L383.959 544.977H388.682L384.861 548.754L386.321 554.866L382.5 551.088L378.679 554.866L380.139 548.754L376.318 544.977H381.041L382.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 538.865L207.959 544.977H212.682L208.861 548.754L210.321 554.866L206.5 551.088L202.679 554.866L204.139 548.754L200.318 544.977H205.041L206.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 538.865L559.959 544.977H564.682L560.861 548.754L562.321 554.866L558.5 551.088L554.679 554.866L556.139 548.754L552.318 544.977H557.041L558.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 538.865L119.959 544.977H124.682L120.861 548.754L122.321 554.866L118.5 551.088L114.679 554.866L116.139 548.754L112.318 544.977H117.041L118.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 538.865L471.959 544.977H476.682L472.861 548.754L474.321 554.866L470.5 551.088L466.679 554.866L468.139 548.754L464.318 544.977H469.041L470.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 538.865L295.959 544.977H300.682L296.861 548.754L298.321 554.866L294.5 551.088L290.679 554.866L292.139 548.754L288.318 544.977H293.041L294.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 538.865L647.959 544.977H652.682L648.861 548.754L650.321 554.866L646.5 551.088L642.679 554.866L644.139 548.754L640.318 544.977H645.041L646.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 538.865L9.95934 544.977H14.6819L10.8613 548.754L12.3206 554.866L8.5 551.088L4.6794 554.866L6.13874 548.754L2.31813 544.977H7.04066L8.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 538.865L361.959 544.977H366.682L362.861 548.754L364.321 554.866L360.5 551.088L356.679 554.866L358.139 548.754L354.318 544.977H359.041L360.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 538.865L185.959 544.977H190.682L186.861 548.754L188.321 554.866L184.5 551.088L180.679 554.866L182.139 548.754L178.318 544.977H183.041L184.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 538.865L537.959 544.977H542.682L538.861 548.754L540.321 554.866L536.5 551.088L532.679 554.866L534.139 548.754L530.318 544.977H535.041L536.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 538.865L97.9593 544.977H102.682L98.8613 548.754L100.321 554.866L96.5 551.088L92.6794 554.866L94.1387 548.754L90.3181 544.977H95.0407L96.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 538.865L449.959 544.977H454.682L450.861 548.754L452.321 554.866L448.5 551.088L444.679 554.866L446.139 548.754L442.318 544.977H447.041L448.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 538.865L273.959 544.977H278.682L274.861 548.754L276.321 554.866L272.5 551.088L268.679 554.866L270.139 548.754L266.318 544.977H271.041L272.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 538.865L625.959 544.977H630.682L626.861 548.754L628.321 554.866L624.5 551.088L620.679 554.866L622.139 548.754L618.318 544.977H623.041L624.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 538.865L53.9593 544.977H58.6819L54.8613 548.754L56.3206 554.866L52.5 551.088L48.6794 554.866L50.1387 548.754L46.3181 544.977H51.0407L52.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 538.865L405.959 544.977H410.682L406.861 548.754L408.321 554.866L404.5 551.088L400.679 554.866L402.139 548.754L398.318 544.977H403.041L404.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 538.865L229.959 544.977H234.682L230.861 548.754L232.321 554.866L228.5 551.088L224.679 554.866L226.139 548.754L222.318 544.977H227.041L228.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 538.865L581.959 544.977H586.682L582.861 548.754L584.321 554.866L580.5 551.088L576.679 554.866L578.139 548.754L574.318 544.977H579.041L580.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 538.865L141.959 544.977H146.682L142.861 548.754L144.321 554.866L140.5 551.088L136.679 554.866L138.139 548.754L134.318 544.977H139.041L140.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 538.865L493.959 544.977H498.682L494.861 548.754L496.321 554.866L492.5 551.088L488.679 554.866L490.139 548.754L486.318 544.977H491.041L492.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 538.865L317.959 544.977H322.682L318.861 548.754L320.321 554.866L316.5 551.088L312.679 554.866L314.139 548.754L310.318 544.977H315.041L316.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 538.865L669.959 544.977H674.682L670.861 548.754L672.321 554.866L668.5 551.088L664.679 554.866L666.139 548.754L662.318 544.977H667.041L668.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 734.816L339.959 740.928H344.682L340.861 744.705L342.321 750.817L338.5 747.04L334.679 750.817L336.139 744.705L332.318 740.928H337.041L338.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 734.816L163.959 740.928H168.682L164.861 744.705L166.321 750.817L162.5 747.04L158.679 750.817L160.139 744.705L156.318 740.928H161.041L162.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 734.816L515.959 740.928H520.682L516.861 744.705L518.321 750.817L514.5 747.04L510.679 750.817L512.139 744.705L508.318 740.928H513.041L514.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 734.816L75.9593 740.928H80.6819L76.8613 744.705L78.3206 750.817L74.5 747.04L70.6794 750.817L72.1387 744.705L68.3181 740.928H73.0407L74.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 734.816L427.959 740.928H432.682L428.861 744.705L430.321 750.817L426.5 747.04L422.679 750.817L424.139 744.705L420.318 740.928H425.041L426.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 734.816L251.959 740.928H256.682L252.861 744.705L254.321 750.817L250.5 747.04L246.679 750.817L248.139 744.705L244.318 740.928H249.041L250.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 734.816L603.959 740.928H608.682L604.861 744.705L606.321 750.817L602.5 747.04L598.679 750.817L600.139 744.705L596.318 740.928H601.041L602.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 734.816L31.9593 740.928H36.6819L32.8613 744.705L34.3206 750.817L30.5 747.04L26.6794 750.817L28.1387 744.705L24.3181 740.928H29.0407L30.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 734.816L383.959 740.928H388.682L384.861 744.705L386.321 750.817L382.5 747.04L378.679 750.817L380.139 744.705L376.318 740.928H381.041L382.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 734.816L207.959 740.928H212.682L208.861 744.705L210.321 750.817L206.5 747.04L202.679 750.817L204.139 744.705L200.318 740.928H205.041L206.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 734.816L559.959 740.928H564.682L560.861 744.705L562.321 750.817L558.5 747.04L554.679 750.817L556.139 744.705L552.318 740.928H557.041L558.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 734.816L119.959 740.928H124.682L120.861 744.705L122.321 750.817L118.5 747.04L114.679 750.817L116.139 744.705L112.318 740.928H117.041L118.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 734.816L471.959 740.928H476.682L472.861 744.705L474.321 750.817L470.5 747.04L466.679 750.817L468.139 744.705L464.318 740.928H469.041L470.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 734.816L295.959 740.928H300.682L296.861 744.705L298.321 750.817L294.5 747.04L290.679 750.817L292.139 744.705L288.318 740.928H293.041L294.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 734.816L647.959 740.928H652.682L648.861 744.705L650.321 750.817L646.5 747.04L642.679 750.817L644.139 744.705L640.318 740.928H645.041L646.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 734.816L9.95934 740.928H14.6819L10.8613 744.705L12.3206 750.817L8.5 747.04L4.6794 750.817L6.13874 744.705L2.31813 740.928H7.04066L8.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 734.816L361.959 740.928H366.682L362.861 744.705L364.321 750.817L360.5 747.04L356.679 750.817L358.139 744.705L354.318 740.928H359.041L360.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 734.816L185.959 740.928H190.682L186.861 744.705L188.321 750.817L184.5 747.04L180.679 750.817L182.139 744.705L178.318 740.928H183.041L184.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 734.816L537.959 740.928H542.682L538.861 744.705L540.321 750.817L536.5 747.04L532.679 750.817L534.139 744.705L530.318 740.928H535.041L536.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 734.816L97.9593 740.928H102.682L98.8613 744.705L100.321 750.817L96.5 747.04L92.6794 750.817L94.1387 744.705L90.3181 740.928H95.0407L96.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 734.816L449.959 740.928H454.682L450.861 744.705L452.321 750.817L448.5 747.04L444.679 750.817L446.139 744.705L442.318 740.928H447.041L448.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 734.816L273.959 740.928H278.682L274.861 744.705L276.321 750.817L272.5 747.04L268.679 750.817L270.139 744.705L266.318 740.928H271.041L272.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 734.816L625.959 740.928H630.682L626.861 744.705L628.321 750.817L624.5 747.04L620.679 750.817L622.139 744.705L618.318 740.928H623.041L624.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 734.816L53.9593 740.928H58.6819L54.8613 744.705L56.3206 750.817L52.5 747.04L48.6794 750.817L50.1387 744.705L46.3181 740.928H51.0407L52.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 734.816L405.959 740.928H410.682L406.861 744.705L408.321 750.817L404.5 747.04L400.679 750.817L402.139 744.705L398.318 740.928H403.041L404.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 734.816L229.959 740.928H234.682L230.861 744.705L232.321 750.817L228.5 747.04L224.679 750.817L226.139 744.705L222.318 740.928H227.041L228.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 734.816L581.959 740.928H586.682L582.861 744.705L584.321 750.817L580.5 747.04L576.679 750.817L578.139 744.705L574.318 740.928H579.041L580.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 734.816L141.959 740.928H146.682L142.861 744.705L144.321 750.817L140.5 747.04L136.679 750.817L138.139 744.705L134.318 740.928H139.041L140.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 734.816L493.959 740.928H498.682L494.861 744.705L496.321 750.817L492.5 747.04L488.679 750.817L490.139 744.705L486.318 740.928H491.041L492.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 734.816L317.959 740.928H322.682L318.861 744.705L320.321 750.817L316.5 747.04L312.679 750.817L314.139 744.705L310.318 740.928H315.041L316.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 734.816L669.959 740.928H674.682L670.861 744.705L672.321 750.817L668.5 747.04L664.679 750.817L666.139 744.705L662.318 740.928H667.041L668.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 416.396L339.959 422.508H344.682L340.861 426.285L342.321 432.397L338.5 428.619L334.679 432.397L336.139 426.285L332.318 422.508H337.041L338.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 416.396L163.959 422.508H168.682L164.861 426.285L166.321 432.397L162.5 428.619L158.679 432.397L160.139 426.285L156.318 422.508H161.041L162.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 416.396L515.959 422.508H520.682L516.861 426.285L518.321 432.397L514.5 428.619L510.679 432.397L512.139 426.285L508.318 422.508H513.041L514.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 416.396L75.9593 422.508H80.6819L76.8613 426.285L78.3206 432.397L74.5 428.619L70.6794 432.397L72.1387 426.285L68.3181 422.508H73.0407L74.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 416.396L427.959 422.508H432.682L428.861 426.285L430.321 432.397L426.5 428.619L422.679 432.397L424.139 426.285L420.318 422.508H425.041L426.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 416.396L251.959 422.508H256.682L252.861 426.285L254.321 432.397L250.5 428.619L246.679 432.397L248.139 426.285L244.318 422.508H249.041L250.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 416.396L603.959 422.508H608.682L604.861 426.285L606.321 432.397L602.5 428.619L598.679 432.397L600.139 426.285L596.318 422.508H601.041L602.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 416.396L31.9593 422.508H36.6819L32.8613 426.285L34.3206 432.397L30.5 428.619L26.6794 432.397L28.1387 426.285L24.3181 422.508H29.0407L30.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 416.396L383.959 422.508H388.682L384.861 426.285L386.321 432.397L382.5 428.619L378.679 432.397L380.139 426.285L376.318 422.508H381.041L382.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 416.396L207.959 422.508H212.682L208.861 426.285L210.321 432.397L206.5 428.619L202.679 432.397L204.139 426.285L200.318 422.508H205.041L206.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 416.396L559.959 422.508H564.682L560.861 426.285L562.321 432.397L558.5 428.619L554.679 432.397L556.139 426.285L552.318 422.508H557.041L558.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 416.396L119.959 422.508H124.682L120.861 426.285L122.321 432.397L118.5 428.619L114.679 432.397L116.139 426.285L112.318 422.508H117.041L118.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 416.396L471.959 422.508H476.682L472.861 426.285L474.321 432.397L470.5 428.619L466.679 432.397L468.139 426.285L464.318 422.508H469.041L470.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 416.396L295.959 422.508H300.682L296.861 426.285L298.321 432.397L294.5 428.619L290.679 432.397L292.139 426.285L288.318 422.508H293.041L294.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 416.396L647.959 422.508H652.682L648.861 426.285L650.321 432.397L646.5 428.619L642.679 432.397L644.139 426.285L640.318 422.508H645.041L646.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 416.396L9.95934 422.508H14.6819L10.8613 426.285L12.3206 432.397L8.5 428.619L4.6794 432.397L6.13874 426.285L2.31813 422.508H7.04066L8.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 416.396L361.959 422.508H366.682L362.861 426.285L364.321 432.397L360.5 428.619L356.679 432.397L358.139 426.285L354.318 422.508H359.041L360.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 416.396L185.959 422.508H190.682L186.861 426.285L188.321 432.397L184.5 428.619L180.679 432.397L182.139 426.285L178.318 422.508H183.041L184.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 416.396L537.959 422.508H542.682L538.861 426.285L540.321 432.397L536.5 428.619L532.679 432.397L534.139 426.285L530.318 422.508H535.041L536.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 416.396L97.9593 422.508H102.682L98.8613 426.285L100.321 432.397L96.5 428.619L92.6794 432.397L94.1387 426.285L90.3181 422.508H95.0407L96.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 416.396L449.959 422.508H454.682L450.861 426.285L452.321 432.397L448.5 428.619L444.679 432.397L446.139 426.285L442.318 422.508H447.041L448.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 416.396L273.959 422.508H278.682L274.861 426.285L276.321 432.397L272.5 428.619L268.679 432.397L270.139 426.285L266.318 422.508H271.041L272.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 416.396L625.959 422.508H630.682L626.861 426.285L628.321 432.397L624.5 428.619L620.679 432.397L622.139 426.285L618.318 422.508H623.041L624.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 416.396L53.9593 422.508H58.6819L54.8613 426.285L56.3206 432.397L52.5 428.619L48.6794 432.397L50.1387 426.285L46.3181 422.508H51.0407L52.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 416.396L405.959 422.508H410.682L406.861 426.285L408.321 432.397L404.5 428.619L400.679 432.397L402.139 426.285L398.318 422.508H403.041L404.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 416.396L229.959 422.508H234.682L230.861 426.285L232.321 432.397L228.5 428.619L224.679 432.397L226.139 426.285L222.318 422.508H227.041L228.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 416.396L581.959 422.508H586.682L582.861 426.285L584.321 432.397L580.5 428.619L576.679 432.397L578.139 426.285L574.318 422.508H579.041L580.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 416.396L141.959 422.508H146.682L142.861 426.285L144.321 432.397L140.5 428.619L136.679 432.397L138.139 426.285L134.318 422.508H139.041L140.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 416.396L493.959 422.508H498.682L494.861 426.285L496.321 432.397L492.5 428.619L488.679 432.397L490.139 426.285L486.318 422.508H491.041L492.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 416.396L317.959 422.508H322.682L318.861 426.285L320.321 432.397L316.5 428.619L312.679 432.397L314.139 426.285L310.318 422.508H315.041L316.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 416.396L669.959 422.508H674.682L670.861 426.285L672.321 432.397L668.5 428.619L664.679 432.397L666.139 426.285L662.318 422.508H667.041L668.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 612.347L339.959 618.459H344.682L340.861 622.236L342.321 628.348L338.5 624.57L334.679 628.348L336.139 622.236L332.318 618.459H337.041L338.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 612.347L163.959 618.459H168.682L164.861 622.236L166.321 628.348L162.5 624.57L158.679 628.348L160.139 622.236L156.318 618.459H161.041L162.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 612.347L515.959 618.459H520.682L516.861 622.236L518.321 628.348L514.5 624.57L510.679 628.348L512.139 622.236L508.318 618.459H513.041L514.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 612.347L75.9593 618.459H80.6819L76.8613 622.236L78.3206 628.348L74.5 624.57L70.6794 628.348L72.1387 622.236L68.3181 618.459H73.0407L74.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 612.347L427.959 618.459H432.682L428.861 622.236L430.321 628.348L426.5 624.57L422.679 628.348L424.139 622.236L420.318 618.459H425.041L426.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 612.347L251.959 618.459H256.682L252.861 622.236L254.321 628.348L250.5 624.57L246.679 628.348L248.139 622.236L244.318 618.459H249.041L250.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 612.347L603.959 618.459H608.682L604.861 622.236L606.321 628.348L602.5 624.57L598.679 628.348L600.139 622.236L596.318 618.459H601.041L602.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 612.347L31.9593 618.459H36.6819L32.8613 622.236L34.3206 628.348L30.5 624.57L26.6794 628.348L28.1387 622.236L24.3181 618.459H29.0407L30.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 612.347L383.959 618.459H388.682L384.861 622.236L386.321 628.348L382.5 624.57L378.679 628.348L380.139 622.236L376.318 618.459H381.041L382.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 612.347L207.959 618.459H212.682L208.861 622.236L210.321 628.348L206.5 624.57L202.679 628.348L204.139 622.236L200.318 618.459H205.041L206.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 612.347L559.959 618.459H564.682L560.861 622.236L562.321 628.348L558.5 624.57L554.679 628.348L556.139 622.236L552.318 618.459H557.041L558.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 612.347L119.959 618.459H124.682L120.861 622.236L122.321 628.348L118.5 624.57L114.679 628.348L116.139 622.236L112.318 618.459H117.041L118.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 612.347L471.959 618.459H476.682L472.861 622.236L474.321 628.348L470.5 624.57L466.679 628.348L468.139 622.236L464.318 618.459H469.041L470.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 612.347L295.959 618.459H300.682L296.861 622.236L298.321 628.348L294.5 624.57L290.679 628.348L292.139 622.236L288.318 618.459H293.041L294.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 612.347L647.959 618.459H652.682L648.861 622.236L650.321 628.348L646.5 624.57L642.679 628.348L644.139 622.236L640.318 618.459H645.041L646.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 612.347L9.95934 618.459H14.6819L10.8613 622.236L12.3206 628.348L8.5 624.57L4.6794 628.348L6.13874 622.236L2.31813 618.459H7.04066L8.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 612.347L361.959 618.459H366.682L362.861 622.236L364.321 628.348L360.5 624.57L356.679 628.348L358.139 622.236L354.318 618.459H359.041L360.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 612.347L185.959 618.459H190.682L186.861 622.236L188.321 628.348L184.5 624.57L180.679 628.348L182.139 622.236L178.318 618.459H183.041L184.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 612.347L537.959 618.459H542.682L538.861 622.236L540.321 628.348L536.5 624.57L532.679 628.348L534.139 622.236L530.318 618.459H535.041L536.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 612.347L97.9593 618.459H102.682L98.8613 622.236L100.321 628.348L96.5 624.57L92.6794 628.348L94.1387 622.236L90.3181 618.459H95.0407L96.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 612.347L449.959 618.459H454.682L450.861 622.236L452.321 628.348L448.5 624.57L444.679 628.348L446.139 622.236L442.318 618.459H447.041L448.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 612.347L273.959 618.459H278.682L274.861 622.236L276.321 628.348L272.5 624.57L268.679 628.348L270.139 622.236L266.318 618.459H271.041L272.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 612.347L625.959 618.459H630.682L626.861 622.236L628.321 628.348L624.5 624.57L620.679 628.348L622.139 622.236L618.318 618.459H623.041L624.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 612.347L53.9593 618.459H58.6819L54.8613 622.236L56.3206 628.348L52.5 624.57L48.6794 628.348L50.1387 622.236L46.3181 618.459H51.0407L52.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 612.347L405.959 618.459H410.682L406.861 622.236L408.321 628.348L404.5 624.57L400.679 628.348L402.139 622.236L398.318 618.459H403.041L404.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 612.347L229.959 618.459H234.682L230.861 622.236L232.321 628.348L228.5 624.57L224.679 628.348L226.139 622.236L222.318 618.459H227.041L228.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 612.347L581.959 618.459H586.682L582.861 622.236L584.321 628.348L580.5 624.57L576.679 628.348L578.139 622.236L574.318 618.459H579.041L580.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 612.347L141.959 618.459H146.682L142.861 622.236L144.321 628.348L140.5 624.57L136.679 628.348L138.139 622.236L134.318 618.459H139.041L140.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 612.347L493.959 618.459H498.682L494.861 622.236L496.321 628.348L492.5 624.57L488.679 628.348L490.139 622.236L486.318 618.459H491.041L492.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 612.347L317.959 618.459H322.682L318.861 622.236L320.321 628.348L316.5 624.57L312.679 628.348L314.139 622.236L310.318 618.459H315.041L316.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 612.347L669.959 618.459H674.682L670.861 622.236L672.321 628.348L668.5 624.57L664.679 628.348L666.139 622.236L662.318 618.459H667.041L668.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 514.371L339.959 520.483H344.682L340.861 524.26L342.321 530.372L338.5 526.595L334.679 530.372L336.139 524.26L332.318 520.483H337.041L338.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 514.371L163.959 520.483H168.682L164.861 524.26L166.321 530.372L162.5 526.595L158.679 530.372L160.139 524.26L156.318 520.483H161.041L162.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 514.371L515.959 520.483H520.682L516.861 524.26L518.321 530.372L514.5 526.595L510.679 530.372L512.139 524.26L508.318 520.483H513.041L514.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 514.371L75.9593 520.483H80.6819L76.8613 524.26L78.3206 530.372L74.5 526.595L70.6794 530.372L72.1387 524.26L68.3181 520.483H73.0407L74.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 514.371L427.959 520.483H432.682L428.861 524.26L430.321 530.372L426.5 526.595L422.679 530.372L424.139 524.26L420.318 520.483H425.041L426.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 514.371L251.959 520.483H256.682L252.861 524.26L254.321 530.372L250.5 526.595L246.679 530.372L248.139 524.26L244.318 520.483H249.041L250.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 514.371L603.959 520.483H608.682L604.861 524.26L606.321 530.372L602.5 526.595L598.679 530.372L600.139 524.26L596.318 520.483H601.041L602.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 514.371L31.9593 520.483H36.6819L32.8613 524.26L34.3206 530.372L30.5 526.595L26.6794 530.372L28.1387 524.26L24.3181 520.483H29.0407L30.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 514.371L383.959 520.483H388.682L384.861 524.26L386.321 530.372L382.5 526.595L378.679 530.372L380.139 524.26L376.318 520.483H381.041L382.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 514.371L207.959 520.483H212.682L208.861 524.26L210.321 530.372L206.5 526.595L202.679 530.372L204.139 524.26L200.318 520.483H205.041L206.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 514.371L559.959 520.483H564.682L560.861 524.26L562.321 530.372L558.5 526.595L554.679 530.372L556.139 524.26L552.318 520.483H557.041L558.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 514.371L119.959 520.483H124.682L120.861 524.26L122.321 530.372L118.5 526.595L114.679 530.372L116.139 524.26L112.318 520.483H117.041L118.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 514.371L471.959 520.483H476.682L472.861 524.26L474.321 530.372L470.5 526.595L466.679 530.372L468.139 524.26L464.318 520.483H469.041L470.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 514.371L295.959 520.483H300.682L296.861 524.26L298.321 530.372L294.5 526.595L290.679 530.372L292.139 524.26L288.318 520.483H293.041L294.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 514.371L647.959 520.483H652.682L648.861 524.26L650.321 530.372L646.5 526.595L642.679 530.372L644.139 524.26L640.318 520.483H645.041L646.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 514.371L9.95934 520.483H14.6819L10.8613 524.26L12.3206 530.372L8.5 526.595L4.6794 530.372L6.13874 524.26L2.31813 520.483H7.04066L8.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 514.371L361.959 520.483H366.682L362.861 524.26L364.321 530.372L360.5 526.595L356.679 530.372L358.139 524.26L354.318 520.483H359.041L360.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 514.371L185.959 520.483H190.682L186.861 524.26L188.321 530.372L184.5 526.595L180.679 530.372L182.139 524.26L178.318 520.483H183.041L184.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 514.371L537.959 520.483H542.682L538.861 524.26L540.321 530.372L536.5 526.595L532.679 530.372L534.139 524.26L530.318 520.483H535.041L536.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 514.371L97.9593 520.483H102.682L98.8613 524.26L100.321 530.372L96.5 526.595L92.6794 530.372L94.1387 524.26L90.3181 520.483H95.0407L96.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 514.371L449.959 520.483H454.682L450.861 524.26L452.321 530.372L448.5 526.595L444.679 530.372L446.139 524.26L442.318 520.483H447.041L448.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 514.371L273.959 520.483H278.682L274.861 524.26L276.321 530.372L272.5 526.595L268.679 530.372L270.139 524.26L266.318 520.483H271.041L272.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 514.371L625.959 520.483H630.682L626.861 524.26L628.321 530.372L624.5 526.595L620.679 530.372L622.139 524.26L618.318 520.483H623.041L624.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 514.371L53.9593 520.483H58.6819L54.8613 524.26L56.3206 530.372L52.5 526.595L48.6794 530.372L50.1387 524.26L46.3181 520.483H51.0407L52.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 514.371L405.959 520.483H410.682L406.861 524.26L408.321 530.372L404.5 526.595L400.679 530.372L402.139 524.26L398.318 520.483H403.041L404.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 514.371L229.959 520.483H234.682L230.861 524.26L232.321 530.372L228.5 526.595L224.679 530.372L226.139 524.26L222.318 520.483H227.041L228.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 514.371L581.959 520.483H586.682L582.861 524.26L584.321 530.372L580.5 526.595L576.679 530.372L578.139 524.26L574.318 520.483H579.041L580.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 514.371L141.959 520.483H146.682L142.861 524.26L144.321 530.372L140.5 526.595L136.679 530.372L138.139 524.26L134.318 520.483H139.041L140.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 514.371L493.959 520.483H498.682L494.861 524.26L496.321 530.372L492.5 526.595L488.679 530.372L490.139 524.26L486.318 520.483H491.041L492.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 514.371L317.959 520.483H322.682L318.861 524.26L320.321 530.372L316.5 526.595L312.679 530.372L314.139 524.26L310.318 520.483H315.041L316.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 514.371L669.959 520.483H674.682L670.861 524.26L672.321 530.372L668.5 526.595L664.679 530.372L666.139 524.26L662.318 520.483H667.041L668.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 710.322L339.959 716.434H344.682L340.861 720.211L342.321 726.323L338.5 722.546L334.679 726.323L336.139 720.211L332.318 716.434H337.041L338.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 710.322L163.959 716.434H168.682L164.861 720.211L166.321 726.323L162.5 722.546L158.679 726.323L160.139 720.211L156.318 716.434H161.041L162.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 710.322L515.959 716.434H520.682L516.861 720.211L518.321 726.323L514.5 722.546L510.679 726.323L512.139 720.211L508.318 716.434H513.041L514.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 710.322L75.9593 716.434H80.6819L76.8613 720.211L78.3206 726.323L74.5 722.546L70.6794 726.323L72.1387 720.211L68.3181 716.434H73.0407L74.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 710.322L427.959 716.434H432.682L428.861 720.211L430.321 726.323L426.5 722.546L422.679 726.323L424.139 720.211L420.318 716.434H425.041L426.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 710.322L251.959 716.434H256.682L252.861 720.211L254.321 726.323L250.5 722.546L246.679 726.323L248.139 720.211L244.318 716.434H249.041L250.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 710.322L603.959 716.434H608.682L604.861 720.211L606.321 726.323L602.5 722.546L598.679 726.323L600.139 720.211L596.318 716.434H601.041L602.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 710.322L31.9593 716.434H36.6819L32.8613 720.211L34.3206 726.323L30.5 722.546L26.6794 726.323L28.1387 720.211L24.3181 716.434H29.0407L30.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 710.322L383.959 716.434H388.682L384.861 720.211L386.321 726.323L382.5 722.546L378.679 726.323L380.139 720.211L376.318 716.434H381.041L382.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 710.322L207.959 716.434H212.682L208.861 720.211L210.321 726.323L206.5 722.546L202.679 726.323L204.139 720.211L200.318 716.434H205.041L206.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 710.322L559.959 716.434H564.682L560.861 720.211L562.321 726.323L558.5 722.546L554.679 726.323L556.139 720.211L552.318 716.434H557.041L558.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 710.322L119.959 716.434H124.682L120.861 720.211L122.321 726.323L118.5 722.546L114.679 726.323L116.139 720.211L112.318 716.434H117.041L118.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 710.322L471.959 716.434H476.682L472.861 720.211L474.321 726.323L470.5 722.546L466.679 726.323L468.139 720.211L464.318 716.434H469.041L470.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 710.322L295.959 716.434H300.682L296.861 720.211L298.321 726.323L294.5 722.546L290.679 726.323L292.139 720.211L288.318 716.434H293.041L294.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 710.322L647.959 716.434H652.682L648.861 720.211L650.321 726.323L646.5 722.546L642.679 726.323L644.139 720.211L640.318 716.434H645.041L646.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 710.322L9.95934 716.434H14.6819L10.8613 720.211L12.3206 726.323L8.5 722.546L4.6794 726.323L6.13874 720.211L2.31813 716.434H7.04066L8.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 710.322L361.959 716.434H366.682L362.861 720.211L364.321 726.323L360.5 722.546L356.679 726.323L358.139 720.211L354.318 716.434H359.041L360.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 710.322L185.959 716.434H190.682L186.861 720.211L188.321 726.323L184.5 722.546L180.679 726.323L182.139 720.211L178.318 716.434H183.041L184.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 710.322L537.959 716.434H542.682L538.861 720.211L540.321 726.323L536.5 722.546L532.679 726.323L534.139 720.211L530.318 716.434H535.041L536.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 710.322L97.9593 716.434H102.682L98.8613 720.211L100.321 726.323L96.5 722.546L92.6794 726.323L94.1387 720.211L90.3181 716.434H95.0407L96.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 710.322L449.959 716.434H454.682L450.861 720.211L452.321 726.323L448.5 722.546L444.679 726.323L446.139 720.211L442.318 716.434H447.041L448.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 710.322L273.959 716.434H278.682L274.861 720.211L276.321 726.323L272.5 722.546L268.679 726.323L270.139 720.211L266.318 716.434H271.041L272.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 710.322L625.959 716.434H630.682L626.861 720.211L628.321 726.323L624.5 722.546L620.679 726.323L622.139 720.211L618.318 716.434H623.041L624.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 710.322L53.9593 716.434H58.6819L54.8613 720.211L56.3206 726.323L52.5 722.546L48.6794 726.323L50.1387 720.211L46.3181 716.434H51.0407L52.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 710.322L405.959 716.434H410.682L406.861 720.211L408.321 726.323L404.5 722.546L400.679 726.323L402.139 720.211L398.318 716.434H403.041L404.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 710.322L229.959 716.434H234.682L230.861 720.211L232.321 726.323L228.5 722.546L224.679 726.323L226.139 720.211L222.318 716.434H227.041L228.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 710.322L581.959 716.434H586.682L582.861 720.211L584.321 726.323L580.5 722.546L576.679 726.323L578.139 720.211L574.318 716.434H579.041L580.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 710.322L141.959 716.434H146.682L142.861 720.211L144.321 726.323L140.5 722.546L136.679 726.323L138.139 720.211L134.318 716.434H139.041L140.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 710.322L493.959 716.434H498.682L494.861 720.211L496.321 726.323L492.5 722.546L488.679 726.323L490.139 720.211L486.318 716.434H491.041L492.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 710.322L317.959 716.434H322.682L318.861 720.211L320.321 726.323L316.5 722.546L312.679 726.323L314.139 720.211L310.318 716.434H315.041L316.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 710.322L669.959 716.434H674.682L670.861 720.211L672.321 726.323L668.5 722.546L664.679 726.323L666.139 720.211L662.318 716.434H667.041L668.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 465.384L339.959 471.495H344.682L340.861 475.273L342.321 481.384L338.5 477.607L334.679 481.384L336.139 475.273L332.318 471.495H337.041L338.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 465.384L163.959 471.495H168.682L164.861 475.273L166.321 481.384L162.5 477.607L158.679 481.384L160.139 475.273L156.318 471.495H161.041L162.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 465.384L515.959 471.495H520.682L516.861 475.273L518.321 481.384L514.5 477.607L510.679 481.384L512.139 475.273L508.318 471.495H513.041L514.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 465.384L75.9593 471.495H80.6819L76.8613 475.273L78.3206 481.384L74.5 477.607L70.6794 481.384L72.1387 475.273L68.3181 471.495H73.0407L74.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 465.384L427.959 471.495H432.682L428.861 475.273L430.321 481.384L426.5 477.607L422.679 481.384L424.139 475.273L420.318 471.495H425.041L426.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 465.384L251.959 471.495H256.682L252.861 475.273L254.321 481.384L250.5 477.607L246.679 481.384L248.139 475.273L244.318 471.495H249.041L250.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 465.384L603.959 471.495H608.682L604.861 475.273L606.321 481.384L602.5 477.607L598.679 481.384L600.139 475.273L596.318 471.495H601.041L602.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 465.384L31.9593 471.495H36.6819L32.8613 475.273L34.3206 481.384L30.5 477.607L26.6794 481.384L28.1387 475.273L24.3181 471.495H29.0407L30.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 465.384L383.959 471.495H388.682L384.861 475.273L386.321 481.384L382.5 477.607L378.679 481.384L380.139 475.273L376.318 471.495H381.041L382.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 465.384L207.959 471.495H212.682L208.861 475.273L210.321 481.384L206.5 477.607L202.679 481.384L204.139 475.273L200.318 471.495H205.041L206.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 465.384L559.959 471.495H564.682L560.861 475.273L562.321 481.384L558.5 477.607L554.679 481.384L556.139 475.273L552.318 471.495H557.041L558.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 465.384L119.959 471.495H124.682L120.861 475.273L122.321 481.384L118.5 477.607L114.679 481.384L116.139 475.273L112.318 471.495H117.041L118.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 465.384L471.959 471.495H476.682L472.861 475.273L474.321 481.384L470.5 477.607L466.679 481.384L468.139 475.273L464.318 471.495H469.041L470.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 465.384L295.959 471.495H300.682L296.861 475.273L298.321 481.384L294.5 477.607L290.679 481.384L292.139 475.273L288.318 471.495H293.041L294.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 465.384L647.959 471.495H652.682L648.861 475.273L650.321 481.384L646.5 477.607L642.679 481.384L644.139 475.273L640.318 471.495H645.041L646.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 465.384L9.95934 471.495H14.6819L10.8613 475.273L12.3206 481.384L8.5 477.607L4.6794 481.384L6.13874 475.273L2.31813 471.495H7.04066L8.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 465.384L361.959 471.495H366.682L362.861 475.273L364.321 481.384L360.5 477.607L356.679 481.384L358.139 475.273L354.318 471.495H359.041L360.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 465.384L185.959 471.495H190.682L186.861 475.273L188.321 481.384L184.5 477.607L180.679 481.384L182.139 475.273L178.318 471.495H183.041L184.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 465.384L537.959 471.495H542.682L538.861 475.273L540.321 481.384L536.5 477.607L532.679 481.384L534.139 475.273L530.318 471.495H535.041L536.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 465.384L97.9593 471.495H102.682L98.8613 475.273L100.321 481.384L96.5 477.607L92.6794 481.384L94.1387 475.273L90.3181 471.495H95.0407L96.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 465.384L449.959 471.495H454.682L450.861 475.273L452.321 481.384L448.5 477.607L444.679 481.384L446.139 475.273L442.318 471.495H447.041L448.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 465.384L273.959 471.495H278.682L274.861 475.273L276.321 481.384L272.5 477.607L268.679 481.384L270.139 475.273L266.318 471.495H271.041L272.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 465.384L625.959 471.495H630.682L626.861 475.273L628.321 481.384L624.5 477.607L620.679 481.384L622.139 475.273L618.318 471.495H623.041L624.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 465.384L53.9593 471.495H58.6819L54.8613 475.273L56.3206 481.384L52.5 477.607L48.6794 481.384L50.1387 475.273L46.3181 471.495H51.0407L52.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 465.384L405.959 471.495H410.682L406.861 475.273L408.321 481.384L404.5 477.607L400.679 481.384L402.139 475.273L398.318 471.495H403.041L404.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 465.384L229.959 471.495H234.682L230.861 475.273L232.321 481.384L228.5 477.607L224.679 481.384L226.139 475.273L222.318 471.495H227.041L228.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 465.384L581.959 471.495H586.682L582.861 475.273L584.321 481.384L580.5 477.607L576.679 481.384L578.139 475.273L574.318 471.495H579.041L580.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 465.384L141.959 471.495H146.682L142.861 475.273L144.321 481.384L140.5 477.607L136.679 481.384L138.139 475.273L134.318 471.495H139.041L140.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 465.384L493.959 471.495H498.682L494.861 475.273L496.321 481.384L492.5 477.607L488.679 481.384L490.139 475.273L486.318 471.495H491.041L492.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 465.384L317.959 471.495H322.682L318.861 475.273L320.321 481.384L316.5 477.607L312.679 481.384L314.139 475.273L310.318 471.495H315.041L316.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 465.384L669.959 471.495H674.682L670.861 475.273L672.321 481.384L668.5 477.607L664.679 481.384L666.139 475.273L662.318 471.495H667.041L668.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 661.334L339.959 667.446H344.682L340.861 671.223L342.321 677.335L338.5 673.558L334.679 677.335L336.139 671.223L332.318 667.446H337.041L338.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 661.334L163.959 667.446H168.682L164.861 671.223L166.321 677.335L162.5 673.558L158.679 677.335L160.139 671.223L156.318 667.446H161.041L162.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 661.334L515.959 667.446H520.682L516.861 671.223L518.321 677.335L514.5 673.558L510.679 677.335L512.139 671.223L508.318 667.446H513.041L514.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 661.334L75.9593 667.446H80.6819L76.8613 671.223L78.3206 677.335L74.5 673.558L70.6794 677.335L72.1387 671.223L68.3181 667.446H73.0407L74.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 661.334L427.959 667.446H432.682L428.861 671.223L430.321 677.335L426.5 673.558L422.679 677.335L424.139 671.223L420.318 667.446H425.041L426.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 661.334L251.959 667.446H256.682L252.861 671.223L254.321 677.335L250.5 673.558L246.679 677.335L248.139 671.223L244.318 667.446H249.041L250.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 661.334L603.959 667.446H608.682L604.861 671.223L606.321 677.335L602.5 673.558L598.679 677.335L600.139 671.223L596.318 667.446H601.041L602.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 661.334L31.9593 667.446H36.6819L32.8613 671.223L34.3206 677.335L30.5 673.558L26.6794 677.335L28.1387 671.223L24.3181 667.446H29.0407L30.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 661.334L383.959 667.446H388.682L384.861 671.223L386.321 677.335L382.5 673.558L378.679 677.335L380.139 671.223L376.318 667.446H381.041L382.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 661.334L207.959 667.446H212.682L208.861 671.223L210.321 677.335L206.5 673.558L202.679 677.335L204.139 671.223L200.318 667.446H205.041L206.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 661.334L559.959 667.446H564.682L560.861 671.223L562.321 677.335L558.5 673.558L554.679 677.335L556.139 671.223L552.318 667.446H557.041L558.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 661.334L119.959 667.446H124.682L120.861 671.223L122.321 677.335L118.5 673.558L114.679 677.335L116.139 671.223L112.318 667.446H117.041L118.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 661.334L471.959 667.446H476.682L472.861 671.223L474.321 677.335L470.5 673.558L466.679 677.335L468.139 671.223L464.318 667.446H469.041L470.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 661.334L295.959 667.446H300.682L296.861 671.223L298.321 677.335L294.5 673.558L290.679 677.335L292.139 671.223L288.318 667.446H293.041L294.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 661.334L647.959 667.446H652.682L648.861 671.223L650.321 677.335L646.5 673.558L642.679 677.335L644.139 671.223L640.318 667.446H645.041L646.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 661.334L9.95934 667.446H14.6819L10.8613 671.223L12.3206 677.335L8.5 673.558L4.6794 677.335L6.13874 671.223L2.31813 667.446H7.04066L8.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 661.334L361.959 667.446H366.682L362.861 671.223L364.321 677.335L360.5 673.558L356.679 677.335L358.139 671.223L354.318 667.446H359.041L360.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 661.334L185.959 667.446H190.682L186.861 671.223L188.321 677.335L184.5 673.558L180.679 677.335L182.139 671.223L178.318 667.446H183.041L184.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 661.334L537.959 667.446H542.682L538.861 671.223L540.321 677.335L536.5 673.558L532.679 677.335L534.139 671.223L530.318 667.446H535.041L536.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 661.334L97.9593 667.446H102.682L98.8613 671.223L100.321 677.335L96.5 673.558L92.6794 677.335L94.1387 671.223L90.3181 667.446H95.0407L96.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 661.334L449.959 667.446H454.682L450.861 671.223L452.321 677.335L448.5 673.558L444.679 677.335L446.139 671.223L442.318 667.446H447.041L448.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 661.334L273.959 667.446H278.682L274.861 671.223L276.321 677.335L272.5 673.558L268.679 677.335L270.139 671.223L266.318 667.446H271.041L272.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 661.334L625.959 667.446H630.682L626.861 671.223L628.321 677.335L624.5 673.558L620.679 677.335L622.139 671.223L618.318 667.446H623.041L624.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 661.334L53.9593 667.446H58.6819L54.8613 671.223L56.3206 677.335L52.5 673.558L48.6794 677.335L50.1387 671.223L46.3181 667.446H51.0407L52.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 661.334L405.959 667.446H410.682L406.861 671.223L408.321 677.335L404.5 673.558L400.679 677.335L402.139 671.223L398.318 667.446H403.041L404.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 661.334L229.959 667.446H234.682L230.861 671.223L232.321 677.335L228.5 673.558L224.679 677.335L226.139 671.223L222.318 667.446H227.041L228.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 661.334L581.959 667.446H586.682L582.861 671.223L584.321 677.335L580.5 673.558L576.679 677.335L578.139 671.223L574.318 667.446H579.041L580.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 661.334L141.959 667.446H146.682L142.861 671.223L144.321 677.335L140.5 673.558L136.679 677.335L138.139 671.223L134.318 667.446H139.041L140.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 661.334L493.959 667.446H498.682L494.861 671.223L496.321 677.335L492.5 673.558L488.679 677.335L490.139 671.223L486.318 667.446H491.041L492.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 661.334L317.959 667.446H322.682L318.861 671.223L320.321 677.335L316.5 673.558L312.679 677.335L314.139 671.223L310.318 667.446H315.041L316.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 661.334L669.959 667.446H674.682L670.861 671.223L672.321 677.335L668.5 673.558L664.679 677.335L666.139 671.223L662.318 667.446H667.041L668.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 563.359L339.959 569.471H344.682L340.861 573.248L342.321 579.36L338.5 575.583L334.679 579.36L336.139 573.248L332.318 569.471H337.041L338.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 563.359L163.959 569.471H168.682L164.861 573.248L166.321 579.36L162.5 575.583L158.679 579.36L160.139 573.248L156.318 569.471H161.041L162.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 563.359L515.959 569.471H520.682L516.861 573.248L518.321 579.36L514.5 575.583L510.679 579.36L512.139 573.248L508.318 569.471H513.041L514.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 563.359L75.9593 569.471H80.6819L76.8613 573.248L78.3206 579.36L74.5 575.583L70.6794 579.36L72.1387 573.248L68.3181 569.471H73.0407L74.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 563.359L427.959 569.471H432.682L428.861 573.248L430.321 579.36L426.5 575.583L422.679 579.36L424.139 573.248L420.318 569.471H425.041L426.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 563.359L251.959 569.471H256.682L252.861 573.248L254.321 579.36L250.5 575.583L246.679 579.36L248.139 573.248L244.318 569.471H249.041L250.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 563.359L603.959 569.471H608.682L604.861 573.248L606.321 579.36L602.5 575.583L598.679 579.36L600.139 573.248L596.318 569.471H601.041L602.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 563.359L31.9593 569.471H36.6819L32.8613 573.248L34.3206 579.36L30.5 575.583L26.6794 579.36L28.1387 573.248L24.3181 569.471H29.0407L30.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 563.359L383.959 569.471H388.682L384.861 573.248L386.321 579.36L382.5 575.583L378.679 579.36L380.139 573.248L376.318 569.471H381.041L382.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 563.359L207.959 569.471H212.682L208.861 573.248L210.321 579.36L206.5 575.583L202.679 579.36L204.139 573.248L200.318 569.471H205.041L206.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 563.359L559.959 569.471H564.682L560.861 573.248L562.321 579.36L558.5 575.583L554.679 579.36L556.139 573.248L552.318 569.471H557.041L558.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 563.359L119.959 569.471H124.682L120.861 573.248L122.321 579.36L118.5 575.583L114.679 579.36L116.139 573.248L112.318 569.471H117.041L118.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 563.359L471.959 569.471H476.682L472.861 573.248L474.321 579.36L470.5 575.583L466.679 579.36L468.139 573.248L464.318 569.471H469.041L470.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 563.359L295.959 569.471H300.682L296.861 573.248L298.321 579.36L294.5 575.583L290.679 579.36L292.139 573.248L288.318 569.471H293.041L294.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 563.359L647.959 569.471H652.682L648.861 573.248L650.321 579.36L646.5 575.583L642.679 579.36L644.139 573.248L640.318 569.471H645.041L646.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 563.359L9.95934 569.471H14.6819L10.8613 573.248L12.3206 579.36L8.5 575.583L4.6794 579.36L6.13874 573.248L2.31813 569.471H7.04066L8.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 563.359L361.959 569.471H366.682L362.861 573.248L364.321 579.36L360.5 575.583L356.679 579.36L358.139 573.248L354.318 569.471H359.041L360.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 563.359L185.959 569.471H190.682L186.861 573.248L188.321 579.36L184.5 575.583L180.679 579.36L182.139 573.248L178.318 569.471H183.041L184.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 563.359L537.959 569.471H542.682L538.861 573.248L540.321 579.36L536.5 575.583L532.679 579.36L534.139 573.248L530.318 569.471H535.041L536.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 563.359L97.9593 569.471H102.682L98.8613 573.248L100.321 579.36L96.5 575.583L92.6794 579.36L94.1387 573.248L90.3181 569.471H95.0407L96.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 563.359L449.959 569.471H454.682L450.861 573.248L452.321 579.36L448.5 575.583L444.679 579.36L446.139 573.248L442.318 569.471H447.041L448.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 563.359L273.959 569.471H278.682L274.861 573.248L276.321 579.36L272.5 575.583L268.679 579.36L270.139 573.248L266.318 569.471H271.041L272.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 563.359L625.959 569.471H630.682L626.861 573.248L628.321 579.36L624.5 575.583L620.679 579.36L622.139 573.248L618.318 569.471H623.041L624.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 563.359L53.9593 569.471H58.6819L54.8613 573.248L56.3206 579.36L52.5 575.583L48.6794 579.36L50.1387 573.248L46.3181 569.471H51.0407L52.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 563.359L405.959 569.471H410.682L406.861 573.248L408.321 579.36L404.5 575.583L400.679 579.36L402.139 573.248L398.318 569.471H403.041L404.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 563.359L229.959 569.471H234.682L230.861 573.248L232.321 579.36L228.5 575.583L224.679 579.36L226.139 573.248L222.318 569.471H227.041L228.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 563.359L581.959 569.471H586.682L582.861 573.248L584.321 579.36L580.5 575.583L576.679 579.36L578.139 573.248L574.318 569.471H579.041L580.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 563.359L141.959 569.471H146.682L142.861 573.248L144.321 579.36L140.5 575.583L136.679 579.36L138.139 573.248L134.318 569.471H139.041L140.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 563.359L493.959 569.471H498.682L494.861 573.248L496.321 579.36L492.5 575.583L488.679 579.36L490.139 573.248L486.318 569.471H491.041L492.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 563.359L317.959 569.471H322.682L318.861 573.248L320.321 579.36L316.5 575.583L312.679 579.36L314.139 573.248L310.318 569.471H315.041L316.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 563.359L669.959 569.471H674.682L670.861 573.248L672.321 579.36L668.5 575.583L664.679 579.36L666.139 573.248L662.318 569.471H667.041L668.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 759.31L339.959 765.422H344.682L340.861 769.199L342.321 775.311L338.5 771.534L334.679 775.311L336.139 769.199L332.318 765.422H337.041L338.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 759.31L163.959 765.422H168.682L164.861 769.199L166.321 775.311L162.5 771.534L158.679 775.311L160.139 769.199L156.318 765.422H161.041L162.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 759.31L515.959 765.422H520.682L516.861 769.199L518.321 775.311L514.5 771.534L510.679 775.311L512.139 769.199L508.318 765.422H513.041L514.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 759.31L75.9593 765.422H80.6819L76.8613 769.199L78.3206 775.311L74.5 771.534L70.6794 775.311L72.1387 769.199L68.3181 765.422H73.0407L74.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 759.31L427.959 765.422H432.682L428.861 769.199L430.321 775.311L426.5 771.534L422.679 775.311L424.139 769.199L420.318 765.422H425.041L426.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 759.31L251.959 765.422H256.682L252.861 769.199L254.321 775.311L250.5 771.534L246.679 775.311L248.139 769.199L244.318 765.422H249.041L250.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 759.31L603.959 765.422H608.682L604.861 769.199L606.321 775.311L602.5 771.534L598.679 775.311L600.139 769.199L596.318 765.422H601.041L602.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 759.31L31.9593 765.422H36.6819L32.8613 769.199L34.3206 775.311L30.5 771.534L26.6794 775.311L28.1387 769.199L24.3181 765.422H29.0407L30.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 759.31L383.959 765.422H388.682L384.861 769.199L386.321 775.311L382.5 771.534L378.679 775.311L380.139 769.199L376.318 765.422H381.041L382.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 759.31L207.959 765.422H212.682L208.861 769.199L210.321 775.311L206.5 771.534L202.679 775.311L204.139 769.199L200.318 765.422H205.041L206.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 759.31L559.959 765.422H564.682L560.861 769.199L562.321 775.311L558.5 771.534L554.679 775.311L556.139 769.199L552.318 765.422H557.041L558.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 759.31L119.959 765.422H124.682L120.861 769.199L122.321 775.311L118.5 771.534L114.679 775.311L116.139 769.199L112.318 765.422H117.041L118.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 759.31L471.959 765.422H476.682L472.861 769.199L474.321 775.311L470.5 771.534L466.679 775.311L468.139 769.199L464.318 765.422H469.041L470.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 759.31L295.959 765.422H300.682L296.861 769.199L298.321 775.311L294.5 771.534L290.679 775.311L292.139 769.199L288.318 765.422H293.041L294.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 759.31L647.959 765.422H652.682L648.861 769.199L650.321 775.311L646.5 771.534L642.679 775.311L644.139 769.199L640.318 765.422H645.041L646.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 759.31L9.95934 765.422H14.6819L10.8613 769.199L12.3206 775.311L8.5 771.534L4.6794 775.311L6.13874 769.199L2.31813 765.422H7.04066L8.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 759.31L361.959 765.422H366.682L362.861 769.199L364.321 775.311L360.5 771.534L356.679 775.311L358.139 769.199L354.318 765.422H359.041L360.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 759.31L185.959 765.422H190.682L186.861 769.199L188.321 775.311L184.5 771.534L180.679 775.311L182.139 769.199L178.318 765.422H183.041L184.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 759.31L537.959 765.422H542.682L538.861 769.199L540.321 775.311L536.5 771.534L532.679 775.311L534.139 769.199L530.318 765.422H535.041L536.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 759.31L97.9593 765.422H102.682L98.8613 769.199L100.321 775.311L96.5 771.534L92.6794 775.311L94.1387 769.199L90.3181 765.422H95.0407L96.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 759.31L449.959 765.422H454.682L450.861 769.199L452.321 775.311L448.5 771.534L444.679 775.311L446.139 769.199L442.318 765.422H447.041L448.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 759.31L273.959 765.422H278.682L274.861 769.199L276.321 775.311L272.5 771.534L268.679 775.311L270.139 769.199L266.318 765.422H271.041L272.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 759.31L625.959 765.422H630.682L626.861 769.199L628.321 775.311L624.5 771.534L620.679 775.311L622.139 769.199L618.318 765.422H623.041L624.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 759.31L53.9593 765.422H58.6819L54.8613 769.199L56.3206 775.311L52.5 771.534L48.6794 775.311L50.1387 769.199L46.3181 765.422H51.0407L52.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 759.31L405.959 765.422H410.682L406.861 769.199L408.321 775.311L404.5 771.534L400.679 775.311L402.139 769.199L398.318 765.422H403.041L404.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 759.31L229.959 765.422H234.682L230.861 769.199L232.321 775.311L228.5 771.534L224.679 775.311L226.139 769.199L222.318 765.422H227.041L228.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 759.31L581.959 765.422H586.682L582.861 769.199L584.321 775.311L580.5 771.534L576.679 775.311L578.139 769.199L574.318 765.422H579.041L580.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 759.31L141.959 765.422H146.682L142.861 769.199L144.321 775.311L140.5 771.534L136.679 775.311L138.139 769.199L134.318 765.422H139.041L140.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 759.31L493.959 765.422H498.682L494.861 769.199L496.321 775.311L492.5 771.534L488.679 775.311L490.139 769.199L486.318 765.422H491.041L492.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 759.31L317.959 765.422H322.682L318.861 769.199L320.321 775.311L316.5 771.534L312.679 775.311L314.139 769.199L310.318 765.422H315.041L316.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M668.5 759.31L669.959 765.422H674.682L670.861 769.199L672.321 775.311L668.5 771.534L664.679 775.311L666.139 769.199L662.318 765.422H667.041L668.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 0L691.959 6.11175H696.682L692.861 9.88902L694.321 16.0008L690.5 12.2235L686.679 16.0008L688.139 9.88902L684.318 6.11175H689.041L690.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 0L1043.96 6.11175H1048.68L1044.86 9.88902L1046.32 16.0008L1042.5 12.2235L1038.68 16.0008L1040.14 9.88902L1036.32 6.11175H1041.04L1042.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 0L867.959 6.11175H872.682L868.861 9.88902L870.321 16.0008L866.5 12.2235L862.679 16.0008L864.139 9.88902L860.318 6.11175H865.041L866.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 0L1219.96 6.11175H1224.68L1220.86 9.88902L1222.32 16.0008L1218.5 12.2235L1214.68 16.0008L1216.14 9.88902L1212.32 6.11175H1217.04L1218.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 0L779.959 6.11175H784.682L780.861 9.88902L782.321 16.0008L778.5 12.2235L774.679 16.0008L776.139 9.88902L772.318 6.11175H777.041L778.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 0L1131.96 6.11175H1136.68L1132.86 9.88902L1134.32 16.0008L1130.5 12.2235L1126.68 16.0008L1128.14 9.88902L1124.32 6.11175H1129.04L1130.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 0L955.959 6.11175H960.682L956.861 9.88902L958.321 16.0008L954.5 12.2235L950.679 16.0008L952.139 9.88902L948.318 6.11175H953.041L954.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 0L1307.96 6.11175H1312.68L1308.86 9.88902L1310.32 16.0008L1306.5 12.2235L1302.68 16.0008L1304.14 9.88902L1300.32 6.11175H1305.04L1306.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 0L735.959 6.11175H740.682L736.861 9.88902L738.321 16.0008L734.5 12.2235L730.679 16.0008L732.139 9.88902L728.318 6.11175H733.041L734.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 0L1087.96 6.11175H1092.68L1088.86 9.88902L1090.32 16.0008L1086.5 12.2235L1082.68 16.0008L1084.14 9.88902L1080.32 6.11175H1085.04L1086.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 0L911.959 6.11175H916.682L912.861 9.88902L914.321 16.0008L910.5 12.2235L906.679 16.0008L908.139 9.88902L904.318 6.11175H909.041L910.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 0L1263.96 6.11175H1268.68L1264.86 9.88902L1266.32 16.0008L1262.5 12.2235L1258.68 16.0008L1260.14 9.88902L1256.32 6.11175H1261.04L1262.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 0L823.959 6.11175H828.682L824.861 9.88902L826.321 16.0008L822.5 12.2235L818.679 16.0008L820.139 9.88902L816.318 6.11175H821.041L822.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 0L1175.96 6.11175H1180.68L1176.86 9.88902L1178.32 16.0008L1174.5 12.2235L1170.68 16.0008L1172.14 9.88902L1168.32 6.11175H1173.04L1174.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 0L999.959 6.11175H1004.68L1000.86 9.88902L1002.32 16.0008L998.5 12.2235L994.679 16.0008L996.139 9.88902L992.318 6.11175H997.041L998.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 0L1351.96 6.11175H1356.68L1352.86 9.88902L1354.32 16.0008L1350.5 12.2235L1346.68 16.0008L1348.14 9.88902L1344.32 6.11175H1349.04L1350.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 0L713.959 6.11175H718.682L714.861 9.88902L716.321 16.0008L712.5 12.2235L708.679 16.0008L710.139 9.88902L706.318 6.11175H711.041L712.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 0L1065.96 6.11175H1070.68L1066.86 9.88902L1068.32 16.0008L1064.5 12.2235L1060.68 16.0008L1062.14 9.88902L1058.32 6.11175H1063.04L1064.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 0L889.959 6.11175H894.682L890.861 9.88902L892.321 16.0008L888.5 12.2235L884.679 16.0008L886.139 9.88902L882.318 6.11175H887.041L888.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 0L1241.96 6.11175H1246.68L1242.86 9.88902L1244.32 16.0008L1240.5 12.2235L1236.68 16.0008L1238.14 9.88902L1234.32 6.11175H1239.04L1240.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 0L801.959 6.11175H806.682L802.861 9.88902L804.321 16.0008L800.5 12.2235L796.679 16.0008L798.139 9.88902L794.318 6.11175H799.041L800.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 0L1153.96 6.11175H1158.68L1154.86 9.88902L1156.32 16.0008L1152.5 12.2235L1148.68 16.0008L1150.14 9.88902L1146.32 6.11175H1151.04L1152.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 0L977.959 6.11175H982.682L978.861 9.88902L980.321 16.0008L976.5 12.2235L972.679 16.0008L974.139 9.88902L970.318 6.11175H975.041L976.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 0L1329.96 6.11175H1334.68L1330.86 9.88902L1332.32 16.0008L1328.5 12.2235L1324.68 16.0008L1326.14 9.88902L1322.32 6.11175H1327.04L1328.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 0L757.959 6.11175H762.682L758.861 9.88902L760.321 16.0008L756.5 12.2235L752.679 16.0008L754.139 9.88902L750.318 6.11175H755.041L756.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 0L1109.96 6.11175H1114.68L1110.86 9.88902L1112.32 16.0008L1108.5 12.2235L1104.68 16.0008L1106.14 9.88902L1102.32 6.11175H1107.04L1108.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 0L933.959 6.11175H938.682L934.861 9.88902L936.321 16.0008L932.5 12.2235L928.679 16.0008L930.139 9.88902L926.318 6.11175H931.041L932.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 0L1285.96 6.11175H1290.68L1286.86 9.88902L1288.32 16.0008L1284.5 12.2235L1280.68 16.0008L1282.14 9.88902L1278.32 6.11175H1283.04L1284.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 0L845.959 6.11175H850.682L846.861 9.88902L848.321 16.0008L844.5 12.2235L840.679 16.0008L842.139 9.88902L838.318 6.11175H843.041L844.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 0L1197.96 6.11175H1202.68L1198.86 9.88902L1200.32 16.0008L1196.5 12.2235L1192.68 16.0008L1194.14 9.88902L1190.32 6.11175H1195.04L1196.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 0L1021.96 6.11175H1026.68L1022.86 9.88902L1024.32 16.0008L1020.5 12.2235L1016.68 16.0008L1018.14 9.88902L1014.32 6.11175H1019.04L1020.5 0Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 195.951L691.959 202.063H696.682L692.861 205.84L694.321 211.952L690.5 208.174L686.679 211.952L688.139 205.84L684.318 202.063H689.041L690.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 195.951L1043.96 202.063H1048.68L1044.86 205.84L1046.32 211.952L1042.5 208.174L1038.68 211.952L1040.14 205.84L1036.32 202.063H1041.04L1042.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 195.951L867.959 202.063H872.682L868.861 205.84L870.321 211.952L866.5 208.174L862.679 211.952L864.139 205.84L860.318 202.063H865.041L866.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 195.951L1219.96 202.063H1224.68L1220.86 205.84L1222.32 211.952L1218.5 208.174L1214.68 211.952L1216.14 205.84L1212.32 202.063H1217.04L1218.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 195.951L779.959 202.063H784.682L780.861 205.84L782.321 211.952L778.5 208.174L774.679 211.952L776.139 205.84L772.318 202.063H777.041L778.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 195.951L1131.96 202.063H1136.68L1132.86 205.84L1134.32 211.952L1130.5 208.174L1126.68 211.952L1128.14 205.84L1124.32 202.063H1129.04L1130.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 195.951L955.959 202.063H960.682L956.861 205.84L958.321 211.952L954.5 208.174L950.679 211.952L952.139 205.84L948.318 202.063H953.041L954.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 195.951L1307.96 202.063H1312.68L1308.86 205.84L1310.32 211.952L1306.5 208.174L1302.68 211.952L1304.14 205.84L1300.32 202.063H1305.04L1306.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 195.951L735.959 202.063H740.682L736.861 205.84L738.321 211.952L734.5 208.174L730.679 211.952L732.139 205.84L728.318 202.063H733.041L734.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 195.951L1087.96 202.063H1092.68L1088.86 205.84L1090.32 211.952L1086.5 208.174L1082.68 211.952L1084.14 205.84L1080.32 202.063H1085.04L1086.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 195.951L911.959 202.063H916.682L912.861 205.84L914.321 211.952L910.5 208.174L906.679 211.952L908.139 205.84L904.318 202.063H909.041L910.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 195.951L1263.96 202.063H1268.68L1264.86 205.84L1266.32 211.952L1262.5 208.174L1258.68 211.952L1260.14 205.84L1256.32 202.063H1261.04L1262.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 195.951L823.959 202.063H828.682L824.861 205.84L826.321 211.952L822.5 208.174L818.679 211.952L820.139 205.84L816.318 202.063H821.041L822.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 195.951L1175.96 202.063H1180.68L1176.86 205.84L1178.32 211.952L1174.5 208.174L1170.68 211.952L1172.14 205.84L1168.32 202.063H1173.04L1174.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 195.951L999.959 202.063H1004.68L1000.86 205.84L1002.32 211.952L998.5 208.174L994.679 211.952L996.139 205.84L992.318 202.063H997.041L998.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 195.951L1351.96 202.063H1356.68L1352.86 205.84L1354.32 211.952L1350.5 208.174L1346.68 211.952L1348.14 205.84L1344.32 202.063H1349.04L1350.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 195.951L713.959 202.063H718.682L714.861 205.84L716.321 211.952L712.5 208.174L708.679 211.952L710.139 205.84L706.318 202.063H711.041L712.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 195.951L1065.96 202.063H1070.68L1066.86 205.84L1068.32 211.952L1064.5 208.174L1060.68 211.952L1062.14 205.84L1058.32 202.063H1063.04L1064.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 195.951L889.959 202.063H894.682L890.861 205.84L892.321 211.952L888.5 208.174L884.679 211.952L886.139 205.84L882.318 202.063H887.041L888.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 195.951L1241.96 202.063H1246.68L1242.86 205.84L1244.32 211.952L1240.5 208.174L1236.68 211.952L1238.14 205.84L1234.32 202.063H1239.04L1240.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 195.951L801.959 202.063H806.682L802.861 205.84L804.321 211.952L800.5 208.174L796.679 211.952L798.139 205.84L794.318 202.063H799.041L800.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 195.951L1153.96 202.063H1158.68L1154.86 205.84L1156.32 211.952L1152.5 208.174L1148.68 211.952L1150.14 205.84L1146.32 202.063H1151.04L1152.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 195.951L977.959 202.063H982.682L978.861 205.84L980.321 211.952L976.5 208.174L972.679 211.952L974.139 205.84L970.318 202.063H975.041L976.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 195.951L1329.96 202.063H1334.68L1330.86 205.84L1332.32 211.952L1328.5 208.174L1324.68 211.952L1326.14 205.84L1322.32 202.063H1327.04L1328.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 195.951L757.959 202.063H762.682L758.861 205.84L760.321 211.952L756.5 208.174L752.679 211.952L754.139 205.84L750.318 202.063H755.041L756.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 195.951L1109.96 202.063H1114.68L1110.86 205.84L1112.32 211.952L1108.5 208.174L1104.68 211.952L1106.14 205.84L1102.32 202.063H1107.04L1108.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 195.951L933.959 202.063H938.682L934.861 205.84L936.321 211.952L932.5 208.174L928.679 211.952L930.139 205.84L926.318 202.063H931.041L932.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 195.951L1285.96 202.063H1290.68L1286.86 205.84L1288.32 211.952L1284.5 208.174L1280.68 211.952L1282.14 205.84L1278.32 202.063H1283.04L1284.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 195.951L845.959 202.063H850.682L846.861 205.84L848.321 211.952L844.5 208.174L840.679 211.952L842.139 205.84L838.318 202.063H843.041L844.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 195.951L1197.96 202.063H1202.68L1198.86 205.84L1200.32 211.952L1196.5 208.174L1192.68 211.952L1194.14 205.84L1190.32 202.063H1195.04L1196.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 195.951L1021.96 202.063H1026.68L1022.86 205.84L1024.32 211.952L1020.5 208.174L1016.68 211.952L1018.14 205.84L1014.32 202.063H1019.04L1020.5 195.951Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 97.9756L691.959 104.087H696.682L692.861 107.865L694.321 113.976L690.5 110.199L686.679 113.976L688.139 107.865L684.318 104.087H689.041L690.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 97.9756L1043.96 104.087H1048.68L1044.86 107.865L1046.32 113.976L1042.5 110.199L1038.68 113.976L1040.14 107.865L1036.32 104.087H1041.04L1042.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 97.9756L867.959 104.087H872.682L868.861 107.865L870.321 113.976L866.5 110.199L862.679 113.976L864.139 107.865L860.318 104.087H865.041L866.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 97.9756L1219.96 104.087H1224.68L1220.86 107.865L1222.32 113.976L1218.5 110.199L1214.68 113.976L1216.14 107.865L1212.32 104.087H1217.04L1218.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 97.9756L779.959 104.087H784.682L780.861 107.865L782.321 113.976L778.5 110.199L774.679 113.976L776.139 107.865L772.318 104.087H777.041L778.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 97.9756L1131.96 104.087H1136.68L1132.86 107.865L1134.32 113.976L1130.5 110.199L1126.68 113.976L1128.14 107.865L1124.32 104.087H1129.04L1130.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 97.9756L955.959 104.087H960.682L956.861 107.865L958.321 113.976L954.5 110.199L950.679 113.976L952.139 107.865L948.318 104.087H953.041L954.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 97.9756L1307.96 104.087H1312.68L1308.86 107.865L1310.32 113.976L1306.5 110.199L1302.68 113.976L1304.14 107.865L1300.32 104.087H1305.04L1306.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 97.9756L735.959 104.087H740.682L736.861 107.865L738.321 113.976L734.5 110.199L730.679 113.976L732.139 107.865L728.318 104.087H733.041L734.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 97.9756L1087.96 104.087H1092.68L1088.86 107.865L1090.32 113.976L1086.5 110.199L1082.68 113.976L1084.14 107.865L1080.32 104.087H1085.04L1086.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 97.9756L911.959 104.087H916.682L912.861 107.865L914.321 113.976L910.5 110.199L906.679 113.976L908.139 107.865L904.318 104.087H909.041L910.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 97.9756L1263.96 104.087H1268.68L1264.86 107.865L1266.32 113.976L1262.5 110.199L1258.68 113.976L1260.14 107.865L1256.32 104.087H1261.04L1262.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 97.9756L823.959 104.087H828.682L824.861 107.865L826.321 113.976L822.5 110.199L818.679 113.976L820.139 107.865L816.318 104.087H821.041L822.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 97.9756L1175.96 104.087H1180.68L1176.86 107.865L1178.32 113.976L1174.5 110.199L1170.68 113.976L1172.14 107.865L1168.32 104.087H1173.04L1174.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 97.9756L999.959 104.087H1004.68L1000.86 107.865L1002.32 113.976L998.5 110.199L994.679 113.976L996.139 107.865L992.318 104.087H997.041L998.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 97.9756L1351.96 104.087H1356.68L1352.86 107.865L1354.32 113.976L1350.5 110.199L1346.68 113.976L1348.14 107.865L1344.32 104.087H1349.04L1350.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 97.9756L713.959 104.087H718.682L714.861 107.865L716.321 113.976L712.5 110.199L708.679 113.976L710.139 107.865L706.318 104.087H711.041L712.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 97.9756L1065.96 104.087H1070.68L1066.86 107.865L1068.32 113.976L1064.5 110.199L1060.68 113.976L1062.14 107.865L1058.32 104.087H1063.04L1064.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 97.9756L889.959 104.087H894.682L890.861 107.865L892.321 113.976L888.5 110.199L884.679 113.976L886.139 107.865L882.318 104.087H887.041L888.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 97.9756L1241.96 104.087H1246.68L1242.86 107.865L1244.32 113.976L1240.5 110.199L1236.68 113.976L1238.14 107.865L1234.32 104.087H1239.04L1240.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 97.9756L801.959 104.087H806.682L802.861 107.865L804.321 113.976L800.5 110.199L796.679 113.976L798.139 107.865L794.318 104.087H799.041L800.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 97.9756L1153.96 104.087H1158.68L1154.86 107.865L1156.32 113.976L1152.5 110.199L1148.68 113.976L1150.14 107.865L1146.32 104.087H1151.04L1152.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 97.9756L977.959 104.087H982.682L978.861 107.865L980.321 113.976L976.5 110.199L972.679 113.976L974.139 107.865L970.318 104.087H975.041L976.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 97.9756L1329.96 104.087H1334.68L1330.86 107.865L1332.32 113.976L1328.5 110.199L1324.68 113.976L1326.14 107.865L1322.32 104.087H1327.04L1328.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 97.9756L757.959 104.087H762.682L758.861 107.865L760.321 113.976L756.5 110.199L752.679 113.976L754.139 107.865L750.318 104.087H755.041L756.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 97.9756L1109.96 104.087H1114.68L1110.86 107.865L1112.32 113.976L1108.5 110.199L1104.68 113.976L1106.14 107.865L1102.32 104.087H1107.04L1108.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 97.9756L933.959 104.087H938.682L934.861 107.865L936.321 113.976L932.5 110.199L928.679 113.976L930.139 107.865L926.318 104.087H931.041L932.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 97.9756L1285.96 104.087H1290.68L1286.86 107.865L1288.32 113.976L1284.5 110.199L1280.68 113.976L1282.14 107.865L1278.32 104.087H1283.04L1284.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 97.9756L845.959 104.087H850.682L846.861 107.865L848.321 113.976L844.5 110.199L840.679 113.976L842.139 107.865L838.318 104.087H843.041L844.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 97.9756L1197.96 104.087H1202.68L1198.86 107.865L1200.32 113.976L1196.5 110.199L1192.68 113.976L1194.14 107.865L1190.32 104.087H1195.04L1196.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 97.9756L1021.96 104.087H1026.68L1022.86 107.865L1024.32 113.976L1020.5 110.199L1016.68 113.976L1018.14 107.865L1014.32 104.087H1019.04L1020.5 97.9756Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 293.927L691.959 300.038H696.682L692.861 303.816L694.321 309.927L690.5 306.15L686.679 309.927L688.139 303.816L684.318 300.038H689.041L690.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 293.927L1043.96 300.038H1048.68L1044.86 303.816L1046.32 309.927L1042.5 306.15L1038.68 309.927L1040.14 303.816L1036.32 300.038H1041.04L1042.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 293.927L867.959 300.038H872.682L868.861 303.816L870.321 309.927L866.5 306.15L862.679 309.927L864.139 303.816L860.318 300.038H865.041L866.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 293.927L1219.96 300.038H1224.68L1220.86 303.816L1222.32 309.927L1218.5 306.15L1214.68 309.927L1216.14 303.816L1212.32 300.038H1217.04L1218.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 293.927L779.959 300.038H784.682L780.861 303.816L782.321 309.927L778.5 306.15L774.679 309.927L776.139 303.816L772.318 300.038H777.041L778.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 293.927L1131.96 300.038H1136.68L1132.86 303.816L1134.32 309.927L1130.5 306.15L1126.68 309.927L1128.14 303.816L1124.32 300.038H1129.04L1130.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 293.927L955.959 300.038H960.682L956.861 303.816L958.321 309.927L954.5 306.15L950.679 309.927L952.139 303.816L948.318 300.038H953.041L954.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 293.927L1307.96 300.038H1312.68L1308.86 303.816L1310.32 309.927L1306.5 306.15L1302.68 309.927L1304.14 303.816L1300.32 300.038H1305.04L1306.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 293.927L735.959 300.038H740.682L736.861 303.816L738.321 309.927L734.5 306.15L730.679 309.927L732.139 303.816L728.318 300.038H733.041L734.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 293.927L1087.96 300.038H1092.68L1088.86 303.816L1090.32 309.927L1086.5 306.15L1082.68 309.927L1084.14 303.816L1080.32 300.038H1085.04L1086.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 293.927L911.959 300.038H916.682L912.861 303.816L914.321 309.927L910.5 306.15L906.679 309.927L908.139 303.816L904.318 300.038H909.041L910.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 293.927L1263.96 300.038H1268.68L1264.86 303.816L1266.32 309.927L1262.5 306.15L1258.68 309.927L1260.14 303.816L1256.32 300.038H1261.04L1262.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 293.927L823.959 300.038H828.682L824.861 303.816L826.321 309.927L822.5 306.15L818.679 309.927L820.139 303.816L816.318 300.038H821.041L822.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 293.927L1175.96 300.038H1180.68L1176.86 303.816L1178.32 309.927L1174.5 306.15L1170.68 309.927L1172.14 303.816L1168.32 300.038H1173.04L1174.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 293.927L999.959 300.038H1004.68L1000.86 303.816L1002.32 309.927L998.5 306.15L994.679 309.927L996.139 303.816L992.318 300.038H997.041L998.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 293.927L1351.96 300.038H1356.68L1352.86 303.816L1354.32 309.927L1350.5 306.15L1346.68 309.927L1348.14 303.816L1344.32 300.038H1349.04L1350.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 293.927L713.959 300.038H718.682L714.861 303.816L716.321 309.927L712.5 306.15L708.679 309.927L710.139 303.816L706.318 300.038H711.041L712.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 293.927L1065.96 300.038H1070.68L1066.86 303.816L1068.32 309.927L1064.5 306.15L1060.68 309.927L1062.14 303.816L1058.32 300.038H1063.04L1064.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 293.927L889.959 300.038H894.682L890.861 303.816L892.321 309.927L888.5 306.15L884.679 309.927L886.139 303.816L882.318 300.038H887.041L888.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 293.927L1241.96 300.038H1246.68L1242.86 303.816L1244.32 309.927L1240.5 306.15L1236.68 309.927L1238.14 303.816L1234.32 300.038H1239.04L1240.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 293.927L801.959 300.038H806.682L802.861 303.816L804.321 309.927L800.5 306.15L796.679 309.927L798.139 303.816L794.318 300.038H799.041L800.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 293.927L1153.96 300.038H1158.68L1154.86 303.816L1156.32 309.927L1152.5 306.15L1148.68 309.927L1150.14 303.816L1146.32 300.038H1151.04L1152.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 293.927L977.959 300.038H982.682L978.861 303.816L980.321 309.927L976.5 306.15L972.679 309.927L974.139 303.816L970.318 300.038H975.041L976.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 293.927L1329.96 300.038H1334.68L1330.86 303.816L1332.32 309.927L1328.5 306.15L1324.68 309.927L1326.14 303.816L1322.32 300.038H1327.04L1328.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 293.927L757.959 300.038H762.682L758.861 303.816L760.321 309.927L756.5 306.15L752.679 309.927L754.139 303.816L750.318 300.038H755.041L756.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 293.927L1109.96 300.038H1114.68L1110.86 303.816L1112.32 309.927L1108.5 306.15L1104.68 309.927L1106.14 303.816L1102.32 300.038H1107.04L1108.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 293.927L933.959 300.038H938.682L934.861 303.816L936.321 309.927L932.5 306.15L928.679 309.927L930.139 303.816L926.318 300.038H931.041L932.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 293.927L1285.96 300.038H1290.68L1286.86 303.816L1288.32 309.927L1284.5 306.15L1280.68 309.927L1282.14 303.816L1278.32 300.038H1283.04L1284.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 293.927L845.959 300.038H850.682L846.861 303.816L848.321 309.927L844.5 306.15L840.679 309.927L842.139 303.816L838.318 300.038H843.041L844.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 293.927L1197.96 300.038H1202.68L1198.86 303.816L1200.32 309.927L1196.5 306.15L1192.68 309.927L1194.14 303.816L1190.32 300.038H1195.04L1196.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 293.927L1021.96 300.038H1026.68L1022.86 303.816L1024.32 309.927L1020.5 306.15L1016.68 309.927L1018.14 303.816L1014.32 300.038H1019.04L1020.5 293.927Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 48.9878L691.959 55.0995H696.682L692.861 58.8768L694.321 64.9886L690.5 61.2113L686.679 64.9886L688.139 58.8768L684.318 55.0995H689.041L690.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 48.9878L1043.96 55.0995H1048.68L1044.86 58.8768L1046.32 64.9886L1042.5 61.2113L1038.68 64.9886L1040.14 58.8768L1036.32 55.0995H1041.04L1042.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 48.9878L867.959 55.0995H872.682L868.861 58.8768L870.321 64.9886L866.5 61.2113L862.679 64.9886L864.139 58.8768L860.318 55.0995H865.041L866.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 48.9878L1219.96 55.0995H1224.68L1220.86 58.8768L1222.32 64.9886L1218.5 61.2113L1214.68 64.9886L1216.14 58.8768L1212.32 55.0995H1217.04L1218.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 48.9878L779.959 55.0995H784.682L780.861 58.8768L782.321 64.9886L778.5 61.2113L774.679 64.9886L776.139 58.8768L772.318 55.0995H777.041L778.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 48.9878L1131.96 55.0995H1136.68L1132.86 58.8768L1134.32 64.9886L1130.5 61.2113L1126.68 64.9886L1128.14 58.8768L1124.32 55.0995H1129.04L1130.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 48.9878L955.959 55.0995H960.682L956.861 58.8768L958.321 64.9886L954.5 61.2113L950.679 64.9886L952.139 58.8768L948.318 55.0995H953.041L954.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 48.9878L1307.96 55.0995H1312.68L1308.86 58.8768L1310.32 64.9886L1306.5 61.2113L1302.68 64.9886L1304.14 58.8768L1300.32 55.0995H1305.04L1306.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 48.9878L735.959 55.0995H740.682L736.861 58.8768L738.321 64.9886L734.5 61.2113L730.679 64.9886L732.139 58.8768L728.318 55.0995H733.041L734.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 48.9878L1087.96 55.0995H1092.68L1088.86 58.8768L1090.32 64.9886L1086.5 61.2113L1082.68 64.9886L1084.14 58.8768L1080.32 55.0995H1085.04L1086.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 48.9878L911.959 55.0995H916.682L912.861 58.8768L914.321 64.9886L910.5 61.2113L906.679 64.9886L908.139 58.8768L904.318 55.0995H909.041L910.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 48.9878L1263.96 55.0995H1268.68L1264.86 58.8768L1266.32 64.9886L1262.5 61.2113L1258.68 64.9886L1260.14 58.8768L1256.32 55.0995H1261.04L1262.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 48.9878L823.959 55.0995H828.682L824.861 58.8768L826.321 64.9886L822.5 61.2113L818.679 64.9886L820.139 58.8768L816.318 55.0995H821.041L822.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 48.9878L1175.96 55.0995H1180.68L1176.86 58.8768L1178.32 64.9886L1174.5 61.2113L1170.68 64.9886L1172.14 58.8768L1168.32 55.0995H1173.04L1174.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 48.9878L999.959 55.0995H1004.68L1000.86 58.8768L1002.32 64.9886L998.5 61.2113L994.679 64.9886L996.139 58.8768L992.318 55.0995H997.041L998.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 48.9878L1351.96 55.0995H1356.68L1352.86 58.8768L1354.32 64.9886L1350.5 61.2113L1346.68 64.9886L1348.14 58.8768L1344.32 55.0995H1349.04L1350.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 48.9878L713.959 55.0995H718.682L714.861 58.8768L716.321 64.9886L712.5 61.2113L708.679 64.9886L710.139 58.8768L706.318 55.0995H711.041L712.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 48.9878L1065.96 55.0995H1070.68L1066.86 58.8768L1068.32 64.9886L1064.5 61.2113L1060.68 64.9886L1062.14 58.8768L1058.32 55.0995H1063.04L1064.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 48.9878L889.959 55.0995H894.682L890.861 58.8768L892.321 64.9886L888.5 61.2113L884.679 64.9886L886.139 58.8768L882.318 55.0995H887.041L888.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 48.9878L1241.96 55.0995H1246.68L1242.86 58.8768L1244.32 64.9886L1240.5 61.2113L1236.68 64.9886L1238.14 58.8768L1234.32 55.0995H1239.04L1240.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 48.9878L801.959 55.0995H806.682L802.861 58.8768L804.321 64.9886L800.5 61.2113L796.679 64.9886L798.139 58.8768L794.318 55.0995H799.041L800.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 48.9878L1153.96 55.0995H1158.68L1154.86 58.8768L1156.32 64.9886L1152.5 61.2113L1148.68 64.9886L1150.14 58.8768L1146.32 55.0995H1151.04L1152.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 48.9878L977.959 55.0995H982.682L978.861 58.8768L980.321 64.9886L976.5 61.2113L972.679 64.9886L974.139 58.8768L970.318 55.0995H975.041L976.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 48.9878L1329.96 55.0995H1334.68L1330.86 58.8768L1332.32 64.9886L1328.5 61.2113L1324.68 64.9886L1326.14 58.8768L1322.32 55.0995H1327.04L1328.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 48.9878L757.959 55.0995H762.682L758.861 58.8768L760.321 64.9886L756.5 61.2113L752.679 64.9886L754.139 58.8768L750.318 55.0995H755.041L756.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 48.9878L1109.96 55.0995H1114.68L1110.86 58.8768L1112.32 64.9886L1108.5 61.2113L1104.68 64.9886L1106.14 58.8768L1102.32 55.0995H1107.04L1108.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 48.9878L933.959 55.0995H938.682L934.861 58.8768L936.321 64.9886L932.5 61.2113L928.679 64.9886L930.139 58.8768L926.318 55.0995H931.041L932.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 48.9878L1285.96 55.0995H1290.68L1286.86 58.8768L1288.32 64.9886L1284.5 61.2113L1280.68 64.9886L1282.14 58.8768L1278.32 55.0995H1283.04L1284.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 48.9878L845.959 55.0995H850.682L846.861 58.8768L848.321 64.9886L844.5 61.2113L840.679 64.9886L842.139 58.8768L838.318 55.0995H843.041L844.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 48.9878L1197.96 55.0995H1202.68L1198.86 58.8768L1200.32 64.9886L1196.5 61.2113L1192.68 64.9886L1194.14 58.8768L1190.32 55.0995H1195.04L1196.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 48.9878L1021.96 55.0995H1026.68L1022.86 58.8768L1024.32 64.9886L1020.5 61.2113L1016.68 64.9886L1018.14 58.8768L1014.32 55.0995H1019.04L1020.5 48.9878Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 244.938L691.959 251.05H696.682L692.861 254.827L694.321 260.939L690.5 257.162L686.679 260.939L688.139 254.827L684.318 251.05H689.041L690.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 244.938L1043.96 251.05H1048.68L1044.86 254.827L1046.32 260.939L1042.5 257.162L1038.68 260.939L1040.14 254.827L1036.32 251.05H1041.04L1042.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 244.938L867.959 251.05H872.682L868.861 254.827L870.321 260.939L866.5 257.162L862.679 260.939L864.139 254.827L860.318 251.05H865.041L866.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 244.938L1219.96 251.05H1224.68L1220.86 254.827L1222.32 260.939L1218.5 257.162L1214.68 260.939L1216.14 254.827L1212.32 251.05H1217.04L1218.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 244.938L779.959 251.05H784.682L780.861 254.827L782.321 260.939L778.5 257.162L774.679 260.939L776.139 254.827L772.318 251.05H777.041L778.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 244.938L1131.96 251.05H1136.68L1132.86 254.827L1134.32 260.939L1130.5 257.162L1126.68 260.939L1128.14 254.827L1124.32 251.05H1129.04L1130.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 244.938L955.959 251.05H960.682L956.861 254.827L958.321 260.939L954.5 257.162L950.679 260.939L952.139 254.827L948.318 251.05H953.041L954.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 244.938L1307.96 251.05H1312.68L1308.86 254.827L1310.32 260.939L1306.5 257.162L1302.68 260.939L1304.14 254.827L1300.32 251.05H1305.04L1306.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 244.938L735.959 251.05H740.682L736.861 254.827L738.321 260.939L734.5 257.162L730.679 260.939L732.139 254.827L728.318 251.05H733.041L734.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 244.938L1087.96 251.05H1092.68L1088.86 254.827L1090.32 260.939L1086.5 257.162L1082.68 260.939L1084.14 254.827L1080.32 251.05H1085.04L1086.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 244.938L911.959 251.05H916.682L912.861 254.827L914.321 260.939L910.5 257.162L906.679 260.939L908.139 254.827L904.318 251.05H909.041L910.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 244.938L1263.96 251.05H1268.68L1264.86 254.827L1266.32 260.939L1262.5 257.162L1258.68 260.939L1260.14 254.827L1256.32 251.05H1261.04L1262.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 244.938L823.959 251.05H828.682L824.861 254.827L826.321 260.939L822.5 257.162L818.679 260.939L820.139 254.827L816.318 251.05H821.041L822.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 244.938L1175.96 251.05H1180.68L1176.86 254.827L1178.32 260.939L1174.5 257.162L1170.68 260.939L1172.14 254.827L1168.32 251.05H1173.04L1174.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 244.938L999.959 251.05H1004.68L1000.86 254.827L1002.32 260.939L998.5 257.162L994.679 260.939L996.139 254.827L992.318 251.05H997.041L998.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 244.938L1351.96 251.05H1356.68L1352.86 254.827L1354.32 260.939L1350.5 257.162L1346.68 260.939L1348.14 254.827L1344.32 251.05H1349.04L1350.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 244.938L713.959 251.05H718.682L714.861 254.827L716.321 260.939L712.5 257.162L708.679 260.939L710.139 254.827L706.318 251.05H711.041L712.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 244.938L1065.96 251.05H1070.68L1066.86 254.827L1068.32 260.939L1064.5 257.162L1060.68 260.939L1062.14 254.827L1058.32 251.05H1063.04L1064.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 244.938L889.959 251.05H894.682L890.861 254.827L892.321 260.939L888.5 257.162L884.679 260.939L886.139 254.827L882.318 251.05H887.041L888.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 244.938L1241.96 251.05H1246.68L1242.86 254.827L1244.32 260.939L1240.5 257.162L1236.68 260.939L1238.14 254.827L1234.32 251.05H1239.04L1240.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 244.938L801.959 251.05H806.682L802.861 254.827L804.321 260.939L800.5 257.162L796.679 260.939L798.139 254.827L794.318 251.05H799.041L800.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 244.938L1153.96 251.05H1158.68L1154.86 254.827L1156.32 260.939L1152.5 257.162L1148.68 260.939L1150.14 254.827L1146.32 251.05H1151.04L1152.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 244.938L977.959 251.05H982.682L978.861 254.827L980.321 260.939L976.5 257.162L972.679 260.939L974.139 254.827L970.318 251.05H975.041L976.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 244.938L1329.96 251.05H1334.68L1330.86 254.827L1332.32 260.939L1328.5 257.162L1324.68 260.939L1326.14 254.827L1322.32 251.05H1327.04L1328.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 244.938L757.959 251.05H762.682L758.861 254.827L760.321 260.939L756.5 257.162L752.679 260.939L754.139 254.827L750.318 251.05H755.041L756.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 244.938L1109.96 251.05H1114.68L1110.86 254.827L1112.32 260.939L1108.5 257.162L1104.68 260.939L1106.14 254.827L1102.32 251.05H1107.04L1108.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 244.938L933.959 251.05H938.682L934.861 254.827L936.321 260.939L932.5 257.162L928.679 260.939L930.139 254.827L926.318 251.05H931.041L932.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 244.938L1285.96 251.05H1290.68L1286.86 254.827L1288.32 260.939L1284.5 257.162L1280.68 260.939L1282.14 254.827L1278.32 251.05H1283.04L1284.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 244.938L845.959 251.05H850.682L846.861 254.827L848.321 260.939L844.5 257.162L840.679 260.939L842.139 254.827L838.318 251.05H843.041L844.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 244.938L1197.96 251.05H1202.68L1198.86 254.827L1200.32 260.939L1196.5 257.162L1192.68 260.939L1194.14 254.827L1190.32 251.05H1195.04L1196.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 244.938L1021.96 251.05H1026.68L1022.86 254.827L1024.32 260.939L1020.5 257.162L1016.68 260.939L1018.14 254.827L1014.32 251.05H1019.04L1020.5 244.938Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 146.963L691.959 153.075H696.682L692.861 156.852L694.321 162.964L690.5 159.187L686.679 162.964L688.139 156.852L684.318 153.075H689.041L690.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 146.963L1043.96 153.075H1048.68L1044.86 156.852L1046.32 162.964L1042.5 159.187L1038.68 162.964L1040.14 156.852L1036.32 153.075H1041.04L1042.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 146.963L867.959 153.075H872.682L868.861 156.852L870.321 162.964L866.5 159.187L862.679 162.964L864.139 156.852L860.318 153.075H865.041L866.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 146.963L1219.96 153.075H1224.68L1220.86 156.852L1222.32 162.964L1218.5 159.187L1214.68 162.964L1216.14 156.852L1212.32 153.075H1217.04L1218.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 146.963L779.959 153.075H784.682L780.861 156.852L782.321 162.964L778.5 159.187L774.679 162.964L776.139 156.852L772.318 153.075H777.041L778.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 146.963L1131.96 153.075H1136.68L1132.86 156.852L1134.32 162.964L1130.5 159.187L1126.68 162.964L1128.14 156.852L1124.32 153.075H1129.04L1130.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 146.963L955.959 153.075H960.682L956.861 156.852L958.321 162.964L954.5 159.187L950.679 162.964L952.139 156.852L948.318 153.075H953.041L954.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 146.963L1307.96 153.075H1312.68L1308.86 156.852L1310.32 162.964L1306.5 159.187L1302.68 162.964L1304.14 156.852L1300.32 153.075H1305.04L1306.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 146.963L735.959 153.075H740.682L736.861 156.852L738.321 162.964L734.5 159.187L730.679 162.964L732.139 156.852L728.318 153.075H733.041L734.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 146.963L1087.96 153.075H1092.68L1088.86 156.852L1090.32 162.964L1086.5 159.187L1082.68 162.964L1084.14 156.852L1080.32 153.075H1085.04L1086.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 146.963L911.959 153.075H916.682L912.861 156.852L914.321 162.964L910.5 159.187L906.679 162.964L908.139 156.852L904.318 153.075H909.041L910.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 146.963L1263.96 153.075H1268.68L1264.86 156.852L1266.32 162.964L1262.5 159.187L1258.68 162.964L1260.14 156.852L1256.32 153.075H1261.04L1262.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 146.963L823.959 153.075H828.682L824.861 156.852L826.321 162.964L822.5 159.187L818.679 162.964L820.139 156.852L816.318 153.075H821.041L822.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 146.963L1175.96 153.075H1180.68L1176.86 156.852L1178.32 162.964L1174.5 159.187L1170.68 162.964L1172.14 156.852L1168.32 153.075H1173.04L1174.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 146.963L999.959 153.075H1004.68L1000.86 156.852L1002.32 162.964L998.5 159.187L994.679 162.964L996.139 156.852L992.318 153.075H997.041L998.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 146.963L1351.96 153.075H1356.68L1352.86 156.852L1354.32 162.964L1350.5 159.187L1346.68 162.964L1348.14 156.852L1344.32 153.075H1349.04L1350.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 146.963L713.959 153.075H718.682L714.861 156.852L716.321 162.964L712.5 159.187L708.679 162.964L710.139 156.852L706.318 153.075H711.041L712.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 146.963L1065.96 153.075H1070.68L1066.86 156.852L1068.32 162.964L1064.5 159.187L1060.68 162.964L1062.14 156.852L1058.32 153.075H1063.04L1064.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 146.963L889.959 153.075H894.682L890.861 156.852L892.321 162.964L888.5 159.187L884.679 162.964L886.139 156.852L882.318 153.075H887.041L888.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 146.963L1241.96 153.075H1246.68L1242.86 156.852L1244.32 162.964L1240.5 159.187L1236.68 162.964L1238.14 156.852L1234.32 153.075H1239.04L1240.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 146.963L801.959 153.075H806.682L802.861 156.852L804.321 162.964L800.5 159.187L796.679 162.964L798.139 156.852L794.318 153.075H799.041L800.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 146.963L1153.96 153.075H1158.68L1154.86 156.852L1156.32 162.964L1152.5 159.187L1148.68 162.964L1150.14 156.852L1146.32 153.075H1151.04L1152.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 146.963L977.959 153.075H982.682L978.861 156.852L980.321 162.964L976.5 159.187L972.679 162.964L974.139 156.852L970.318 153.075H975.041L976.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 146.963L1329.96 153.075H1334.68L1330.86 156.852L1332.32 162.964L1328.5 159.187L1324.68 162.964L1326.14 156.852L1322.32 153.075H1327.04L1328.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 146.963L757.959 153.075H762.682L758.861 156.852L760.321 162.964L756.5 159.187L752.679 162.964L754.139 156.852L750.318 153.075H755.041L756.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 146.963L1109.96 153.075H1114.68L1110.86 156.852L1112.32 162.964L1108.5 159.187L1104.68 162.964L1106.14 156.852L1102.32 153.075H1107.04L1108.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 146.963L933.959 153.075H938.682L934.861 156.852L936.321 162.964L932.5 159.187L928.679 162.964L930.139 156.852L926.318 153.075H931.041L932.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 146.963L1285.96 153.075H1290.68L1286.86 156.852L1288.32 162.964L1284.5 159.187L1280.68 162.964L1282.14 156.852L1278.32 153.075H1283.04L1284.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 146.963L845.959 153.075H850.682L846.861 156.852L848.321 162.964L844.5 159.187L840.679 162.964L842.139 156.852L838.318 153.075H843.041L844.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 146.963L1197.96 153.075H1202.68L1198.86 156.852L1200.32 162.964L1196.5 159.187L1192.68 162.964L1194.14 156.852L1190.32 153.075H1195.04L1196.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 146.963L1021.96 153.075H1026.68L1022.86 156.852L1024.32 162.964L1020.5 159.187L1016.68 162.964L1018.14 156.852L1014.32 153.075H1019.04L1020.5 146.963Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 342.914L691.959 349.026H696.682L692.861 352.803L694.321 358.915L690.5 355.138L686.679 358.915L688.139 352.803L684.318 349.026H689.041L690.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 342.914L1043.96 349.026H1048.68L1044.86 352.803L1046.32 358.915L1042.5 355.138L1038.68 358.915L1040.14 352.803L1036.32 349.026H1041.04L1042.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 342.914L867.959 349.026H872.682L868.861 352.803L870.321 358.915L866.5 355.138L862.679 358.915L864.139 352.803L860.318 349.026H865.041L866.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 342.914L1219.96 349.026H1224.68L1220.86 352.803L1222.32 358.915L1218.5 355.138L1214.68 358.915L1216.14 352.803L1212.32 349.026H1217.04L1218.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 342.914L779.959 349.026H784.682L780.861 352.803L782.321 358.915L778.5 355.138L774.679 358.915L776.139 352.803L772.318 349.026H777.041L778.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 342.914L1131.96 349.026H1136.68L1132.86 352.803L1134.32 358.915L1130.5 355.138L1126.68 358.915L1128.14 352.803L1124.32 349.026H1129.04L1130.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 342.914L955.959 349.026H960.682L956.861 352.803L958.321 358.915L954.5 355.138L950.679 358.915L952.139 352.803L948.318 349.026H953.041L954.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 342.914L1307.96 349.026H1312.68L1308.86 352.803L1310.32 358.915L1306.5 355.138L1302.68 358.915L1304.14 352.803L1300.32 349.026H1305.04L1306.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 342.914L735.959 349.026H740.682L736.861 352.803L738.321 358.915L734.5 355.138L730.679 358.915L732.139 352.803L728.318 349.026H733.041L734.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 342.914L1087.96 349.026H1092.68L1088.86 352.803L1090.32 358.915L1086.5 355.138L1082.68 358.915L1084.14 352.803L1080.32 349.026H1085.04L1086.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 342.914L911.959 349.026H916.682L912.861 352.803L914.321 358.915L910.5 355.138L906.679 358.915L908.139 352.803L904.318 349.026H909.041L910.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 342.914L1263.96 349.026H1268.68L1264.86 352.803L1266.32 358.915L1262.5 355.138L1258.68 358.915L1260.14 352.803L1256.32 349.026H1261.04L1262.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 342.914L823.959 349.026H828.682L824.861 352.803L826.321 358.915L822.5 355.138L818.679 358.915L820.139 352.803L816.318 349.026H821.041L822.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 342.914L1175.96 349.026H1180.68L1176.86 352.803L1178.32 358.915L1174.5 355.138L1170.68 358.915L1172.14 352.803L1168.32 349.026H1173.04L1174.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 342.914L999.959 349.026H1004.68L1000.86 352.803L1002.32 358.915L998.5 355.138L994.679 358.915L996.139 352.803L992.318 349.026H997.041L998.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 342.914L1351.96 349.026H1356.68L1352.86 352.803L1354.32 358.915L1350.5 355.138L1346.68 358.915L1348.14 352.803L1344.32 349.026H1349.04L1350.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 342.914L713.959 349.026H718.682L714.861 352.803L716.321 358.915L712.5 355.138L708.679 358.915L710.139 352.803L706.318 349.026H711.041L712.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 342.914L1065.96 349.026H1070.68L1066.86 352.803L1068.32 358.915L1064.5 355.138L1060.68 358.915L1062.14 352.803L1058.32 349.026H1063.04L1064.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 342.914L889.959 349.026H894.682L890.861 352.803L892.321 358.915L888.5 355.138L884.679 358.915L886.139 352.803L882.318 349.026H887.041L888.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 342.914L1241.96 349.026H1246.68L1242.86 352.803L1244.32 358.915L1240.5 355.138L1236.68 358.915L1238.14 352.803L1234.32 349.026H1239.04L1240.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 342.914L801.959 349.026H806.682L802.861 352.803L804.321 358.915L800.5 355.138L796.679 358.915L798.139 352.803L794.318 349.026H799.041L800.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 342.914L1153.96 349.026H1158.68L1154.86 352.803L1156.32 358.915L1152.5 355.138L1148.68 358.915L1150.14 352.803L1146.32 349.026H1151.04L1152.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 342.914L977.959 349.026H982.682L978.861 352.803L980.321 358.915L976.5 355.138L972.679 358.915L974.139 352.803L970.318 349.026H975.041L976.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 342.914L1329.96 349.026H1334.68L1330.86 352.803L1332.32 358.915L1328.5 355.138L1324.68 358.915L1326.14 352.803L1322.32 349.026H1327.04L1328.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 342.914L757.959 349.026H762.682L758.861 352.803L760.321 358.915L756.5 355.138L752.679 358.915L754.139 352.803L750.318 349.026H755.041L756.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 342.914L1109.96 349.026H1114.68L1110.86 352.803L1112.32 358.915L1108.5 355.138L1104.68 358.915L1106.14 352.803L1102.32 349.026H1107.04L1108.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 342.914L933.959 349.026H938.682L934.861 352.803L936.321 358.915L932.5 355.138L928.679 358.915L930.139 352.803L926.318 349.026H931.041L932.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 342.914L1285.96 349.026H1290.68L1286.86 352.803L1288.32 358.915L1284.5 355.138L1280.68 358.915L1282.14 352.803L1278.32 349.026H1283.04L1284.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 342.914L845.959 349.026H850.682L846.861 352.803L848.321 358.915L844.5 355.138L840.679 358.915L842.139 352.803L838.318 349.026H843.041L844.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 342.914L1197.96 349.026H1202.68L1198.86 352.803L1200.32 358.915L1196.5 355.138L1192.68 358.915L1194.14 352.803L1190.32 349.026H1195.04L1196.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 342.914L1021.96 349.026H1026.68L1022.86 352.803L1024.32 358.915L1020.5 355.138L1016.68 358.915L1018.14 352.803L1014.32 349.026H1019.04L1020.5 342.914Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 24.4939L691.959 30.6056H696.682L692.861 34.3829L694.321 40.4947L690.5 36.7174L686.679 40.4947L688.139 34.3829L684.318 30.6056H689.041L690.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 24.4939L1043.96 30.6056H1048.68L1044.86 34.3829L1046.32 40.4947L1042.5 36.7174L1038.68 40.4947L1040.14 34.3829L1036.32 30.6056H1041.04L1042.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 24.4939L867.959 30.6056H872.682L868.861 34.3829L870.321 40.4947L866.5 36.7174L862.679 40.4947L864.139 34.3829L860.318 30.6056H865.041L866.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 24.4939L1219.96 30.6056H1224.68L1220.86 34.3829L1222.32 40.4947L1218.5 36.7174L1214.68 40.4947L1216.14 34.3829L1212.32 30.6056H1217.04L1218.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 24.4939L779.959 30.6056H784.682L780.861 34.3829L782.321 40.4947L778.5 36.7174L774.679 40.4947L776.139 34.3829L772.318 30.6056H777.041L778.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 24.4939L1131.96 30.6056H1136.68L1132.86 34.3829L1134.32 40.4947L1130.5 36.7174L1126.68 40.4947L1128.14 34.3829L1124.32 30.6056H1129.04L1130.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 24.4939L955.959 30.6056H960.682L956.861 34.3829L958.321 40.4947L954.5 36.7174L950.679 40.4947L952.139 34.3829L948.318 30.6056H953.041L954.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 24.4939L1307.96 30.6056H1312.68L1308.86 34.3829L1310.32 40.4947L1306.5 36.7174L1302.68 40.4947L1304.14 34.3829L1300.32 30.6056H1305.04L1306.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 24.4939L735.959 30.6056H740.682L736.861 34.3829L738.321 40.4947L734.5 36.7174L730.679 40.4947L732.139 34.3829L728.318 30.6056H733.041L734.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 24.4939L1087.96 30.6056H1092.68L1088.86 34.3829L1090.32 40.4947L1086.5 36.7174L1082.68 40.4947L1084.14 34.3829L1080.32 30.6056H1085.04L1086.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 24.4939L911.959 30.6056H916.682L912.861 34.3829L914.321 40.4947L910.5 36.7174L906.679 40.4947L908.139 34.3829L904.318 30.6056H909.041L910.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 24.4939L1263.96 30.6056H1268.68L1264.86 34.3829L1266.32 40.4947L1262.5 36.7174L1258.68 40.4947L1260.14 34.3829L1256.32 30.6056H1261.04L1262.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 24.4939L823.959 30.6056H828.682L824.861 34.3829L826.321 40.4947L822.5 36.7174L818.679 40.4947L820.139 34.3829L816.318 30.6056H821.041L822.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 24.4939L1175.96 30.6056H1180.68L1176.86 34.3829L1178.32 40.4947L1174.5 36.7174L1170.68 40.4947L1172.14 34.3829L1168.32 30.6056H1173.04L1174.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 24.4939L999.959 30.6056H1004.68L1000.86 34.3829L1002.32 40.4947L998.5 36.7174L994.679 40.4947L996.139 34.3829L992.318 30.6056H997.041L998.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 24.4939L1351.96 30.6056H1356.68L1352.86 34.3829L1354.32 40.4947L1350.5 36.7174L1346.68 40.4947L1348.14 34.3829L1344.32 30.6056H1349.04L1350.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 24.4939L713.959 30.6056H718.682L714.861 34.3829L716.321 40.4947L712.5 36.7174L708.679 40.4947L710.139 34.3829L706.318 30.6056H711.041L712.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 24.4939L1065.96 30.6056H1070.68L1066.86 34.3829L1068.32 40.4947L1064.5 36.7174L1060.68 40.4947L1062.14 34.3829L1058.32 30.6056H1063.04L1064.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 24.4939L889.959 30.6056H894.682L890.861 34.3829L892.321 40.4947L888.5 36.7174L884.679 40.4947L886.139 34.3829L882.318 30.6056H887.041L888.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 24.4939L1241.96 30.6056H1246.68L1242.86 34.3829L1244.32 40.4947L1240.5 36.7174L1236.68 40.4947L1238.14 34.3829L1234.32 30.6056H1239.04L1240.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 24.4939L801.959 30.6056H806.682L802.861 34.3829L804.321 40.4947L800.5 36.7174L796.679 40.4947L798.139 34.3829L794.318 30.6056H799.041L800.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 24.4939L1153.96 30.6056H1158.68L1154.86 34.3829L1156.32 40.4947L1152.5 36.7174L1148.68 40.4947L1150.14 34.3829L1146.32 30.6056H1151.04L1152.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 24.4939L977.959 30.6056H982.682L978.861 34.3829L980.321 40.4947L976.5 36.7174L972.679 40.4947L974.139 34.3829L970.318 30.6056H975.041L976.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 24.4939L1329.96 30.6056H1334.68L1330.86 34.3829L1332.32 40.4947L1328.5 36.7174L1324.68 40.4947L1326.14 34.3829L1322.32 30.6056H1327.04L1328.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 24.4939L757.959 30.6056H762.682L758.861 34.3829L760.321 40.4947L756.5 36.7174L752.679 40.4947L754.139 34.3829L750.318 30.6056H755.041L756.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 24.4939L1109.96 30.6056H1114.68L1110.86 34.3829L1112.32 40.4947L1108.5 36.7174L1104.68 40.4947L1106.14 34.3829L1102.32 30.6056H1107.04L1108.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 24.4939L933.959 30.6056H938.682L934.861 34.3829L936.321 40.4947L932.5 36.7174L928.679 40.4947L930.139 34.3829L926.318 30.6056H931.041L932.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 24.4939L1285.96 30.6056H1290.68L1286.86 34.3829L1288.32 40.4947L1284.5 36.7174L1280.68 40.4947L1282.14 34.3829L1278.32 30.6056H1283.04L1284.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 24.4939L845.959 30.6056H850.682L846.861 34.3829L848.321 40.4947L844.5 36.7174L840.679 40.4947L842.139 34.3829L838.318 30.6056H843.041L844.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 24.4939L1197.96 30.6056H1202.68L1198.86 34.3829L1200.32 40.4947L1196.5 36.7174L1192.68 40.4947L1194.14 34.3829L1190.32 30.6056H1195.04L1196.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 24.4939L1021.96 30.6056H1026.68L1022.86 34.3829L1024.32 40.4947L1020.5 36.7174L1016.68 40.4947L1018.14 34.3829L1014.32 30.6056H1019.04L1020.5 24.4939Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 220.445L691.959 226.557H696.682L692.861 230.334L694.321 236.446L690.5 232.669L686.679 236.446L688.139 230.334L684.318 226.557H689.041L690.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 220.445L1043.96 226.557H1048.68L1044.86 230.334L1046.32 236.446L1042.5 232.669L1038.68 236.446L1040.14 230.334L1036.32 226.557H1041.04L1042.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 220.445L867.959 226.557H872.682L868.861 230.334L870.321 236.446L866.5 232.669L862.679 236.446L864.139 230.334L860.318 226.557H865.041L866.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 220.445L1219.96 226.557H1224.68L1220.86 230.334L1222.32 236.446L1218.5 232.669L1214.68 236.446L1216.14 230.334L1212.32 226.557H1217.04L1218.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 220.445L779.959 226.557H784.682L780.861 230.334L782.321 236.446L778.5 232.669L774.679 236.446L776.139 230.334L772.318 226.557H777.041L778.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 220.445L1131.96 226.557H1136.68L1132.86 230.334L1134.32 236.446L1130.5 232.669L1126.68 236.446L1128.14 230.334L1124.32 226.557H1129.04L1130.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 220.445L955.959 226.557H960.682L956.861 230.334L958.321 236.446L954.5 232.669L950.679 236.446L952.139 230.334L948.318 226.557H953.041L954.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 220.445L1307.96 226.557H1312.68L1308.86 230.334L1310.32 236.446L1306.5 232.669L1302.68 236.446L1304.14 230.334L1300.32 226.557H1305.04L1306.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 220.445L735.959 226.557H740.682L736.861 230.334L738.321 236.446L734.5 232.669L730.679 236.446L732.139 230.334L728.318 226.557H733.041L734.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 220.445L1087.96 226.557H1092.68L1088.86 230.334L1090.32 236.446L1086.5 232.669L1082.68 236.446L1084.14 230.334L1080.32 226.557H1085.04L1086.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 220.445L911.959 226.557H916.682L912.861 230.334L914.321 236.446L910.5 232.669L906.679 236.446L908.139 230.334L904.318 226.557H909.041L910.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 220.445L1263.96 226.557H1268.68L1264.86 230.334L1266.32 236.446L1262.5 232.669L1258.68 236.446L1260.14 230.334L1256.32 226.557H1261.04L1262.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 220.445L823.959 226.557H828.682L824.861 230.334L826.321 236.446L822.5 232.669L818.679 236.446L820.139 230.334L816.318 226.557H821.041L822.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 220.445L1175.96 226.557H1180.68L1176.86 230.334L1178.32 236.446L1174.5 232.669L1170.68 236.446L1172.14 230.334L1168.32 226.557H1173.04L1174.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 220.445L999.959 226.557H1004.68L1000.86 230.334L1002.32 236.446L998.5 232.669L994.679 236.446L996.139 230.334L992.318 226.557H997.041L998.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 220.445L1351.96 226.557H1356.68L1352.86 230.334L1354.32 236.446L1350.5 232.669L1346.68 236.446L1348.14 230.334L1344.32 226.557H1349.04L1350.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 220.445L713.959 226.557H718.682L714.861 230.334L716.321 236.446L712.5 232.669L708.679 236.446L710.139 230.334L706.318 226.557H711.041L712.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 220.445L1065.96 226.557H1070.68L1066.86 230.334L1068.32 236.446L1064.5 232.669L1060.68 236.446L1062.14 230.334L1058.32 226.557H1063.04L1064.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 220.445L889.959 226.557H894.682L890.861 230.334L892.321 236.446L888.5 232.669L884.679 236.446L886.139 230.334L882.318 226.557H887.041L888.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 220.445L1241.96 226.557H1246.68L1242.86 230.334L1244.32 236.446L1240.5 232.669L1236.68 236.446L1238.14 230.334L1234.32 226.557H1239.04L1240.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 220.445L801.959 226.557H806.682L802.861 230.334L804.321 236.446L800.5 232.669L796.679 236.446L798.139 230.334L794.318 226.557H799.041L800.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 220.445L1153.96 226.557H1158.68L1154.86 230.334L1156.32 236.446L1152.5 232.669L1148.68 236.446L1150.14 230.334L1146.32 226.557H1151.04L1152.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 220.445L977.959 226.557H982.682L978.861 230.334L980.321 236.446L976.5 232.669L972.679 236.446L974.139 230.334L970.318 226.557H975.041L976.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 220.445L1329.96 226.557H1334.68L1330.86 230.334L1332.32 236.446L1328.5 232.669L1324.68 236.446L1326.14 230.334L1322.32 226.557H1327.04L1328.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 220.445L757.959 226.557H762.682L758.861 230.334L760.321 236.446L756.5 232.669L752.679 236.446L754.139 230.334L750.318 226.557H755.041L756.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 220.445L1109.96 226.557H1114.68L1110.86 230.334L1112.32 236.446L1108.5 232.669L1104.68 236.446L1106.14 230.334L1102.32 226.557H1107.04L1108.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 220.445L933.959 226.557H938.682L934.861 230.334L936.321 236.446L932.5 232.669L928.679 236.446L930.139 230.334L926.318 226.557H931.041L932.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 220.445L1285.96 226.557H1290.68L1286.86 230.334L1288.32 236.446L1284.5 232.669L1280.68 236.446L1282.14 230.334L1278.32 226.557H1283.04L1284.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 220.445L845.959 226.557H850.682L846.861 230.334L848.321 236.446L844.5 232.669L840.679 236.446L842.139 230.334L838.318 226.557H843.041L844.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 220.445L1197.96 226.557H1202.68L1198.86 230.334L1200.32 236.446L1196.5 232.669L1192.68 236.446L1194.14 230.334L1190.32 226.557H1195.04L1196.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 220.445L1021.96 226.557H1026.68L1022.86 230.334L1024.32 236.446L1020.5 232.669L1016.68 236.446L1018.14 230.334L1014.32 226.557H1019.04L1020.5 220.445Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 122.469L691.959 128.581H696.682L692.861 132.358L694.321 138.47L690.5 134.693L686.679 138.47L688.139 132.358L684.318 128.581H689.041L690.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 122.469L1043.96 128.581H1048.68L1044.86 132.358L1046.32 138.47L1042.5 134.693L1038.68 138.47L1040.14 132.358L1036.32 128.581H1041.04L1042.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 122.469L867.959 128.581H872.682L868.861 132.358L870.321 138.47L866.5 134.693L862.679 138.47L864.139 132.358L860.318 128.581H865.041L866.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 122.469L1219.96 128.581H1224.68L1220.86 132.358L1222.32 138.47L1218.5 134.693L1214.68 138.47L1216.14 132.358L1212.32 128.581H1217.04L1218.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 122.469L779.959 128.581H784.682L780.861 132.358L782.321 138.47L778.5 134.693L774.679 138.47L776.139 132.358L772.318 128.581H777.041L778.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 122.469L1131.96 128.581H1136.68L1132.86 132.358L1134.32 138.47L1130.5 134.693L1126.68 138.47L1128.14 132.358L1124.32 128.581H1129.04L1130.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 122.469L955.959 128.581H960.682L956.861 132.358L958.321 138.47L954.5 134.693L950.679 138.47L952.139 132.358L948.318 128.581H953.041L954.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 122.469L1307.96 128.581H1312.68L1308.86 132.358L1310.32 138.47L1306.5 134.693L1302.68 138.47L1304.14 132.358L1300.32 128.581H1305.04L1306.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 122.469L735.959 128.581H740.682L736.861 132.358L738.321 138.47L734.5 134.693L730.679 138.47L732.139 132.358L728.318 128.581H733.041L734.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 122.469L1087.96 128.581H1092.68L1088.86 132.358L1090.32 138.47L1086.5 134.693L1082.68 138.47L1084.14 132.358L1080.32 128.581H1085.04L1086.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 122.469L911.959 128.581H916.682L912.861 132.358L914.321 138.47L910.5 134.693L906.679 138.47L908.139 132.358L904.318 128.581H909.041L910.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 122.469L1263.96 128.581H1268.68L1264.86 132.358L1266.32 138.47L1262.5 134.693L1258.68 138.47L1260.14 132.358L1256.32 128.581H1261.04L1262.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 122.469L823.959 128.581H828.682L824.861 132.358L826.321 138.47L822.5 134.693L818.679 138.47L820.139 132.358L816.318 128.581H821.041L822.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 122.469L1175.96 128.581H1180.68L1176.86 132.358L1178.32 138.47L1174.5 134.693L1170.68 138.47L1172.14 132.358L1168.32 128.581H1173.04L1174.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 122.469L999.959 128.581H1004.68L1000.86 132.358L1002.32 138.47L998.5 134.693L994.679 138.47L996.139 132.358L992.318 128.581H997.041L998.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 122.469L1351.96 128.581H1356.68L1352.86 132.358L1354.32 138.47L1350.5 134.693L1346.68 138.47L1348.14 132.358L1344.32 128.581H1349.04L1350.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 122.469L713.959 128.581H718.682L714.861 132.358L716.321 138.47L712.5 134.693L708.679 138.47L710.139 132.358L706.318 128.581H711.041L712.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 122.469L1065.96 128.581H1070.68L1066.86 132.358L1068.32 138.47L1064.5 134.693L1060.68 138.47L1062.14 132.358L1058.32 128.581H1063.04L1064.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 122.469L889.959 128.581H894.682L890.861 132.358L892.321 138.47L888.5 134.693L884.679 138.47L886.139 132.358L882.318 128.581H887.041L888.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 122.469L1241.96 128.581H1246.68L1242.86 132.358L1244.32 138.47L1240.5 134.693L1236.68 138.47L1238.14 132.358L1234.32 128.581H1239.04L1240.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 122.469L801.959 128.581H806.682L802.861 132.358L804.321 138.47L800.5 134.693L796.679 138.47L798.139 132.358L794.318 128.581H799.041L800.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 122.469L1153.96 128.581H1158.68L1154.86 132.358L1156.32 138.47L1152.5 134.693L1148.68 138.47L1150.14 132.358L1146.32 128.581H1151.04L1152.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 122.469L977.959 128.581H982.682L978.861 132.358L980.321 138.47L976.5 134.693L972.679 138.47L974.139 132.358L970.318 128.581H975.041L976.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 122.469L1329.96 128.581H1334.68L1330.86 132.358L1332.32 138.47L1328.5 134.693L1324.68 138.47L1326.14 132.358L1322.32 128.581H1327.04L1328.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 122.469L757.959 128.581H762.682L758.861 132.358L760.321 138.47L756.5 134.693L752.679 138.47L754.139 132.358L750.318 128.581H755.041L756.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 122.469L1109.96 128.581H1114.68L1110.86 132.358L1112.32 138.47L1108.5 134.693L1104.68 138.47L1106.14 132.358L1102.32 128.581H1107.04L1108.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 122.469L933.959 128.581H938.682L934.861 132.358L936.321 138.47L932.5 134.693L928.679 138.47L930.139 132.358L926.318 128.581H931.041L932.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 122.469L1285.96 128.581H1290.68L1286.86 132.358L1288.32 138.47L1284.5 134.693L1280.68 138.47L1282.14 132.358L1278.32 128.581H1283.04L1284.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 122.469L845.959 128.581H850.682L846.861 132.358L848.321 138.47L844.5 134.693L840.679 138.47L842.139 132.358L838.318 128.581H843.041L844.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 122.469L1197.96 128.581H1202.68L1198.86 132.358L1200.32 138.47L1196.5 134.693L1192.68 138.47L1194.14 132.358L1190.32 128.581H1195.04L1196.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 122.469L1021.96 128.581H1026.68L1022.86 132.358L1024.32 138.47L1020.5 134.693L1016.68 138.47L1018.14 132.358L1014.32 128.581H1019.04L1020.5 122.469Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 318.42L691.959 324.532H696.682L692.861 328.309L694.321 334.421L690.5 330.644L686.679 334.421L688.139 328.309L684.318 324.532H689.041L690.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 318.42L1043.96 324.532H1048.68L1044.86 328.309L1046.32 334.421L1042.5 330.644L1038.68 334.421L1040.14 328.309L1036.32 324.532H1041.04L1042.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 318.42L867.959 324.532H872.682L868.861 328.309L870.321 334.421L866.5 330.644L862.679 334.421L864.139 328.309L860.318 324.532H865.041L866.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 318.42L1219.96 324.532H1224.68L1220.86 328.309L1222.32 334.421L1218.5 330.644L1214.68 334.421L1216.14 328.309L1212.32 324.532H1217.04L1218.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 318.42L779.959 324.532H784.682L780.861 328.309L782.321 334.421L778.5 330.644L774.679 334.421L776.139 328.309L772.318 324.532H777.041L778.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 318.42L1131.96 324.532H1136.68L1132.86 328.309L1134.32 334.421L1130.5 330.644L1126.68 334.421L1128.14 328.309L1124.32 324.532H1129.04L1130.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 318.42L955.959 324.532H960.682L956.861 328.309L958.321 334.421L954.5 330.644L950.679 334.421L952.139 328.309L948.318 324.532H953.041L954.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 318.42L1307.96 324.532H1312.68L1308.86 328.309L1310.32 334.421L1306.5 330.644L1302.68 334.421L1304.14 328.309L1300.32 324.532H1305.04L1306.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 318.42L735.959 324.532H740.682L736.861 328.309L738.321 334.421L734.5 330.644L730.679 334.421L732.139 328.309L728.318 324.532H733.041L734.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 318.42L1087.96 324.532H1092.68L1088.86 328.309L1090.32 334.421L1086.5 330.644L1082.68 334.421L1084.14 328.309L1080.32 324.532H1085.04L1086.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 318.42L911.959 324.532H916.682L912.861 328.309L914.321 334.421L910.5 330.644L906.679 334.421L908.139 328.309L904.318 324.532H909.041L910.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 318.42L1263.96 324.532H1268.68L1264.86 328.309L1266.32 334.421L1262.5 330.644L1258.68 334.421L1260.14 328.309L1256.32 324.532H1261.04L1262.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 318.42L823.959 324.532H828.682L824.861 328.309L826.321 334.421L822.5 330.644L818.679 334.421L820.139 328.309L816.318 324.532H821.041L822.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 318.42L1175.96 324.532H1180.68L1176.86 328.309L1178.32 334.421L1174.5 330.644L1170.68 334.421L1172.14 328.309L1168.32 324.532H1173.04L1174.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 318.42L999.959 324.532H1004.68L1000.86 328.309L1002.32 334.421L998.5 330.644L994.679 334.421L996.139 328.309L992.318 324.532H997.041L998.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 318.42L1351.96 324.532H1356.68L1352.86 328.309L1354.32 334.421L1350.5 330.644L1346.68 334.421L1348.14 328.309L1344.32 324.532H1349.04L1350.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 318.42L713.959 324.532H718.682L714.861 328.309L716.321 334.421L712.5 330.644L708.679 334.421L710.139 328.309L706.318 324.532H711.041L712.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 318.42L1065.96 324.532H1070.68L1066.86 328.309L1068.32 334.421L1064.5 330.644L1060.68 334.421L1062.14 328.309L1058.32 324.532H1063.04L1064.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 318.42L889.959 324.532H894.682L890.861 328.309L892.321 334.421L888.5 330.644L884.679 334.421L886.139 328.309L882.318 324.532H887.041L888.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 318.42L1241.96 324.532H1246.68L1242.86 328.309L1244.32 334.421L1240.5 330.644L1236.68 334.421L1238.14 328.309L1234.32 324.532H1239.04L1240.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 318.42L801.959 324.532H806.682L802.861 328.309L804.321 334.421L800.5 330.644L796.679 334.421L798.139 328.309L794.318 324.532H799.041L800.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 318.42L1153.96 324.532H1158.68L1154.86 328.309L1156.32 334.421L1152.5 330.644L1148.68 334.421L1150.14 328.309L1146.32 324.532H1151.04L1152.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 318.42L977.959 324.532H982.682L978.861 328.309L980.321 334.421L976.5 330.644L972.679 334.421L974.139 328.309L970.318 324.532H975.041L976.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 318.42L1329.96 324.532H1334.68L1330.86 328.309L1332.32 334.421L1328.5 330.644L1324.68 334.421L1326.14 328.309L1322.32 324.532H1327.04L1328.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 318.42L757.959 324.532H762.682L758.861 328.309L760.321 334.421L756.5 330.644L752.679 334.421L754.139 328.309L750.318 324.532H755.041L756.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 318.42L1109.96 324.532H1114.68L1110.86 328.309L1112.32 334.421L1108.5 330.644L1104.68 334.421L1106.14 328.309L1102.32 324.532H1107.04L1108.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 318.42L933.959 324.532H938.682L934.861 328.309L936.321 334.421L932.5 330.644L928.679 334.421L930.139 328.309L926.318 324.532H931.041L932.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 318.42L1285.96 324.532H1290.68L1286.86 328.309L1288.32 334.421L1284.5 330.644L1280.68 334.421L1282.14 328.309L1278.32 324.532H1283.04L1284.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 318.42L845.959 324.532H850.682L846.861 328.309L848.321 334.421L844.5 330.644L840.679 334.421L842.139 328.309L838.318 324.532H843.041L844.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 318.42L1197.96 324.532H1202.68L1198.86 328.309L1200.32 334.421L1196.5 330.644L1192.68 334.421L1194.14 328.309L1190.32 324.532H1195.04L1196.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 318.42L1021.96 324.532H1026.68L1022.86 328.309L1024.32 334.421L1020.5 330.644L1016.68 334.421L1018.14 328.309L1014.32 324.532H1019.04L1020.5 318.42Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 73.4814L691.959 79.5932H696.682L692.861 83.3705L694.321 89.4822L690.5 85.7049L686.679 89.4822L688.139 83.3705L684.318 79.5932H689.041L690.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 73.4814L1043.96 79.5932H1048.68L1044.86 83.3705L1046.32 89.4822L1042.5 85.7049L1038.68 89.4822L1040.14 83.3705L1036.32 79.5932H1041.04L1042.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 73.4814L867.959 79.5932H872.682L868.861 83.3705L870.321 89.4822L866.5 85.7049L862.679 89.4822L864.139 83.3705L860.318 79.5932H865.041L866.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 73.4814L1219.96 79.5932H1224.68L1220.86 83.3705L1222.32 89.4822L1218.5 85.7049L1214.68 89.4822L1216.14 83.3705L1212.32 79.5932H1217.04L1218.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 73.4814L779.959 79.5932H784.682L780.861 83.3705L782.321 89.4822L778.5 85.7049L774.679 89.4822L776.139 83.3705L772.318 79.5932H777.041L778.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 73.4814L1131.96 79.5932H1136.68L1132.86 83.3705L1134.32 89.4822L1130.5 85.7049L1126.68 89.4822L1128.14 83.3705L1124.32 79.5932H1129.04L1130.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 73.4814L955.959 79.5932H960.682L956.861 83.3705L958.321 89.4822L954.5 85.7049L950.679 89.4822L952.139 83.3705L948.318 79.5932H953.041L954.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 73.4814L1307.96 79.5932H1312.68L1308.86 83.3705L1310.32 89.4822L1306.5 85.7049L1302.68 89.4822L1304.14 83.3705L1300.32 79.5932H1305.04L1306.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 73.4814L735.959 79.5932H740.682L736.861 83.3705L738.321 89.4822L734.5 85.7049L730.679 89.4822L732.139 83.3705L728.318 79.5932H733.041L734.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 73.4814L1087.96 79.5932H1092.68L1088.86 83.3705L1090.32 89.4822L1086.5 85.7049L1082.68 89.4822L1084.14 83.3705L1080.32 79.5932H1085.04L1086.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 73.4814L911.959 79.5932H916.682L912.861 83.3705L914.321 89.4822L910.5 85.7049L906.679 89.4822L908.139 83.3705L904.318 79.5932H909.041L910.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 73.4814L1263.96 79.5932H1268.68L1264.86 83.3705L1266.32 89.4822L1262.5 85.7049L1258.68 89.4822L1260.14 83.3705L1256.32 79.5932H1261.04L1262.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 73.4814L823.959 79.5932H828.682L824.861 83.3705L826.321 89.4822L822.5 85.7049L818.679 89.4822L820.139 83.3705L816.318 79.5932H821.041L822.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 73.4814L1175.96 79.5932H1180.68L1176.86 83.3705L1178.32 89.4822L1174.5 85.7049L1170.68 89.4822L1172.14 83.3705L1168.32 79.5932H1173.04L1174.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 73.4814L999.959 79.5932H1004.68L1000.86 83.3705L1002.32 89.4822L998.5 85.7049L994.679 89.4822L996.139 83.3705L992.318 79.5932H997.041L998.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 73.4814L1351.96 79.5932H1356.68L1352.86 83.3705L1354.32 89.4822L1350.5 85.7049L1346.68 89.4822L1348.14 83.3705L1344.32 79.5932H1349.04L1350.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 73.4814L713.959 79.5932H718.682L714.861 83.3705L716.321 89.4822L712.5 85.7049L708.679 89.4822L710.139 83.3705L706.318 79.5932H711.041L712.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 73.4814L1065.96 79.5932H1070.68L1066.86 83.3705L1068.32 89.4822L1064.5 85.7049L1060.68 89.4822L1062.14 83.3705L1058.32 79.5932H1063.04L1064.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 73.4814L889.959 79.5932H894.682L890.861 83.3705L892.321 89.4822L888.5 85.7049L884.679 89.4822L886.139 83.3705L882.318 79.5932H887.041L888.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 73.4814L1241.96 79.5932H1246.68L1242.86 83.3705L1244.32 89.4822L1240.5 85.7049L1236.68 89.4822L1238.14 83.3705L1234.32 79.5932H1239.04L1240.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 73.4814L801.959 79.5932H806.682L802.861 83.3705L804.321 89.4822L800.5 85.7049L796.679 89.4822L798.139 83.3705L794.318 79.5932H799.041L800.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 73.4814L1153.96 79.5932H1158.68L1154.86 83.3705L1156.32 89.4822L1152.5 85.7049L1148.68 89.4822L1150.14 83.3705L1146.32 79.5932H1151.04L1152.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 73.4814L977.959 79.5932H982.682L978.861 83.3705L980.321 89.4822L976.5 85.7049L972.679 89.4822L974.139 83.3705L970.318 79.5932H975.041L976.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 73.4814L1329.96 79.5932H1334.68L1330.86 83.3705L1332.32 89.4822L1328.5 85.7049L1324.68 89.4822L1326.14 83.3705L1322.32 79.5932H1327.04L1328.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 73.4814L757.959 79.5932H762.682L758.861 83.3705L760.321 89.4822L756.5 85.7049L752.679 89.4822L754.139 83.3705L750.318 79.5932H755.041L756.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 73.4814L1109.96 79.5932H1114.68L1110.86 83.3705L1112.32 89.4822L1108.5 85.7049L1104.68 89.4822L1106.14 83.3705L1102.32 79.5932H1107.04L1108.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 73.4814L933.959 79.5932H938.682L934.861 83.3705L936.321 89.4822L932.5 85.7049L928.679 89.4822L930.139 83.3705L926.318 79.5932H931.041L932.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 73.4814L1285.96 79.5932H1290.68L1286.86 83.3705L1288.32 89.4822L1284.5 85.7049L1280.68 89.4822L1282.14 83.3705L1278.32 79.5932H1283.04L1284.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 73.4814L845.959 79.5932H850.682L846.861 83.3705L848.321 89.4822L844.5 85.7049L840.679 89.4822L842.139 83.3705L838.318 79.5932H843.041L844.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 73.4814L1197.96 79.5932H1202.68L1198.86 83.3705L1200.32 89.4822L1196.5 85.7049L1192.68 89.4822L1194.14 83.3705L1190.32 79.5932H1195.04L1196.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 73.4814L1021.96 79.5932H1026.68L1022.86 83.3705L1024.32 89.4822L1020.5 85.7049L1016.68 89.4822L1018.14 83.3705L1014.32 79.5932H1019.04L1020.5 73.4814Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 269.433L691.959 275.544H696.682L692.861 279.322L694.321 285.433L690.5 281.656L686.679 285.433L688.139 279.322L684.318 275.544H689.041L690.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 269.433L1043.96 275.544H1048.68L1044.86 279.322L1046.32 285.433L1042.5 281.656L1038.68 285.433L1040.14 279.322L1036.32 275.544H1041.04L1042.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 269.433L867.959 275.544H872.682L868.861 279.322L870.321 285.433L866.5 281.656L862.679 285.433L864.139 279.322L860.318 275.544H865.041L866.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 269.433L1219.96 275.544H1224.68L1220.86 279.322L1222.32 285.433L1218.5 281.656L1214.68 285.433L1216.14 279.322L1212.32 275.544H1217.04L1218.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 269.433L779.959 275.544H784.682L780.861 279.322L782.321 285.433L778.5 281.656L774.679 285.433L776.139 279.322L772.318 275.544H777.041L778.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 269.433L1131.96 275.544H1136.68L1132.86 279.322L1134.32 285.433L1130.5 281.656L1126.68 285.433L1128.14 279.322L1124.32 275.544H1129.04L1130.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 269.433L955.959 275.544H960.682L956.861 279.322L958.321 285.433L954.5 281.656L950.679 285.433L952.139 279.322L948.318 275.544H953.041L954.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 269.433L1307.96 275.544H1312.68L1308.86 279.322L1310.32 285.433L1306.5 281.656L1302.68 285.433L1304.14 279.322L1300.32 275.544H1305.04L1306.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 269.433L735.959 275.544H740.682L736.861 279.322L738.321 285.433L734.5 281.656L730.679 285.433L732.139 279.322L728.318 275.544H733.041L734.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 269.433L1087.96 275.544H1092.68L1088.86 279.322L1090.32 285.433L1086.5 281.656L1082.68 285.433L1084.14 279.322L1080.32 275.544H1085.04L1086.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 269.433L911.959 275.544H916.682L912.861 279.322L914.321 285.433L910.5 281.656L906.679 285.433L908.139 279.322L904.318 275.544H909.041L910.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 269.433L1263.96 275.544H1268.68L1264.86 279.322L1266.32 285.433L1262.5 281.656L1258.68 285.433L1260.14 279.322L1256.32 275.544H1261.04L1262.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 269.433L823.959 275.544H828.682L824.861 279.322L826.321 285.433L822.5 281.656L818.679 285.433L820.139 279.322L816.318 275.544H821.041L822.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 269.433L1175.96 275.544H1180.68L1176.86 279.322L1178.32 285.433L1174.5 281.656L1170.68 285.433L1172.14 279.322L1168.32 275.544H1173.04L1174.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 269.433L999.959 275.544H1004.68L1000.86 279.322L1002.32 285.433L998.5 281.656L994.679 285.433L996.139 279.322L992.318 275.544H997.041L998.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 269.433L1351.96 275.544H1356.68L1352.86 279.322L1354.32 285.433L1350.5 281.656L1346.68 285.433L1348.14 279.322L1344.32 275.544H1349.04L1350.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 269.433L713.959 275.544H718.682L714.861 279.322L716.321 285.433L712.5 281.656L708.679 285.433L710.139 279.322L706.318 275.544H711.041L712.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 269.433L1065.96 275.544H1070.68L1066.86 279.322L1068.32 285.433L1064.5 281.656L1060.68 285.433L1062.14 279.322L1058.32 275.544H1063.04L1064.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 269.433L889.959 275.544H894.682L890.861 279.322L892.321 285.433L888.5 281.656L884.679 285.433L886.139 279.322L882.318 275.544H887.041L888.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 269.433L1241.96 275.544H1246.68L1242.86 279.322L1244.32 285.433L1240.5 281.656L1236.68 285.433L1238.14 279.322L1234.32 275.544H1239.04L1240.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 269.433L801.959 275.544H806.682L802.861 279.322L804.321 285.433L800.5 281.656L796.679 285.433L798.139 279.322L794.318 275.544H799.041L800.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 269.433L1153.96 275.544H1158.68L1154.86 279.322L1156.32 285.433L1152.5 281.656L1148.68 285.433L1150.14 279.322L1146.32 275.544H1151.04L1152.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 269.433L977.959 275.544H982.682L978.861 279.322L980.321 285.433L976.5 281.656L972.679 285.433L974.139 279.322L970.318 275.544H975.041L976.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 269.433L1329.96 275.544H1334.68L1330.86 279.322L1332.32 285.433L1328.5 281.656L1324.68 285.433L1326.14 279.322L1322.32 275.544H1327.04L1328.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 269.433L757.959 275.544H762.682L758.861 279.322L760.321 285.433L756.5 281.656L752.679 285.433L754.139 279.322L750.318 275.544H755.041L756.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 269.433L1109.96 275.544H1114.68L1110.86 279.322L1112.32 285.433L1108.5 281.656L1104.68 285.433L1106.14 279.322L1102.32 275.544H1107.04L1108.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 269.433L933.959 275.544H938.682L934.861 279.322L936.321 285.433L932.5 281.656L928.679 285.433L930.139 279.322L926.318 275.544H931.041L932.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 269.433L1285.96 275.544H1290.68L1286.86 279.322L1288.32 285.433L1284.5 281.656L1280.68 285.433L1282.14 279.322L1278.32 275.544H1283.04L1284.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 269.433L845.959 275.544H850.682L846.861 279.322L848.321 285.433L844.5 281.656L840.679 285.433L842.139 279.322L838.318 275.544H843.041L844.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 269.433L1197.96 275.544H1202.68L1198.86 279.322L1200.32 285.433L1196.5 281.656L1192.68 285.433L1194.14 279.322L1190.32 275.544H1195.04L1196.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 269.433L1021.96 275.544H1026.68L1022.86 279.322L1024.32 285.433L1020.5 281.656L1016.68 285.433L1018.14 279.322L1014.32 275.544H1019.04L1020.5 269.433Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 171.457L691.959 177.569H696.682L692.861 181.346L694.321 187.458L690.5 183.681L686.679 187.458L688.139 181.346L684.318 177.569H689.041L690.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 171.457L1043.96 177.569H1048.68L1044.86 181.346L1046.32 187.458L1042.5 183.681L1038.68 187.458L1040.14 181.346L1036.32 177.569H1041.04L1042.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 171.457L867.959 177.569H872.682L868.861 181.346L870.321 187.458L866.5 183.681L862.679 187.458L864.139 181.346L860.318 177.569H865.041L866.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 171.457L1219.96 177.569H1224.68L1220.86 181.346L1222.32 187.458L1218.5 183.681L1214.68 187.458L1216.14 181.346L1212.32 177.569H1217.04L1218.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 171.457L779.959 177.569H784.682L780.861 181.346L782.321 187.458L778.5 183.681L774.679 187.458L776.139 181.346L772.318 177.569H777.041L778.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 171.457L1131.96 177.569H1136.68L1132.86 181.346L1134.32 187.458L1130.5 183.681L1126.68 187.458L1128.14 181.346L1124.32 177.569H1129.04L1130.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 171.457L955.959 177.569H960.682L956.861 181.346L958.321 187.458L954.5 183.681L950.679 187.458L952.139 181.346L948.318 177.569H953.041L954.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 171.457L1307.96 177.569H1312.68L1308.86 181.346L1310.32 187.458L1306.5 183.681L1302.68 187.458L1304.14 181.346L1300.32 177.569H1305.04L1306.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 171.457L735.959 177.569H740.682L736.861 181.346L738.321 187.458L734.5 183.681L730.679 187.458L732.139 181.346L728.318 177.569H733.041L734.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 171.457L1087.96 177.569H1092.68L1088.86 181.346L1090.32 187.458L1086.5 183.681L1082.68 187.458L1084.14 181.346L1080.32 177.569H1085.04L1086.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 171.457L911.959 177.569H916.682L912.861 181.346L914.321 187.458L910.5 183.681L906.679 187.458L908.139 181.346L904.318 177.569H909.041L910.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 171.457L1263.96 177.569H1268.68L1264.86 181.346L1266.32 187.458L1262.5 183.681L1258.68 187.458L1260.14 181.346L1256.32 177.569H1261.04L1262.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 171.457L823.959 177.569H828.682L824.861 181.346L826.321 187.458L822.5 183.681L818.679 187.458L820.139 181.346L816.318 177.569H821.041L822.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 171.457L1175.96 177.569H1180.68L1176.86 181.346L1178.32 187.458L1174.5 183.681L1170.68 187.458L1172.14 181.346L1168.32 177.569H1173.04L1174.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 171.457L999.959 177.569H1004.68L1000.86 181.346L1002.32 187.458L998.5 183.681L994.679 187.458L996.139 181.346L992.318 177.569H997.041L998.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 171.457L1351.96 177.569H1356.68L1352.86 181.346L1354.32 187.458L1350.5 183.681L1346.68 187.458L1348.14 181.346L1344.32 177.569H1349.04L1350.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 171.457L713.959 177.569H718.682L714.861 181.346L716.321 187.458L712.5 183.681L708.679 187.458L710.139 181.346L706.318 177.569H711.041L712.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 171.457L1065.96 177.569H1070.68L1066.86 181.346L1068.32 187.458L1064.5 183.681L1060.68 187.458L1062.14 181.346L1058.32 177.569H1063.04L1064.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 171.457L889.959 177.569H894.682L890.861 181.346L892.321 187.458L888.5 183.681L884.679 187.458L886.139 181.346L882.318 177.569H887.041L888.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 171.457L1241.96 177.569H1246.68L1242.86 181.346L1244.32 187.458L1240.5 183.681L1236.68 187.458L1238.14 181.346L1234.32 177.569H1239.04L1240.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 171.457L801.959 177.569H806.682L802.861 181.346L804.321 187.458L800.5 183.681L796.679 187.458L798.139 181.346L794.318 177.569H799.041L800.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 171.457L1153.96 177.569H1158.68L1154.86 181.346L1156.32 187.458L1152.5 183.681L1148.68 187.458L1150.14 181.346L1146.32 177.569H1151.04L1152.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 171.457L977.959 177.569H982.682L978.861 181.346L980.321 187.458L976.5 183.681L972.679 187.458L974.139 181.346L970.318 177.569H975.041L976.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 171.457L1329.96 177.569H1334.68L1330.86 181.346L1332.32 187.458L1328.5 183.681L1324.68 187.458L1326.14 181.346L1322.32 177.569H1327.04L1328.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 171.457L757.959 177.569H762.682L758.861 181.346L760.321 187.458L756.5 183.681L752.679 187.458L754.139 181.346L750.318 177.569H755.041L756.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 171.457L1109.96 177.569H1114.68L1110.86 181.346L1112.32 187.458L1108.5 183.681L1104.68 187.458L1106.14 181.346L1102.32 177.569H1107.04L1108.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 171.457L933.959 177.569H938.682L934.861 181.346L936.321 187.458L932.5 183.681L928.679 187.458L930.139 181.346L926.318 177.569H931.041L932.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 171.457L1285.96 177.569H1290.68L1286.86 181.346L1288.32 187.458L1284.5 183.681L1280.68 187.458L1282.14 181.346L1278.32 177.569H1283.04L1284.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 171.457L845.959 177.569H850.682L846.861 181.346L848.321 187.458L844.5 183.681L840.679 187.458L842.139 181.346L838.318 177.569H843.041L844.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 171.457L1197.96 177.569H1202.68L1198.86 181.346L1200.32 187.458L1196.5 183.681L1192.68 187.458L1194.14 181.346L1190.32 177.569H1195.04L1196.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 171.457L1021.96 177.569H1026.68L1022.86 181.346L1024.32 187.458L1020.5 183.681L1016.68 187.458L1018.14 181.346L1014.32 177.569H1019.04L1020.5 171.457Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 367.408L691.959 373.52H696.682L692.861 377.297L694.321 383.409L690.5 379.631L686.679 383.409L688.139 377.297L684.318 373.52H689.041L690.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 367.408L1043.96 373.52H1048.68L1044.86 377.297L1046.32 383.409L1042.5 379.631L1038.68 383.409L1040.14 377.297L1036.32 373.52H1041.04L1042.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 367.408L867.959 373.52H872.682L868.861 377.297L870.321 383.409L866.5 379.631L862.679 383.409L864.139 377.297L860.318 373.52H865.041L866.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 367.408L1219.96 373.52H1224.68L1220.86 377.297L1222.32 383.409L1218.5 379.631L1214.68 383.409L1216.14 377.297L1212.32 373.52H1217.04L1218.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 367.408L779.959 373.52H784.682L780.861 377.297L782.321 383.409L778.5 379.631L774.679 383.409L776.139 377.297L772.318 373.52H777.041L778.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 367.408L1131.96 373.52H1136.68L1132.86 377.297L1134.32 383.409L1130.5 379.631L1126.68 383.409L1128.14 377.297L1124.32 373.52H1129.04L1130.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 367.408L955.959 373.52H960.682L956.861 377.297L958.321 383.409L954.5 379.631L950.679 383.409L952.139 377.297L948.318 373.52H953.041L954.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 367.408L1307.96 373.52H1312.68L1308.86 377.297L1310.32 383.409L1306.5 379.631L1302.68 383.409L1304.14 377.297L1300.32 373.52H1305.04L1306.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 367.408L735.959 373.52H740.682L736.861 377.297L738.321 383.409L734.5 379.631L730.679 383.409L732.139 377.297L728.318 373.52H733.041L734.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 367.408L1087.96 373.52H1092.68L1088.86 377.297L1090.32 383.409L1086.5 379.631L1082.68 383.409L1084.14 377.297L1080.32 373.52H1085.04L1086.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 367.408L911.959 373.52H916.682L912.861 377.297L914.321 383.409L910.5 379.631L906.679 383.409L908.139 377.297L904.318 373.52H909.041L910.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 367.408L1263.96 373.52H1268.68L1264.86 377.297L1266.32 383.409L1262.5 379.631L1258.68 383.409L1260.14 377.297L1256.32 373.52H1261.04L1262.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 367.408L823.959 373.52H828.682L824.861 377.297L826.321 383.409L822.5 379.631L818.679 383.409L820.139 377.297L816.318 373.52H821.041L822.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 367.408L1175.96 373.52H1180.68L1176.86 377.297L1178.32 383.409L1174.5 379.631L1170.68 383.409L1172.14 377.297L1168.32 373.52H1173.04L1174.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 367.408L999.959 373.52H1004.68L1000.86 377.297L1002.32 383.409L998.5 379.631L994.679 383.409L996.139 377.297L992.318 373.52H997.041L998.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 367.408L1351.96 373.52H1356.68L1352.86 377.297L1354.32 383.409L1350.5 379.631L1346.68 383.409L1348.14 377.297L1344.32 373.52H1349.04L1350.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 367.408L713.959 373.52H718.682L714.861 377.297L716.321 383.409L712.5 379.631L708.679 383.409L710.139 377.297L706.318 373.52H711.041L712.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 367.408L1065.96 373.52H1070.68L1066.86 377.297L1068.32 383.409L1064.5 379.631L1060.68 383.409L1062.14 377.297L1058.32 373.52H1063.04L1064.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 367.408L889.959 373.52H894.682L890.861 377.297L892.321 383.409L888.5 379.631L884.679 383.409L886.139 377.297L882.318 373.52H887.041L888.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 367.408L1241.96 373.52H1246.68L1242.86 377.297L1244.32 383.409L1240.5 379.631L1236.68 383.409L1238.14 377.297L1234.32 373.52H1239.04L1240.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 367.408L801.959 373.52H806.682L802.861 377.297L804.321 383.409L800.5 379.631L796.679 383.409L798.139 377.297L794.318 373.52H799.041L800.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 367.408L1153.96 373.52H1158.68L1154.86 377.297L1156.32 383.409L1152.5 379.631L1148.68 383.409L1150.14 377.297L1146.32 373.52H1151.04L1152.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 367.408L977.959 373.52H982.682L978.861 377.297L980.321 383.409L976.5 379.631L972.679 383.409L974.139 377.297L970.318 373.52H975.041L976.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 367.408L1329.96 373.52H1334.68L1330.86 377.297L1332.32 383.409L1328.5 379.631L1324.68 383.409L1326.14 377.297L1322.32 373.52H1327.04L1328.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 367.408L757.959 373.52H762.682L758.861 377.297L760.321 383.409L756.5 379.631L752.679 383.409L754.139 377.297L750.318 373.52H755.041L756.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 367.408L1109.96 373.52H1114.68L1110.86 377.297L1112.32 383.409L1108.5 379.631L1104.68 383.409L1106.14 377.297L1102.32 373.52H1107.04L1108.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 367.408L933.959 373.52H938.682L934.861 377.297L936.321 383.409L932.5 379.631L928.679 383.409L930.139 377.297L926.318 373.52H931.041L932.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 367.408L1285.96 373.52H1290.68L1286.86 377.297L1288.32 383.409L1284.5 379.631L1280.68 383.409L1282.14 377.297L1278.32 373.52H1283.04L1284.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 367.408L845.959 373.52H850.682L846.861 377.297L848.321 383.409L844.5 379.631L840.679 383.409L842.139 377.297L838.318 373.52H843.041L844.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 367.408L1197.96 373.52H1202.68L1198.86 377.297L1200.32 383.409L1196.5 379.631L1192.68 383.409L1194.14 377.297L1190.32 373.52H1195.04L1196.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 367.408L1021.96 373.52H1026.68L1022.86 377.297L1024.32 383.409L1020.5 379.631L1016.68 383.409L1018.14 377.297L1014.32 373.52H1019.04L1020.5 367.408Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 391.902L691.959 398.014H696.682L692.861 401.791L694.321 407.903L690.5 404.125L686.679 407.903L688.139 401.791L684.318 398.014H689.041L690.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 391.902L1043.96 398.014H1048.68L1044.86 401.791L1046.32 407.903L1042.5 404.125L1038.68 407.903L1040.14 401.791L1036.32 398.014H1041.04L1042.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 391.902L867.959 398.014H872.682L868.861 401.791L870.321 407.903L866.5 404.125L862.679 407.903L864.139 401.791L860.318 398.014H865.041L866.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 391.902L1219.96 398.014H1224.68L1220.86 401.791L1222.32 407.903L1218.5 404.125L1214.68 407.903L1216.14 401.791L1212.32 398.014H1217.04L1218.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 391.902L779.959 398.014H784.682L780.861 401.791L782.321 407.903L778.5 404.125L774.679 407.903L776.139 401.791L772.318 398.014H777.041L778.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 391.902L1131.96 398.014H1136.68L1132.86 401.791L1134.32 407.903L1130.5 404.125L1126.68 407.903L1128.14 401.791L1124.32 398.014H1129.04L1130.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 391.902L955.959 398.014H960.682L956.861 401.791L958.321 407.903L954.5 404.125L950.679 407.903L952.139 401.791L948.318 398.014H953.041L954.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 391.902L1307.96 398.014H1312.68L1308.86 401.791L1310.32 407.903L1306.5 404.125L1302.68 407.903L1304.14 401.791L1300.32 398.014H1305.04L1306.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 391.902L735.959 398.014H740.682L736.861 401.791L738.321 407.903L734.5 404.125L730.679 407.903L732.139 401.791L728.318 398.014H733.041L734.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 391.902L1087.96 398.014H1092.68L1088.86 401.791L1090.32 407.903L1086.5 404.125L1082.68 407.903L1084.14 401.791L1080.32 398.014H1085.04L1086.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 391.902L911.959 398.014H916.682L912.861 401.791L914.321 407.903L910.5 404.125L906.679 407.903L908.139 401.791L904.318 398.014H909.041L910.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 391.902L1263.96 398.014H1268.68L1264.86 401.791L1266.32 407.903L1262.5 404.125L1258.68 407.903L1260.14 401.791L1256.32 398.014H1261.04L1262.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 391.902L823.959 398.014H828.682L824.861 401.791L826.321 407.903L822.5 404.125L818.679 407.903L820.139 401.791L816.318 398.014H821.041L822.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 391.902L1175.96 398.014H1180.68L1176.86 401.791L1178.32 407.903L1174.5 404.125L1170.68 407.903L1172.14 401.791L1168.32 398.014H1173.04L1174.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 391.902L999.959 398.014H1004.68L1000.86 401.791L1002.32 407.903L998.5 404.125L994.679 407.903L996.139 401.791L992.318 398.014H997.041L998.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 391.902L1351.96 398.014H1356.68L1352.86 401.791L1354.32 407.903L1350.5 404.125L1346.68 407.903L1348.14 401.791L1344.32 398.014H1349.04L1350.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 391.902L713.959 398.014H718.682L714.861 401.791L716.321 407.903L712.5 404.125L708.679 407.903L710.139 401.791L706.318 398.014H711.041L712.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 391.902L1065.96 398.014H1070.68L1066.86 401.791L1068.32 407.903L1064.5 404.125L1060.68 407.903L1062.14 401.791L1058.32 398.014H1063.04L1064.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 391.902L889.959 398.014H894.682L890.861 401.791L892.321 407.903L888.5 404.125L884.679 407.903L886.139 401.791L882.318 398.014H887.041L888.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 391.902L1241.96 398.014H1246.68L1242.86 401.791L1244.32 407.903L1240.5 404.125L1236.68 407.903L1238.14 401.791L1234.32 398.014H1239.04L1240.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 391.902L801.959 398.014H806.682L802.861 401.791L804.321 407.903L800.5 404.125L796.679 407.903L798.139 401.791L794.318 398.014H799.041L800.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 391.902L1153.96 398.014H1158.68L1154.86 401.791L1156.32 407.903L1152.5 404.125L1148.68 407.903L1150.14 401.791L1146.32 398.014H1151.04L1152.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 391.902L977.959 398.014H982.682L978.861 401.791L980.321 407.903L976.5 404.125L972.679 407.903L974.139 401.791L970.318 398.014H975.041L976.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 391.902L1329.96 398.014H1334.68L1330.86 401.791L1332.32 407.903L1328.5 404.125L1324.68 407.903L1326.14 401.791L1322.32 398.014H1327.04L1328.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 391.902L757.959 398.014H762.682L758.861 401.791L760.321 407.903L756.5 404.125L752.679 407.903L754.139 401.791L750.318 398.014H755.041L756.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 391.902L1109.96 398.014H1114.68L1110.86 401.791L1112.32 407.903L1108.5 404.125L1104.68 407.903L1106.14 401.791L1102.32 398.014H1107.04L1108.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 391.902L933.959 398.014H938.682L934.861 401.791L936.321 407.903L932.5 404.125L928.679 407.903L930.139 401.791L926.318 398.014H931.041L932.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 391.902L1285.96 398.014H1290.68L1286.86 401.791L1288.32 407.903L1284.5 404.125L1280.68 407.903L1282.14 401.791L1278.32 398.014H1283.04L1284.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 391.902L845.959 398.014H850.682L846.861 401.791L848.321 407.903L844.5 404.125L840.679 407.903L842.139 401.791L838.318 398.014H843.041L844.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 391.902L1197.96 398.014H1202.68L1198.86 401.791L1200.32 407.903L1196.5 404.125L1192.68 407.903L1194.14 401.791L1190.32 398.014H1195.04L1196.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 391.902L1021.96 398.014H1026.68L1022.86 401.791L1024.32 407.903L1020.5 404.125L1016.68 407.903L1018.14 401.791L1014.32 398.014H1019.04L1020.5 391.902Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 587.853L691.959 593.965H696.682L692.861 597.742L694.321 603.854L690.5 600.076L686.679 603.854L688.139 597.742L684.318 593.965H689.041L690.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 587.853L1043.96 593.965H1048.68L1044.86 597.742L1046.32 603.854L1042.5 600.076L1038.68 603.854L1040.14 597.742L1036.32 593.965H1041.04L1042.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 587.853L867.959 593.965H872.682L868.861 597.742L870.321 603.854L866.5 600.076L862.679 603.854L864.139 597.742L860.318 593.965H865.041L866.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 587.853L1219.96 593.965H1224.68L1220.86 597.742L1222.32 603.854L1218.5 600.076L1214.68 603.854L1216.14 597.742L1212.32 593.965H1217.04L1218.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 587.853L779.959 593.965H784.682L780.861 597.742L782.321 603.854L778.5 600.076L774.679 603.854L776.139 597.742L772.318 593.965H777.041L778.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 587.853L1131.96 593.965H1136.68L1132.86 597.742L1134.32 603.854L1130.5 600.076L1126.68 603.854L1128.14 597.742L1124.32 593.965H1129.04L1130.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 587.853L955.959 593.965H960.682L956.861 597.742L958.321 603.854L954.5 600.076L950.679 603.854L952.139 597.742L948.318 593.965H953.041L954.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 587.853L1307.96 593.965H1312.68L1308.86 597.742L1310.32 603.854L1306.5 600.076L1302.68 603.854L1304.14 597.742L1300.32 593.965H1305.04L1306.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 587.853L735.959 593.965H740.682L736.861 597.742L738.321 603.854L734.5 600.076L730.679 603.854L732.139 597.742L728.318 593.965H733.041L734.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 587.853L1087.96 593.965H1092.68L1088.86 597.742L1090.32 603.854L1086.5 600.076L1082.68 603.854L1084.14 597.742L1080.32 593.965H1085.04L1086.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 587.853L911.959 593.965H916.682L912.861 597.742L914.321 603.854L910.5 600.076L906.679 603.854L908.139 597.742L904.318 593.965H909.041L910.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 587.853L1263.96 593.965H1268.68L1264.86 597.742L1266.32 603.854L1262.5 600.076L1258.68 603.854L1260.14 597.742L1256.32 593.965H1261.04L1262.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 587.853L823.959 593.965H828.682L824.861 597.742L826.321 603.854L822.5 600.076L818.679 603.854L820.139 597.742L816.318 593.965H821.041L822.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 587.853L1175.96 593.965H1180.68L1176.86 597.742L1178.32 603.854L1174.5 600.076L1170.68 603.854L1172.14 597.742L1168.32 593.965H1173.04L1174.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 587.853L999.959 593.965H1004.68L1000.86 597.742L1002.32 603.854L998.5 600.076L994.679 603.854L996.139 597.742L992.318 593.965H997.041L998.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 587.853L1351.96 593.965H1356.68L1352.86 597.742L1354.32 603.854L1350.5 600.076L1346.68 603.854L1348.14 597.742L1344.32 593.965H1349.04L1350.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 587.853L713.959 593.965H718.682L714.861 597.742L716.321 603.854L712.5 600.076L708.679 603.854L710.139 597.742L706.318 593.965H711.041L712.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 587.853L1065.96 593.965H1070.68L1066.86 597.742L1068.32 603.854L1064.5 600.076L1060.68 603.854L1062.14 597.742L1058.32 593.965H1063.04L1064.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 587.853L889.959 593.965H894.682L890.861 597.742L892.321 603.854L888.5 600.076L884.679 603.854L886.139 597.742L882.318 593.965H887.041L888.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 587.853L1241.96 593.965H1246.68L1242.86 597.742L1244.32 603.854L1240.5 600.076L1236.68 603.854L1238.14 597.742L1234.32 593.965H1239.04L1240.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 587.853L801.959 593.965H806.682L802.861 597.742L804.321 603.854L800.5 600.076L796.679 603.854L798.139 597.742L794.318 593.965H799.041L800.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 587.853L1153.96 593.965H1158.68L1154.86 597.742L1156.32 603.854L1152.5 600.076L1148.68 603.854L1150.14 597.742L1146.32 593.965H1151.04L1152.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 587.853L977.959 593.965H982.682L978.861 597.742L980.321 603.854L976.5 600.076L972.679 603.854L974.139 597.742L970.318 593.965H975.041L976.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 587.853L1329.96 593.965H1334.68L1330.86 597.742L1332.32 603.854L1328.5 600.076L1324.68 603.854L1326.14 597.742L1322.32 593.965H1327.04L1328.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 587.853L757.959 593.965H762.682L758.861 597.742L760.321 603.854L756.5 600.076L752.679 603.854L754.139 597.742L750.318 593.965H755.041L756.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 587.853L1109.96 593.965H1114.68L1110.86 597.742L1112.32 603.854L1108.5 600.076L1104.68 603.854L1106.14 597.742L1102.32 593.965H1107.04L1108.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 587.853L933.959 593.965H938.682L934.861 597.742L936.321 603.854L932.5 600.076L928.679 603.854L930.139 597.742L926.318 593.965H931.041L932.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 587.853L1285.96 593.965H1290.68L1286.86 597.742L1288.32 603.854L1284.5 600.076L1280.68 603.854L1282.14 597.742L1278.32 593.965H1283.04L1284.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 587.853L845.959 593.965H850.682L846.861 597.742L848.321 603.854L844.5 600.076L840.679 603.854L842.139 597.742L838.318 593.965H843.041L844.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 587.853L1197.96 593.965H1202.68L1198.86 597.742L1200.32 603.854L1196.5 600.076L1192.68 603.854L1194.14 597.742L1190.32 593.965H1195.04L1196.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 587.853L1021.96 593.965H1026.68L1022.86 597.742L1024.32 603.854L1020.5 600.076L1016.68 603.854L1018.14 597.742L1014.32 593.965H1019.04L1020.5 587.853Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 489.877L691.959 495.989H696.682L692.861 499.766L694.321 505.878L690.5 502.101L686.679 505.878L688.139 499.766L684.318 495.989H689.041L690.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 489.877L1043.96 495.989H1048.68L1044.86 499.766L1046.32 505.878L1042.5 502.101L1038.68 505.878L1040.14 499.766L1036.32 495.989H1041.04L1042.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 489.877L867.959 495.989H872.682L868.861 499.766L870.321 505.878L866.5 502.101L862.679 505.878L864.139 499.766L860.318 495.989H865.041L866.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 489.877L1219.96 495.989H1224.68L1220.86 499.766L1222.32 505.878L1218.5 502.101L1214.68 505.878L1216.14 499.766L1212.32 495.989H1217.04L1218.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 489.877L779.959 495.989H784.682L780.861 499.766L782.321 505.878L778.5 502.101L774.679 505.878L776.139 499.766L772.318 495.989H777.041L778.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 489.877L1131.96 495.989H1136.68L1132.86 499.766L1134.32 505.878L1130.5 502.101L1126.68 505.878L1128.14 499.766L1124.32 495.989H1129.04L1130.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 489.877L955.959 495.989H960.682L956.861 499.766L958.321 505.878L954.5 502.101L950.679 505.878L952.139 499.766L948.318 495.989H953.041L954.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 489.877L1307.96 495.989H1312.68L1308.86 499.766L1310.32 505.878L1306.5 502.101L1302.68 505.878L1304.14 499.766L1300.32 495.989H1305.04L1306.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 489.877L735.959 495.989H740.682L736.861 499.766L738.321 505.878L734.5 502.101L730.679 505.878L732.139 499.766L728.318 495.989H733.041L734.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 489.877L1087.96 495.989H1092.68L1088.86 499.766L1090.32 505.878L1086.5 502.101L1082.68 505.878L1084.14 499.766L1080.32 495.989H1085.04L1086.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 489.877L911.959 495.989H916.682L912.861 499.766L914.321 505.878L910.5 502.101L906.679 505.878L908.139 499.766L904.318 495.989H909.041L910.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 489.877L1263.96 495.989H1268.68L1264.86 499.766L1266.32 505.878L1262.5 502.101L1258.68 505.878L1260.14 499.766L1256.32 495.989H1261.04L1262.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 489.877L823.959 495.989H828.682L824.861 499.766L826.321 505.878L822.5 502.101L818.679 505.878L820.139 499.766L816.318 495.989H821.041L822.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 489.877L1175.96 495.989H1180.68L1176.86 499.766L1178.32 505.878L1174.5 502.101L1170.68 505.878L1172.14 499.766L1168.32 495.989H1173.04L1174.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 489.877L999.959 495.989H1004.68L1000.86 499.766L1002.32 505.878L998.5 502.101L994.679 505.878L996.139 499.766L992.318 495.989H997.041L998.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 489.877L1351.96 495.989H1356.68L1352.86 499.766L1354.32 505.878L1350.5 502.101L1346.68 505.878L1348.14 499.766L1344.32 495.989H1349.04L1350.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 489.877L713.959 495.989H718.682L714.861 499.766L716.321 505.878L712.5 502.101L708.679 505.878L710.139 499.766L706.318 495.989H711.041L712.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 489.877L1065.96 495.989H1070.68L1066.86 499.766L1068.32 505.878L1064.5 502.101L1060.68 505.878L1062.14 499.766L1058.32 495.989H1063.04L1064.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 489.877L889.959 495.989H894.682L890.861 499.766L892.321 505.878L888.5 502.101L884.679 505.878L886.139 499.766L882.318 495.989H887.041L888.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 489.877L1241.96 495.989H1246.68L1242.86 499.766L1244.32 505.878L1240.5 502.101L1236.68 505.878L1238.14 499.766L1234.32 495.989H1239.04L1240.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 489.877L801.959 495.989H806.682L802.861 499.766L804.321 505.878L800.5 502.101L796.679 505.878L798.139 499.766L794.318 495.989H799.041L800.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 489.877L1153.96 495.989H1158.68L1154.86 499.766L1156.32 505.878L1152.5 502.101L1148.68 505.878L1150.14 499.766L1146.32 495.989H1151.04L1152.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 489.877L977.959 495.989H982.682L978.861 499.766L980.321 505.878L976.5 502.101L972.679 505.878L974.139 499.766L970.318 495.989H975.041L976.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 489.877L1329.96 495.989H1334.68L1330.86 499.766L1332.32 505.878L1328.5 502.101L1324.68 505.878L1326.14 499.766L1322.32 495.989H1327.04L1328.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 489.877L757.959 495.989H762.682L758.861 499.766L760.321 505.878L756.5 502.101L752.679 505.878L754.139 499.766L750.318 495.989H755.041L756.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 489.877L1109.96 495.989H1114.68L1110.86 499.766L1112.32 505.878L1108.5 502.101L1104.68 505.878L1106.14 499.766L1102.32 495.989H1107.04L1108.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 489.877L933.959 495.989H938.682L934.861 499.766L936.321 505.878L932.5 502.101L928.679 505.878L930.139 499.766L926.318 495.989H931.041L932.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 489.877L1285.96 495.989H1290.68L1286.86 499.766L1288.32 505.878L1284.5 502.101L1280.68 505.878L1282.14 499.766L1278.32 495.989H1283.04L1284.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 489.877L845.959 495.989H850.682L846.861 499.766L848.321 505.878L844.5 502.101L840.679 505.878L842.139 499.766L838.318 495.989H843.041L844.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 489.877L1197.96 495.989H1202.68L1198.86 499.766L1200.32 505.878L1196.5 502.101L1192.68 505.878L1194.14 499.766L1190.32 495.989H1195.04L1196.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 489.877L1021.96 495.989H1026.68L1022.86 499.766L1024.32 505.878L1020.5 502.101L1016.68 505.878L1018.14 499.766L1014.32 495.989H1019.04L1020.5 489.877Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 685.828L691.959 691.94H696.682L692.861 695.717L694.321 701.829L690.5 698.052L686.679 701.829L688.139 695.717L684.318 691.94H689.041L690.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 685.828L1043.96 691.94H1048.68L1044.86 695.717L1046.32 701.829L1042.5 698.052L1038.68 701.829L1040.14 695.717L1036.32 691.94H1041.04L1042.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 685.828L867.959 691.94H872.682L868.861 695.717L870.321 701.829L866.5 698.052L862.679 701.829L864.139 695.717L860.318 691.94H865.041L866.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 685.828L1219.96 691.94H1224.68L1220.86 695.717L1222.32 701.829L1218.5 698.052L1214.68 701.829L1216.14 695.717L1212.32 691.94H1217.04L1218.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 685.828L779.959 691.94H784.682L780.861 695.717L782.321 701.829L778.5 698.052L774.679 701.829L776.139 695.717L772.318 691.94H777.041L778.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 685.828L1131.96 691.94H1136.68L1132.86 695.717L1134.32 701.829L1130.5 698.052L1126.68 701.829L1128.14 695.717L1124.32 691.94H1129.04L1130.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 685.828L955.959 691.94H960.682L956.861 695.717L958.321 701.829L954.5 698.052L950.679 701.829L952.139 695.717L948.318 691.94H953.041L954.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 685.828L1307.96 691.94H1312.68L1308.86 695.717L1310.32 701.829L1306.5 698.052L1302.68 701.829L1304.14 695.717L1300.32 691.94H1305.04L1306.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 685.828L735.959 691.94H740.682L736.861 695.717L738.321 701.829L734.5 698.052L730.679 701.829L732.139 695.717L728.318 691.94H733.041L734.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 685.828L1087.96 691.94H1092.68L1088.86 695.717L1090.32 701.829L1086.5 698.052L1082.68 701.829L1084.14 695.717L1080.32 691.94H1085.04L1086.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 685.828L911.959 691.94H916.682L912.861 695.717L914.321 701.829L910.5 698.052L906.679 701.829L908.139 695.717L904.318 691.94H909.041L910.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 685.828L1263.96 691.94H1268.68L1264.86 695.717L1266.32 701.829L1262.5 698.052L1258.68 701.829L1260.14 695.717L1256.32 691.94H1261.04L1262.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 685.828L823.959 691.94H828.682L824.861 695.717L826.321 701.829L822.5 698.052L818.679 701.829L820.139 695.717L816.318 691.94H821.041L822.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 685.828L1175.96 691.94H1180.68L1176.86 695.717L1178.32 701.829L1174.5 698.052L1170.68 701.829L1172.14 695.717L1168.32 691.94H1173.04L1174.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 685.828L999.959 691.94H1004.68L1000.86 695.717L1002.32 701.829L998.5 698.052L994.679 701.829L996.139 695.717L992.318 691.94H997.041L998.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 685.828L1351.96 691.94H1356.68L1352.86 695.717L1354.32 701.829L1350.5 698.052L1346.68 701.829L1348.14 695.717L1344.32 691.94H1349.04L1350.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 685.828L713.959 691.94H718.682L714.861 695.717L716.321 701.829L712.5 698.052L708.679 701.829L710.139 695.717L706.318 691.94H711.041L712.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 685.828L1065.96 691.94H1070.68L1066.86 695.717L1068.32 701.829L1064.5 698.052L1060.68 701.829L1062.14 695.717L1058.32 691.94H1063.04L1064.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 685.828L889.959 691.94H894.682L890.861 695.717L892.321 701.829L888.5 698.052L884.679 701.829L886.139 695.717L882.318 691.94H887.041L888.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 685.828L1241.96 691.94H1246.68L1242.86 695.717L1244.32 701.829L1240.5 698.052L1236.68 701.829L1238.14 695.717L1234.32 691.94H1239.04L1240.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 685.828L801.959 691.94H806.682L802.861 695.717L804.321 701.829L800.5 698.052L796.679 701.829L798.139 695.717L794.318 691.94H799.041L800.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 685.828L1153.96 691.94H1158.68L1154.86 695.717L1156.32 701.829L1152.5 698.052L1148.68 701.829L1150.14 695.717L1146.32 691.94H1151.04L1152.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 685.828L977.959 691.94H982.682L978.861 695.717L980.321 701.829L976.5 698.052L972.679 701.829L974.139 695.717L970.318 691.94H975.041L976.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 685.828L1329.96 691.94H1334.68L1330.86 695.717L1332.32 701.829L1328.5 698.052L1324.68 701.829L1326.14 695.717L1322.32 691.94H1327.04L1328.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 685.828L757.959 691.94H762.682L758.861 695.717L760.321 701.829L756.5 698.052L752.679 701.829L754.139 695.717L750.318 691.94H755.041L756.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 685.828L1109.96 691.94H1114.68L1110.86 695.717L1112.32 701.829L1108.5 698.052L1104.68 701.829L1106.14 695.717L1102.32 691.94H1107.04L1108.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 685.828L933.959 691.94H938.682L934.861 695.717L936.321 701.829L932.5 698.052L928.679 701.829L930.139 695.717L926.318 691.94H931.041L932.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 685.828L1285.96 691.94H1290.68L1286.86 695.717L1288.32 701.829L1284.5 698.052L1280.68 701.829L1282.14 695.717L1278.32 691.94H1283.04L1284.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 685.828L845.959 691.94H850.682L846.861 695.717L848.321 701.829L844.5 698.052L840.679 701.829L842.139 695.717L838.318 691.94H843.041L844.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 685.828L1197.96 691.94H1202.68L1198.86 695.717L1200.32 701.829L1196.5 698.052L1192.68 701.829L1194.14 695.717L1190.32 691.94H1195.04L1196.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 685.828L1021.96 691.94H1026.68L1022.86 695.717L1024.32 701.829L1020.5 698.052L1016.68 701.829L1018.14 695.717L1014.32 691.94H1019.04L1020.5 685.828Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 440.89L691.959 447.001H696.682L692.861 450.779L694.321 456.89L690.5 453.113L686.679 456.89L688.139 450.779L684.318 447.001H689.041L690.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 440.89L1043.96 447.001H1048.68L1044.86 450.779L1046.32 456.89L1042.5 453.113L1038.68 456.89L1040.14 450.779L1036.32 447.001H1041.04L1042.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 440.89L867.959 447.001H872.682L868.861 450.779L870.321 456.89L866.5 453.113L862.679 456.89L864.139 450.779L860.318 447.001H865.041L866.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 440.89L1219.96 447.001H1224.68L1220.86 450.779L1222.32 456.89L1218.5 453.113L1214.68 456.89L1216.14 450.779L1212.32 447.001H1217.04L1218.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 440.89L779.959 447.001H784.682L780.861 450.779L782.321 456.89L778.5 453.113L774.679 456.89L776.139 450.779L772.318 447.001H777.041L778.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 440.89L1131.96 447.001H1136.68L1132.86 450.779L1134.32 456.89L1130.5 453.113L1126.68 456.89L1128.14 450.779L1124.32 447.001H1129.04L1130.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 440.89L955.959 447.001H960.682L956.861 450.779L958.321 456.89L954.5 453.113L950.679 456.89L952.139 450.779L948.318 447.001H953.041L954.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 440.89L1307.96 447.001H1312.68L1308.86 450.779L1310.32 456.89L1306.5 453.113L1302.68 456.89L1304.14 450.779L1300.32 447.001H1305.04L1306.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 440.89L735.959 447.001H740.682L736.861 450.779L738.321 456.89L734.5 453.113L730.679 456.89L732.139 450.779L728.318 447.001H733.041L734.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 440.89L1087.96 447.001H1092.68L1088.86 450.779L1090.32 456.89L1086.5 453.113L1082.68 456.89L1084.14 450.779L1080.32 447.001H1085.04L1086.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 440.89L911.959 447.001H916.682L912.861 450.779L914.321 456.89L910.5 453.113L906.679 456.89L908.139 450.779L904.318 447.001H909.041L910.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 440.89L1263.96 447.001H1268.68L1264.86 450.779L1266.32 456.89L1262.5 453.113L1258.68 456.89L1260.14 450.779L1256.32 447.001H1261.04L1262.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 440.89L823.959 447.001H828.682L824.861 450.779L826.321 456.89L822.5 453.113L818.679 456.89L820.139 450.779L816.318 447.001H821.041L822.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 440.89L1175.96 447.001H1180.68L1176.86 450.779L1178.32 456.89L1174.5 453.113L1170.68 456.89L1172.14 450.779L1168.32 447.001H1173.04L1174.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 440.89L999.959 447.001H1004.68L1000.86 450.779L1002.32 456.89L998.5 453.113L994.679 456.89L996.139 450.779L992.318 447.001H997.041L998.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 440.89L1351.96 447.001H1356.68L1352.86 450.779L1354.32 456.89L1350.5 453.113L1346.68 456.89L1348.14 450.779L1344.32 447.001H1349.04L1350.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 440.89L713.959 447.001H718.682L714.861 450.779L716.321 456.89L712.5 453.113L708.679 456.89L710.139 450.779L706.318 447.001H711.041L712.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 440.89L1065.96 447.001H1070.68L1066.86 450.779L1068.32 456.89L1064.5 453.113L1060.68 456.89L1062.14 450.779L1058.32 447.001H1063.04L1064.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 440.89L889.959 447.001H894.682L890.861 450.779L892.321 456.89L888.5 453.113L884.679 456.89L886.139 450.779L882.318 447.001H887.041L888.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 440.89L1241.96 447.001H1246.68L1242.86 450.779L1244.32 456.89L1240.5 453.113L1236.68 456.89L1238.14 450.779L1234.32 447.001H1239.04L1240.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 440.89L801.959 447.001H806.682L802.861 450.779L804.321 456.89L800.5 453.113L796.679 456.89L798.139 450.779L794.318 447.001H799.041L800.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 440.89L1153.96 447.001H1158.68L1154.86 450.779L1156.32 456.89L1152.5 453.113L1148.68 456.89L1150.14 450.779L1146.32 447.001H1151.04L1152.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 440.89L977.959 447.001H982.682L978.861 450.779L980.321 456.89L976.5 453.113L972.679 456.89L974.139 450.779L970.318 447.001H975.041L976.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 440.89L1329.96 447.001H1334.68L1330.86 450.779L1332.32 456.89L1328.5 453.113L1324.68 456.89L1326.14 450.779L1322.32 447.001H1327.04L1328.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 440.89L757.959 447.001H762.682L758.861 450.779L760.321 456.89L756.5 453.113L752.679 456.89L754.139 450.779L750.318 447.001H755.041L756.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 440.89L1109.96 447.001H1114.68L1110.86 450.779L1112.32 456.89L1108.5 453.113L1104.68 456.89L1106.14 450.779L1102.32 447.001H1107.04L1108.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 440.89L933.959 447.001H938.682L934.861 450.779L936.321 456.89L932.5 453.113L928.679 456.89L930.139 450.779L926.318 447.001H931.041L932.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 440.89L1285.96 447.001H1290.68L1286.86 450.779L1288.32 456.89L1284.5 453.113L1280.68 456.89L1282.14 450.779L1278.32 447.001H1283.04L1284.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 440.89L845.959 447.001H850.682L846.861 450.779L848.321 456.89L844.5 453.113L840.679 456.89L842.139 450.779L838.318 447.001H843.041L844.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 440.89L1197.96 447.001H1202.68L1198.86 450.779L1200.32 456.89L1196.5 453.113L1192.68 456.89L1194.14 450.779L1190.32 447.001H1195.04L1196.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 440.89L1021.96 447.001H1026.68L1022.86 450.779L1024.32 456.89L1020.5 453.113L1016.68 456.89L1018.14 450.779L1014.32 447.001H1019.04L1020.5 440.89Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 636.841L691.959 642.952H696.682L692.861 646.73L694.321 652.841L690.5 649.064L686.679 652.841L688.139 646.73L684.318 642.952H689.041L690.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 636.841L1043.96 642.952H1048.68L1044.86 646.73L1046.32 652.841L1042.5 649.064L1038.68 652.841L1040.14 646.73L1036.32 642.952H1041.04L1042.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 636.841L867.959 642.952H872.682L868.861 646.73L870.321 652.841L866.5 649.064L862.679 652.841L864.139 646.73L860.318 642.952H865.041L866.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 636.841L1219.96 642.952H1224.68L1220.86 646.73L1222.32 652.841L1218.5 649.064L1214.68 652.841L1216.14 646.73L1212.32 642.952H1217.04L1218.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 636.841L779.959 642.952H784.682L780.861 646.73L782.321 652.841L778.5 649.064L774.679 652.841L776.139 646.73L772.318 642.952H777.041L778.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 636.841L1131.96 642.952H1136.68L1132.86 646.73L1134.32 652.841L1130.5 649.064L1126.68 652.841L1128.14 646.73L1124.32 642.952H1129.04L1130.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 636.841L955.959 642.952H960.682L956.861 646.73L958.321 652.841L954.5 649.064L950.679 652.841L952.139 646.73L948.318 642.952H953.041L954.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 636.841L1307.96 642.952H1312.68L1308.86 646.73L1310.32 652.841L1306.5 649.064L1302.68 652.841L1304.14 646.73L1300.32 642.952H1305.04L1306.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 636.841L735.959 642.952H740.682L736.861 646.73L738.321 652.841L734.5 649.064L730.679 652.841L732.139 646.73L728.318 642.952H733.041L734.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 636.841L1087.96 642.952H1092.68L1088.86 646.73L1090.32 652.841L1086.5 649.064L1082.68 652.841L1084.14 646.73L1080.32 642.952H1085.04L1086.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 636.841L911.959 642.952H916.682L912.861 646.73L914.321 652.841L910.5 649.064L906.679 652.841L908.139 646.73L904.318 642.952H909.041L910.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 636.841L1263.96 642.952H1268.68L1264.86 646.73L1266.32 652.841L1262.5 649.064L1258.68 652.841L1260.14 646.73L1256.32 642.952H1261.04L1262.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 636.841L823.959 642.952H828.682L824.861 646.73L826.321 652.841L822.5 649.064L818.679 652.841L820.139 646.73L816.318 642.952H821.041L822.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 636.841L1175.96 642.952H1180.68L1176.86 646.73L1178.32 652.841L1174.5 649.064L1170.68 652.841L1172.14 646.73L1168.32 642.952H1173.04L1174.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 636.841L999.959 642.952H1004.68L1000.86 646.73L1002.32 652.841L998.5 649.064L994.679 652.841L996.139 646.73L992.318 642.952H997.041L998.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 636.841L1351.96 642.952H1356.68L1352.86 646.73L1354.32 652.841L1350.5 649.064L1346.68 652.841L1348.14 646.73L1344.32 642.952H1349.04L1350.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 636.841L713.959 642.952H718.682L714.861 646.73L716.321 652.841L712.5 649.064L708.679 652.841L710.139 646.73L706.318 642.952H711.041L712.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 636.841L1065.96 642.952H1070.68L1066.86 646.73L1068.32 652.841L1064.5 649.064L1060.68 652.841L1062.14 646.73L1058.32 642.952H1063.04L1064.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 636.841L889.959 642.952H894.682L890.861 646.73L892.321 652.841L888.5 649.064L884.679 652.841L886.139 646.73L882.318 642.952H887.041L888.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 636.841L1241.96 642.952H1246.68L1242.86 646.73L1244.32 652.841L1240.5 649.064L1236.68 652.841L1238.14 646.73L1234.32 642.952H1239.04L1240.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 636.841L801.959 642.952H806.682L802.861 646.73L804.321 652.841L800.5 649.064L796.679 652.841L798.139 646.73L794.318 642.952H799.041L800.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 636.841L1153.96 642.952H1158.68L1154.86 646.73L1156.32 652.841L1152.5 649.064L1148.68 652.841L1150.14 646.73L1146.32 642.952H1151.04L1152.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 636.841L977.959 642.952H982.682L978.861 646.73L980.321 652.841L976.5 649.064L972.679 652.841L974.139 646.73L970.318 642.952H975.041L976.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 636.841L1329.96 642.952H1334.68L1330.86 646.73L1332.32 652.841L1328.5 649.064L1324.68 652.841L1326.14 646.73L1322.32 642.952H1327.04L1328.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 636.841L757.959 642.952H762.682L758.861 646.73L760.321 652.841L756.5 649.064L752.679 652.841L754.139 646.73L750.318 642.952H755.041L756.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 636.841L1109.96 642.952H1114.68L1110.86 646.73L1112.32 652.841L1108.5 649.064L1104.68 652.841L1106.14 646.73L1102.32 642.952H1107.04L1108.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 636.841L933.959 642.952H938.682L934.861 646.73L936.321 652.841L932.5 649.064L928.679 652.841L930.139 646.73L926.318 642.952H931.041L932.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 636.841L1285.96 642.952H1290.68L1286.86 646.73L1288.32 652.841L1284.5 649.064L1280.68 652.841L1282.14 646.73L1278.32 642.952H1283.04L1284.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 636.841L845.959 642.952H850.682L846.861 646.73L848.321 652.841L844.5 649.064L840.679 652.841L842.139 646.73L838.318 642.952H843.041L844.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 636.841L1197.96 642.952H1202.68L1198.86 646.73L1200.32 652.841L1196.5 649.064L1192.68 652.841L1194.14 646.73L1190.32 642.952H1195.04L1196.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 636.841L1021.96 642.952H1026.68L1022.86 646.73L1024.32 652.841L1020.5 649.064L1016.68 652.841L1018.14 646.73L1014.32 642.952H1019.04L1020.5 636.841Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 538.865L691.959 544.977H696.682L692.861 548.754L694.321 554.866L690.5 551.088L686.679 554.866L688.139 548.754L684.318 544.977H689.041L690.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 538.865L1043.96 544.977H1048.68L1044.86 548.754L1046.32 554.866L1042.5 551.088L1038.68 554.866L1040.14 548.754L1036.32 544.977H1041.04L1042.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 538.865L867.959 544.977H872.682L868.861 548.754L870.321 554.866L866.5 551.088L862.679 554.866L864.139 548.754L860.318 544.977H865.041L866.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 538.865L1219.96 544.977H1224.68L1220.86 548.754L1222.32 554.866L1218.5 551.088L1214.68 554.866L1216.14 548.754L1212.32 544.977H1217.04L1218.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 538.865L779.959 544.977H784.682L780.861 548.754L782.321 554.866L778.5 551.088L774.679 554.866L776.139 548.754L772.318 544.977H777.041L778.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 538.865L1131.96 544.977H1136.68L1132.86 548.754L1134.32 554.866L1130.5 551.088L1126.68 554.866L1128.14 548.754L1124.32 544.977H1129.04L1130.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 538.865L955.959 544.977H960.682L956.861 548.754L958.321 554.866L954.5 551.088L950.679 554.866L952.139 548.754L948.318 544.977H953.041L954.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 538.865L1307.96 544.977H1312.68L1308.86 548.754L1310.32 554.866L1306.5 551.088L1302.68 554.866L1304.14 548.754L1300.32 544.977H1305.04L1306.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 538.865L735.959 544.977H740.682L736.861 548.754L738.321 554.866L734.5 551.088L730.679 554.866L732.139 548.754L728.318 544.977H733.041L734.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 538.865L1087.96 544.977H1092.68L1088.86 548.754L1090.32 554.866L1086.5 551.088L1082.68 554.866L1084.14 548.754L1080.32 544.977H1085.04L1086.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 538.865L911.959 544.977H916.682L912.861 548.754L914.321 554.866L910.5 551.088L906.679 554.866L908.139 548.754L904.318 544.977H909.041L910.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 538.865L1263.96 544.977H1268.68L1264.86 548.754L1266.32 554.866L1262.5 551.088L1258.68 554.866L1260.14 548.754L1256.32 544.977H1261.04L1262.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 538.865L823.959 544.977H828.682L824.861 548.754L826.321 554.866L822.5 551.088L818.679 554.866L820.139 548.754L816.318 544.977H821.041L822.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 538.865L1175.96 544.977H1180.68L1176.86 548.754L1178.32 554.866L1174.5 551.088L1170.68 554.866L1172.14 548.754L1168.32 544.977H1173.04L1174.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 538.865L999.959 544.977H1004.68L1000.86 548.754L1002.32 554.866L998.5 551.088L994.679 554.866L996.139 548.754L992.318 544.977H997.041L998.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 538.865L1351.96 544.977H1356.68L1352.86 548.754L1354.32 554.866L1350.5 551.088L1346.68 554.866L1348.14 548.754L1344.32 544.977H1349.04L1350.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 538.865L713.959 544.977H718.682L714.861 548.754L716.321 554.866L712.5 551.088L708.679 554.866L710.139 548.754L706.318 544.977H711.041L712.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 538.865L1065.96 544.977H1070.68L1066.86 548.754L1068.32 554.866L1064.5 551.088L1060.68 554.866L1062.14 548.754L1058.32 544.977H1063.04L1064.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 538.865L889.959 544.977H894.682L890.861 548.754L892.321 554.866L888.5 551.088L884.679 554.866L886.139 548.754L882.318 544.977H887.041L888.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 538.865L1241.96 544.977H1246.68L1242.86 548.754L1244.32 554.866L1240.5 551.088L1236.68 554.866L1238.14 548.754L1234.32 544.977H1239.04L1240.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 538.865L801.959 544.977H806.682L802.861 548.754L804.321 554.866L800.5 551.088L796.679 554.866L798.139 548.754L794.318 544.977H799.041L800.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 538.865L1153.96 544.977H1158.68L1154.86 548.754L1156.32 554.866L1152.5 551.088L1148.68 554.866L1150.14 548.754L1146.32 544.977H1151.04L1152.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 538.865L977.959 544.977H982.682L978.861 548.754L980.321 554.866L976.5 551.088L972.679 554.866L974.139 548.754L970.318 544.977H975.041L976.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 538.865L1329.96 544.977H1334.68L1330.86 548.754L1332.32 554.866L1328.5 551.088L1324.68 554.866L1326.14 548.754L1322.32 544.977H1327.04L1328.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 538.865L757.959 544.977H762.682L758.861 548.754L760.321 554.866L756.5 551.088L752.679 554.866L754.139 548.754L750.318 544.977H755.041L756.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 538.865L1109.96 544.977H1114.68L1110.86 548.754L1112.32 554.866L1108.5 551.088L1104.68 554.866L1106.14 548.754L1102.32 544.977H1107.04L1108.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 538.865L933.959 544.977H938.682L934.861 548.754L936.321 554.866L932.5 551.088L928.679 554.866L930.139 548.754L926.318 544.977H931.041L932.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 538.865L1285.96 544.977H1290.68L1286.86 548.754L1288.32 554.866L1284.5 551.088L1280.68 554.866L1282.14 548.754L1278.32 544.977H1283.04L1284.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 538.865L845.959 544.977H850.682L846.861 548.754L848.321 554.866L844.5 551.088L840.679 554.866L842.139 548.754L838.318 544.977H843.041L844.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 538.865L1197.96 544.977H1202.68L1198.86 548.754L1200.32 554.866L1196.5 551.088L1192.68 554.866L1194.14 548.754L1190.32 544.977H1195.04L1196.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 538.865L1021.96 544.977H1026.68L1022.86 548.754L1024.32 554.866L1020.5 551.088L1016.68 554.866L1018.14 548.754L1014.32 544.977H1019.04L1020.5 538.865Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 734.816L691.959 740.928H696.682L692.861 744.705L694.321 750.817L690.5 747.04L686.679 750.817L688.139 744.705L684.318 740.928H689.041L690.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 734.816L1043.96 740.928H1048.68L1044.86 744.705L1046.32 750.817L1042.5 747.04L1038.68 750.817L1040.14 744.705L1036.32 740.928H1041.04L1042.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 734.816L867.959 740.928H872.682L868.861 744.705L870.321 750.817L866.5 747.04L862.679 750.817L864.139 744.705L860.318 740.928H865.041L866.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 734.816L1219.96 740.928H1224.68L1220.86 744.705L1222.32 750.817L1218.5 747.04L1214.68 750.817L1216.14 744.705L1212.32 740.928H1217.04L1218.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 734.816L779.959 740.928H784.682L780.861 744.705L782.321 750.817L778.5 747.04L774.679 750.817L776.139 744.705L772.318 740.928H777.041L778.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 734.816L1131.96 740.928H1136.68L1132.86 744.705L1134.32 750.817L1130.5 747.04L1126.68 750.817L1128.14 744.705L1124.32 740.928H1129.04L1130.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 734.816L955.959 740.928H960.682L956.861 744.705L958.321 750.817L954.5 747.04L950.679 750.817L952.139 744.705L948.318 740.928H953.041L954.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 734.816L1307.96 740.928H1312.68L1308.86 744.705L1310.32 750.817L1306.5 747.04L1302.68 750.817L1304.14 744.705L1300.32 740.928H1305.04L1306.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 734.816L735.959 740.928H740.682L736.861 744.705L738.321 750.817L734.5 747.04L730.679 750.817L732.139 744.705L728.318 740.928H733.041L734.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 734.816L1087.96 740.928H1092.68L1088.86 744.705L1090.32 750.817L1086.5 747.04L1082.68 750.817L1084.14 744.705L1080.32 740.928H1085.04L1086.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 734.816L911.959 740.928H916.682L912.861 744.705L914.321 750.817L910.5 747.04L906.679 750.817L908.139 744.705L904.318 740.928H909.041L910.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 734.816L1263.96 740.928H1268.68L1264.86 744.705L1266.32 750.817L1262.5 747.04L1258.68 750.817L1260.14 744.705L1256.32 740.928H1261.04L1262.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 734.816L823.959 740.928H828.682L824.861 744.705L826.321 750.817L822.5 747.04L818.679 750.817L820.139 744.705L816.318 740.928H821.041L822.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 734.816L1175.96 740.928H1180.68L1176.86 744.705L1178.32 750.817L1174.5 747.04L1170.68 750.817L1172.14 744.705L1168.32 740.928H1173.04L1174.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 734.816L999.959 740.928H1004.68L1000.86 744.705L1002.32 750.817L998.5 747.04L994.679 750.817L996.139 744.705L992.318 740.928H997.041L998.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 734.816L1351.96 740.928H1356.68L1352.86 744.705L1354.32 750.817L1350.5 747.04L1346.68 750.817L1348.14 744.705L1344.32 740.928H1349.04L1350.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 734.816L713.959 740.928H718.682L714.861 744.705L716.321 750.817L712.5 747.04L708.679 750.817L710.139 744.705L706.318 740.928H711.041L712.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 734.816L1065.96 740.928H1070.68L1066.86 744.705L1068.32 750.817L1064.5 747.04L1060.68 750.817L1062.14 744.705L1058.32 740.928H1063.04L1064.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 734.816L889.959 740.928H894.682L890.861 744.705L892.321 750.817L888.5 747.04L884.679 750.817L886.139 744.705L882.318 740.928H887.041L888.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 734.816L1241.96 740.928H1246.68L1242.86 744.705L1244.32 750.817L1240.5 747.04L1236.68 750.817L1238.14 744.705L1234.32 740.928H1239.04L1240.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 734.816L801.959 740.928H806.682L802.861 744.705L804.321 750.817L800.5 747.04L796.679 750.817L798.139 744.705L794.318 740.928H799.041L800.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 734.816L1153.96 740.928H1158.68L1154.86 744.705L1156.32 750.817L1152.5 747.04L1148.68 750.817L1150.14 744.705L1146.32 740.928H1151.04L1152.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 734.816L977.959 740.928H982.682L978.861 744.705L980.321 750.817L976.5 747.04L972.679 750.817L974.139 744.705L970.318 740.928H975.041L976.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 734.816L1329.96 740.928H1334.68L1330.86 744.705L1332.32 750.817L1328.5 747.04L1324.68 750.817L1326.14 744.705L1322.32 740.928H1327.04L1328.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 734.816L757.959 740.928H762.682L758.861 744.705L760.321 750.817L756.5 747.04L752.679 750.817L754.139 744.705L750.318 740.928H755.041L756.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 734.816L1109.96 740.928H1114.68L1110.86 744.705L1112.32 750.817L1108.5 747.04L1104.68 750.817L1106.14 744.705L1102.32 740.928H1107.04L1108.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 734.816L933.959 740.928H938.682L934.861 744.705L936.321 750.817L932.5 747.04L928.679 750.817L930.139 744.705L926.318 740.928H931.041L932.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 734.816L1285.96 740.928H1290.68L1286.86 744.705L1288.32 750.817L1284.5 747.04L1280.68 750.817L1282.14 744.705L1278.32 740.928H1283.04L1284.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 734.816L845.959 740.928H850.682L846.861 744.705L848.321 750.817L844.5 747.04L840.679 750.817L842.139 744.705L838.318 740.928H843.041L844.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 734.816L1197.96 740.928H1202.68L1198.86 744.705L1200.32 750.817L1196.5 747.04L1192.68 750.817L1194.14 744.705L1190.32 740.928H1195.04L1196.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 734.816L1021.96 740.928H1026.68L1022.86 744.705L1024.32 750.817L1020.5 747.04L1016.68 750.817L1018.14 744.705L1014.32 740.928H1019.04L1020.5 734.816Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 416.396L691.959 422.508H696.682L692.861 426.285L694.321 432.397L690.5 428.619L686.679 432.397L688.139 426.285L684.318 422.508H689.041L690.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 416.396L1043.96 422.508H1048.68L1044.86 426.285L1046.32 432.397L1042.5 428.619L1038.68 432.397L1040.14 426.285L1036.32 422.508H1041.04L1042.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 416.396L867.959 422.508H872.682L868.861 426.285L870.321 432.397L866.5 428.619L862.679 432.397L864.139 426.285L860.318 422.508H865.041L866.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 416.396L1219.96 422.508H1224.68L1220.86 426.285L1222.32 432.397L1218.5 428.619L1214.68 432.397L1216.14 426.285L1212.32 422.508H1217.04L1218.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 416.396L779.959 422.508H784.682L780.861 426.285L782.321 432.397L778.5 428.619L774.679 432.397L776.139 426.285L772.318 422.508H777.041L778.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 416.396L1131.96 422.508H1136.68L1132.86 426.285L1134.32 432.397L1130.5 428.619L1126.68 432.397L1128.14 426.285L1124.32 422.508H1129.04L1130.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 416.396L955.959 422.508H960.682L956.861 426.285L958.321 432.397L954.5 428.619L950.679 432.397L952.139 426.285L948.318 422.508H953.041L954.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 416.396L1307.96 422.508H1312.68L1308.86 426.285L1310.32 432.397L1306.5 428.619L1302.68 432.397L1304.14 426.285L1300.32 422.508H1305.04L1306.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 416.396L735.959 422.508H740.682L736.861 426.285L738.321 432.397L734.5 428.619L730.679 432.397L732.139 426.285L728.318 422.508H733.041L734.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 416.396L1087.96 422.508H1092.68L1088.86 426.285L1090.32 432.397L1086.5 428.619L1082.68 432.397L1084.14 426.285L1080.32 422.508H1085.04L1086.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 416.396L911.959 422.508H916.682L912.861 426.285L914.321 432.397L910.5 428.619L906.679 432.397L908.139 426.285L904.318 422.508H909.041L910.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 416.396L1263.96 422.508H1268.68L1264.86 426.285L1266.32 432.397L1262.5 428.619L1258.68 432.397L1260.14 426.285L1256.32 422.508H1261.04L1262.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 416.396L823.959 422.508H828.682L824.861 426.285L826.321 432.397L822.5 428.619L818.679 432.397L820.139 426.285L816.318 422.508H821.041L822.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 416.396L1175.96 422.508H1180.68L1176.86 426.285L1178.32 432.397L1174.5 428.619L1170.68 432.397L1172.14 426.285L1168.32 422.508H1173.04L1174.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 416.396L999.959 422.508H1004.68L1000.86 426.285L1002.32 432.397L998.5 428.619L994.679 432.397L996.139 426.285L992.318 422.508H997.041L998.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 416.396L1351.96 422.508H1356.68L1352.86 426.285L1354.32 432.397L1350.5 428.619L1346.68 432.397L1348.14 426.285L1344.32 422.508H1349.04L1350.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 416.396L713.959 422.508H718.682L714.861 426.285L716.321 432.397L712.5 428.619L708.679 432.397L710.139 426.285L706.318 422.508H711.041L712.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 416.396L1065.96 422.508H1070.68L1066.86 426.285L1068.32 432.397L1064.5 428.619L1060.68 432.397L1062.14 426.285L1058.32 422.508H1063.04L1064.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 416.396L889.959 422.508H894.682L890.861 426.285L892.321 432.397L888.5 428.619L884.679 432.397L886.139 426.285L882.318 422.508H887.041L888.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 416.396L1241.96 422.508H1246.68L1242.86 426.285L1244.32 432.397L1240.5 428.619L1236.68 432.397L1238.14 426.285L1234.32 422.508H1239.04L1240.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 416.396L801.959 422.508H806.682L802.861 426.285L804.321 432.397L800.5 428.619L796.679 432.397L798.139 426.285L794.318 422.508H799.041L800.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 416.396L1153.96 422.508H1158.68L1154.86 426.285L1156.32 432.397L1152.5 428.619L1148.68 432.397L1150.14 426.285L1146.32 422.508H1151.04L1152.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 416.396L977.959 422.508H982.682L978.861 426.285L980.321 432.397L976.5 428.619L972.679 432.397L974.139 426.285L970.318 422.508H975.041L976.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 416.396L1329.96 422.508H1334.68L1330.86 426.285L1332.32 432.397L1328.5 428.619L1324.68 432.397L1326.14 426.285L1322.32 422.508H1327.04L1328.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 416.396L757.959 422.508H762.682L758.861 426.285L760.321 432.397L756.5 428.619L752.679 432.397L754.139 426.285L750.318 422.508H755.041L756.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 416.396L1109.96 422.508H1114.68L1110.86 426.285L1112.32 432.397L1108.5 428.619L1104.68 432.397L1106.14 426.285L1102.32 422.508H1107.04L1108.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 416.396L933.959 422.508H938.682L934.861 426.285L936.321 432.397L932.5 428.619L928.679 432.397L930.139 426.285L926.318 422.508H931.041L932.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 416.396L1285.96 422.508H1290.68L1286.86 426.285L1288.32 432.397L1284.5 428.619L1280.68 432.397L1282.14 426.285L1278.32 422.508H1283.04L1284.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 416.396L845.959 422.508H850.682L846.861 426.285L848.321 432.397L844.5 428.619L840.679 432.397L842.139 426.285L838.318 422.508H843.041L844.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 416.396L1197.96 422.508H1202.68L1198.86 426.285L1200.32 432.397L1196.5 428.619L1192.68 432.397L1194.14 426.285L1190.32 422.508H1195.04L1196.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 416.396L1021.96 422.508H1026.68L1022.86 426.285L1024.32 432.397L1020.5 428.619L1016.68 432.397L1018.14 426.285L1014.32 422.508H1019.04L1020.5 416.396Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 612.347L691.959 618.459H696.682L692.861 622.236L694.321 628.348L690.5 624.57L686.679 628.348L688.139 622.236L684.318 618.459H689.041L690.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 612.347L1043.96 618.459H1048.68L1044.86 622.236L1046.32 628.348L1042.5 624.57L1038.68 628.348L1040.14 622.236L1036.32 618.459H1041.04L1042.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 612.347L867.959 618.459H872.682L868.861 622.236L870.321 628.348L866.5 624.57L862.679 628.348L864.139 622.236L860.318 618.459H865.041L866.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 612.347L1219.96 618.459H1224.68L1220.86 622.236L1222.32 628.348L1218.5 624.57L1214.68 628.348L1216.14 622.236L1212.32 618.459H1217.04L1218.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 612.347L779.959 618.459H784.682L780.861 622.236L782.321 628.348L778.5 624.57L774.679 628.348L776.139 622.236L772.318 618.459H777.041L778.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 612.347L1131.96 618.459H1136.68L1132.86 622.236L1134.32 628.348L1130.5 624.57L1126.68 628.348L1128.14 622.236L1124.32 618.459H1129.04L1130.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 612.347L955.959 618.459H960.682L956.861 622.236L958.321 628.348L954.5 624.57L950.679 628.348L952.139 622.236L948.318 618.459H953.041L954.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 612.347L1307.96 618.459H1312.68L1308.86 622.236L1310.32 628.348L1306.5 624.57L1302.68 628.348L1304.14 622.236L1300.32 618.459H1305.04L1306.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 612.347L735.959 618.459H740.682L736.861 622.236L738.321 628.348L734.5 624.57L730.679 628.348L732.139 622.236L728.318 618.459H733.041L734.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 612.347L1087.96 618.459H1092.68L1088.86 622.236L1090.32 628.348L1086.5 624.57L1082.68 628.348L1084.14 622.236L1080.32 618.459H1085.04L1086.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 612.347L911.959 618.459H916.682L912.861 622.236L914.321 628.348L910.5 624.57L906.679 628.348L908.139 622.236L904.318 618.459H909.041L910.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 612.347L1263.96 618.459H1268.68L1264.86 622.236L1266.32 628.348L1262.5 624.57L1258.68 628.348L1260.14 622.236L1256.32 618.459H1261.04L1262.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 612.347L823.959 618.459H828.682L824.861 622.236L826.321 628.348L822.5 624.57L818.679 628.348L820.139 622.236L816.318 618.459H821.041L822.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 612.347L1175.96 618.459H1180.68L1176.86 622.236L1178.32 628.348L1174.5 624.57L1170.68 628.348L1172.14 622.236L1168.32 618.459H1173.04L1174.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 612.347L999.959 618.459H1004.68L1000.86 622.236L1002.32 628.348L998.5 624.57L994.679 628.348L996.139 622.236L992.318 618.459H997.041L998.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 612.347L1351.96 618.459H1356.68L1352.86 622.236L1354.32 628.348L1350.5 624.57L1346.68 628.348L1348.14 622.236L1344.32 618.459H1349.04L1350.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 612.347L713.959 618.459H718.682L714.861 622.236L716.321 628.348L712.5 624.57L708.679 628.348L710.139 622.236L706.318 618.459H711.041L712.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 612.347L1065.96 618.459H1070.68L1066.86 622.236L1068.32 628.348L1064.5 624.57L1060.68 628.348L1062.14 622.236L1058.32 618.459H1063.04L1064.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 612.347L889.959 618.459H894.682L890.861 622.236L892.321 628.348L888.5 624.57L884.679 628.348L886.139 622.236L882.318 618.459H887.041L888.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 612.347L1241.96 618.459H1246.68L1242.86 622.236L1244.32 628.348L1240.5 624.57L1236.68 628.348L1238.14 622.236L1234.32 618.459H1239.04L1240.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 612.347L801.959 618.459H806.682L802.861 622.236L804.321 628.348L800.5 624.57L796.679 628.348L798.139 622.236L794.318 618.459H799.041L800.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 612.347L1153.96 618.459H1158.68L1154.86 622.236L1156.32 628.348L1152.5 624.57L1148.68 628.348L1150.14 622.236L1146.32 618.459H1151.04L1152.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 612.347L977.959 618.459H982.682L978.861 622.236L980.321 628.348L976.5 624.57L972.679 628.348L974.139 622.236L970.318 618.459H975.041L976.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 612.347L1329.96 618.459H1334.68L1330.86 622.236L1332.32 628.348L1328.5 624.57L1324.68 628.348L1326.14 622.236L1322.32 618.459H1327.04L1328.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 612.347L757.959 618.459H762.682L758.861 622.236L760.321 628.348L756.5 624.57L752.679 628.348L754.139 622.236L750.318 618.459H755.041L756.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 612.347L1109.96 618.459H1114.68L1110.86 622.236L1112.32 628.348L1108.5 624.57L1104.68 628.348L1106.14 622.236L1102.32 618.459H1107.04L1108.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 612.347L933.959 618.459H938.682L934.861 622.236L936.321 628.348L932.5 624.57L928.679 628.348L930.139 622.236L926.318 618.459H931.041L932.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 612.347L1285.96 618.459H1290.68L1286.86 622.236L1288.32 628.348L1284.5 624.57L1280.68 628.348L1282.14 622.236L1278.32 618.459H1283.04L1284.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 612.347L845.959 618.459H850.682L846.861 622.236L848.321 628.348L844.5 624.57L840.679 628.348L842.139 622.236L838.318 618.459H843.041L844.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 612.347L1197.96 618.459H1202.68L1198.86 622.236L1200.32 628.348L1196.5 624.57L1192.68 628.348L1194.14 622.236L1190.32 618.459H1195.04L1196.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 612.347L1021.96 618.459H1026.68L1022.86 622.236L1024.32 628.348L1020.5 624.57L1016.68 628.348L1018.14 622.236L1014.32 618.459H1019.04L1020.5 612.347Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 514.371L691.959 520.483H696.682L692.861 524.26L694.321 530.372L690.5 526.595L686.679 530.372L688.139 524.26L684.318 520.483H689.041L690.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 514.371L1043.96 520.483H1048.68L1044.86 524.26L1046.32 530.372L1042.5 526.595L1038.68 530.372L1040.14 524.26L1036.32 520.483H1041.04L1042.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 514.371L867.959 520.483H872.682L868.861 524.26L870.321 530.372L866.5 526.595L862.679 530.372L864.139 524.26L860.318 520.483H865.041L866.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 514.371L1219.96 520.483H1224.68L1220.86 524.26L1222.32 530.372L1218.5 526.595L1214.68 530.372L1216.14 524.26L1212.32 520.483H1217.04L1218.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 514.371L779.959 520.483H784.682L780.861 524.26L782.321 530.372L778.5 526.595L774.679 530.372L776.139 524.26L772.318 520.483H777.041L778.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 514.371L1131.96 520.483H1136.68L1132.86 524.26L1134.32 530.372L1130.5 526.595L1126.68 530.372L1128.14 524.26L1124.32 520.483H1129.04L1130.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 514.371L955.959 520.483H960.682L956.861 524.26L958.321 530.372L954.5 526.595L950.679 530.372L952.139 524.26L948.318 520.483H953.041L954.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 514.371L1307.96 520.483H1312.68L1308.86 524.26L1310.32 530.372L1306.5 526.595L1302.68 530.372L1304.14 524.26L1300.32 520.483H1305.04L1306.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 514.371L735.959 520.483H740.682L736.861 524.26L738.321 530.372L734.5 526.595L730.679 530.372L732.139 524.26L728.318 520.483H733.041L734.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 514.371L1087.96 520.483H1092.68L1088.86 524.26L1090.32 530.372L1086.5 526.595L1082.68 530.372L1084.14 524.26L1080.32 520.483H1085.04L1086.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 514.371L911.959 520.483H916.682L912.861 524.26L914.321 530.372L910.5 526.595L906.679 530.372L908.139 524.26L904.318 520.483H909.041L910.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 514.371L1263.96 520.483H1268.68L1264.86 524.26L1266.32 530.372L1262.5 526.595L1258.68 530.372L1260.14 524.26L1256.32 520.483H1261.04L1262.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 514.371L823.959 520.483H828.682L824.861 524.26L826.321 530.372L822.5 526.595L818.679 530.372L820.139 524.26L816.318 520.483H821.041L822.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 514.371L1175.96 520.483H1180.68L1176.86 524.26L1178.32 530.372L1174.5 526.595L1170.68 530.372L1172.14 524.26L1168.32 520.483H1173.04L1174.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 514.371L999.959 520.483H1004.68L1000.86 524.26L1002.32 530.372L998.5 526.595L994.679 530.372L996.139 524.26L992.318 520.483H997.041L998.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 514.371L1351.96 520.483H1356.68L1352.86 524.26L1354.32 530.372L1350.5 526.595L1346.68 530.372L1348.14 524.26L1344.32 520.483H1349.04L1350.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 514.371L713.959 520.483H718.682L714.861 524.26L716.321 530.372L712.5 526.595L708.679 530.372L710.139 524.26L706.318 520.483H711.041L712.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 514.371L1065.96 520.483H1070.68L1066.86 524.26L1068.32 530.372L1064.5 526.595L1060.68 530.372L1062.14 524.26L1058.32 520.483H1063.04L1064.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 514.371L889.959 520.483H894.682L890.861 524.26L892.321 530.372L888.5 526.595L884.679 530.372L886.139 524.26L882.318 520.483H887.041L888.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 514.371L1241.96 520.483H1246.68L1242.86 524.26L1244.32 530.372L1240.5 526.595L1236.68 530.372L1238.14 524.26L1234.32 520.483H1239.04L1240.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 514.371L801.959 520.483H806.682L802.861 524.26L804.321 530.372L800.5 526.595L796.679 530.372L798.139 524.26L794.318 520.483H799.041L800.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 514.371L1153.96 520.483H1158.68L1154.86 524.26L1156.32 530.372L1152.5 526.595L1148.68 530.372L1150.14 524.26L1146.32 520.483H1151.04L1152.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 514.371L977.959 520.483H982.682L978.861 524.26L980.321 530.372L976.5 526.595L972.679 530.372L974.139 524.26L970.318 520.483H975.041L976.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 514.371L1329.96 520.483H1334.68L1330.86 524.26L1332.32 530.372L1328.5 526.595L1324.68 530.372L1326.14 524.26L1322.32 520.483H1327.04L1328.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 514.371L757.959 520.483H762.682L758.861 524.26L760.321 530.372L756.5 526.595L752.679 530.372L754.139 524.26L750.318 520.483H755.041L756.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 514.371L1109.96 520.483H1114.68L1110.86 524.26L1112.32 530.372L1108.5 526.595L1104.68 530.372L1106.14 524.26L1102.32 520.483H1107.04L1108.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 514.371L933.959 520.483H938.682L934.861 524.26L936.321 530.372L932.5 526.595L928.679 530.372L930.139 524.26L926.318 520.483H931.041L932.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 514.371L1285.96 520.483H1290.68L1286.86 524.26L1288.32 530.372L1284.5 526.595L1280.68 530.372L1282.14 524.26L1278.32 520.483H1283.04L1284.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 514.371L845.959 520.483H850.682L846.861 524.26L848.321 530.372L844.5 526.595L840.679 530.372L842.139 524.26L838.318 520.483H843.041L844.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 514.371L1197.96 520.483H1202.68L1198.86 524.26L1200.32 530.372L1196.5 526.595L1192.68 530.372L1194.14 524.26L1190.32 520.483H1195.04L1196.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 514.371L1021.96 520.483H1026.68L1022.86 524.26L1024.32 530.372L1020.5 526.595L1016.68 530.372L1018.14 524.26L1014.32 520.483H1019.04L1020.5 514.371Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 710.322L691.959 716.434H696.682L692.861 720.211L694.321 726.323L690.5 722.546L686.679 726.323L688.139 720.211L684.318 716.434H689.041L690.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 710.322L1043.96 716.434H1048.68L1044.86 720.211L1046.32 726.323L1042.5 722.546L1038.68 726.323L1040.14 720.211L1036.32 716.434H1041.04L1042.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 710.322L867.959 716.434H872.682L868.861 720.211L870.321 726.323L866.5 722.546L862.679 726.323L864.139 720.211L860.318 716.434H865.041L866.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 710.322L1219.96 716.434H1224.68L1220.86 720.211L1222.32 726.323L1218.5 722.546L1214.68 726.323L1216.14 720.211L1212.32 716.434H1217.04L1218.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 710.322L779.959 716.434H784.682L780.861 720.211L782.321 726.323L778.5 722.546L774.679 726.323L776.139 720.211L772.318 716.434H777.041L778.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 710.322L1131.96 716.434H1136.68L1132.86 720.211L1134.32 726.323L1130.5 722.546L1126.68 726.323L1128.14 720.211L1124.32 716.434H1129.04L1130.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 710.322L955.959 716.434H960.682L956.861 720.211L958.321 726.323L954.5 722.546L950.679 726.323L952.139 720.211L948.318 716.434H953.041L954.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 710.322L1307.96 716.434H1312.68L1308.86 720.211L1310.32 726.323L1306.5 722.546L1302.68 726.323L1304.14 720.211L1300.32 716.434H1305.04L1306.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 710.322L735.959 716.434H740.682L736.861 720.211L738.321 726.323L734.5 722.546L730.679 726.323L732.139 720.211L728.318 716.434H733.041L734.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 710.322L1087.96 716.434H1092.68L1088.86 720.211L1090.32 726.323L1086.5 722.546L1082.68 726.323L1084.14 720.211L1080.32 716.434H1085.04L1086.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 710.322L911.959 716.434H916.682L912.861 720.211L914.321 726.323L910.5 722.546L906.679 726.323L908.139 720.211L904.318 716.434H909.041L910.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 710.322L1263.96 716.434H1268.68L1264.86 720.211L1266.32 726.323L1262.5 722.546L1258.68 726.323L1260.14 720.211L1256.32 716.434H1261.04L1262.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 710.322L823.959 716.434H828.682L824.861 720.211L826.321 726.323L822.5 722.546L818.679 726.323L820.139 720.211L816.318 716.434H821.041L822.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 710.322L1175.96 716.434H1180.68L1176.86 720.211L1178.32 726.323L1174.5 722.546L1170.68 726.323L1172.14 720.211L1168.32 716.434H1173.04L1174.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 710.322L999.959 716.434H1004.68L1000.86 720.211L1002.32 726.323L998.5 722.546L994.679 726.323L996.139 720.211L992.318 716.434H997.041L998.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 710.322L1351.96 716.434H1356.68L1352.86 720.211L1354.32 726.323L1350.5 722.546L1346.68 726.323L1348.14 720.211L1344.32 716.434H1349.04L1350.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 710.322L713.959 716.434H718.682L714.861 720.211L716.321 726.323L712.5 722.546L708.679 726.323L710.139 720.211L706.318 716.434H711.041L712.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 710.322L1065.96 716.434H1070.68L1066.86 720.211L1068.32 726.323L1064.5 722.546L1060.68 726.323L1062.14 720.211L1058.32 716.434H1063.04L1064.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 710.322L889.959 716.434H894.682L890.861 720.211L892.321 726.323L888.5 722.546L884.679 726.323L886.139 720.211L882.318 716.434H887.041L888.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 710.322L1241.96 716.434H1246.68L1242.86 720.211L1244.32 726.323L1240.5 722.546L1236.68 726.323L1238.14 720.211L1234.32 716.434H1239.04L1240.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 710.322L801.959 716.434H806.682L802.861 720.211L804.321 726.323L800.5 722.546L796.679 726.323L798.139 720.211L794.318 716.434H799.041L800.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 710.322L1153.96 716.434H1158.68L1154.86 720.211L1156.32 726.323L1152.5 722.546L1148.68 726.323L1150.14 720.211L1146.32 716.434H1151.04L1152.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 710.322L977.959 716.434H982.682L978.861 720.211L980.321 726.323L976.5 722.546L972.679 726.323L974.139 720.211L970.318 716.434H975.041L976.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 710.322L1329.96 716.434H1334.68L1330.86 720.211L1332.32 726.323L1328.5 722.546L1324.68 726.323L1326.14 720.211L1322.32 716.434H1327.04L1328.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 710.322L757.959 716.434H762.682L758.861 720.211L760.321 726.323L756.5 722.546L752.679 726.323L754.139 720.211L750.318 716.434H755.041L756.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 710.322L1109.96 716.434H1114.68L1110.86 720.211L1112.32 726.323L1108.5 722.546L1104.68 726.323L1106.14 720.211L1102.32 716.434H1107.04L1108.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 710.322L933.959 716.434H938.682L934.861 720.211L936.321 726.323L932.5 722.546L928.679 726.323L930.139 720.211L926.318 716.434H931.041L932.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 710.322L1285.96 716.434H1290.68L1286.86 720.211L1288.32 726.323L1284.5 722.546L1280.68 726.323L1282.14 720.211L1278.32 716.434H1283.04L1284.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 710.322L845.959 716.434H850.682L846.861 720.211L848.321 726.323L844.5 722.546L840.679 726.323L842.139 720.211L838.318 716.434H843.041L844.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 710.322L1197.96 716.434H1202.68L1198.86 720.211L1200.32 726.323L1196.5 722.546L1192.68 726.323L1194.14 720.211L1190.32 716.434H1195.04L1196.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 710.322L1021.96 716.434H1026.68L1022.86 720.211L1024.32 726.323L1020.5 722.546L1016.68 726.323L1018.14 720.211L1014.32 716.434H1019.04L1020.5 710.322Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 465.384L691.959 471.495H696.682L692.861 475.273L694.321 481.384L690.5 477.607L686.679 481.384L688.139 475.273L684.318 471.495H689.041L690.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 465.384L1043.96 471.495H1048.68L1044.86 475.273L1046.32 481.384L1042.5 477.607L1038.68 481.384L1040.14 475.273L1036.32 471.495H1041.04L1042.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 465.384L867.959 471.495H872.682L868.861 475.273L870.321 481.384L866.5 477.607L862.679 481.384L864.139 475.273L860.318 471.495H865.041L866.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 465.384L1219.96 471.495H1224.68L1220.86 475.273L1222.32 481.384L1218.5 477.607L1214.68 481.384L1216.14 475.273L1212.32 471.495H1217.04L1218.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 465.384L779.959 471.495H784.682L780.861 475.273L782.321 481.384L778.5 477.607L774.679 481.384L776.139 475.273L772.318 471.495H777.041L778.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 465.384L1131.96 471.495H1136.68L1132.86 475.273L1134.32 481.384L1130.5 477.607L1126.68 481.384L1128.14 475.273L1124.32 471.495H1129.04L1130.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 465.384L955.959 471.495H960.682L956.861 475.273L958.321 481.384L954.5 477.607L950.679 481.384L952.139 475.273L948.318 471.495H953.041L954.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 465.384L1307.96 471.495H1312.68L1308.86 475.273L1310.32 481.384L1306.5 477.607L1302.68 481.384L1304.14 475.273L1300.32 471.495H1305.04L1306.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 465.384L735.959 471.495H740.682L736.861 475.273L738.321 481.384L734.5 477.607L730.679 481.384L732.139 475.273L728.318 471.495H733.041L734.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 465.384L1087.96 471.495H1092.68L1088.86 475.273L1090.32 481.384L1086.5 477.607L1082.68 481.384L1084.14 475.273L1080.32 471.495H1085.04L1086.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 465.384L911.959 471.495H916.682L912.861 475.273L914.321 481.384L910.5 477.607L906.679 481.384L908.139 475.273L904.318 471.495H909.041L910.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 465.384L1263.96 471.495H1268.68L1264.86 475.273L1266.32 481.384L1262.5 477.607L1258.68 481.384L1260.14 475.273L1256.32 471.495H1261.04L1262.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 465.384L823.959 471.495H828.682L824.861 475.273L826.321 481.384L822.5 477.607L818.679 481.384L820.139 475.273L816.318 471.495H821.041L822.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 465.384L1175.96 471.495H1180.68L1176.86 475.273L1178.32 481.384L1174.5 477.607L1170.68 481.384L1172.14 475.273L1168.32 471.495H1173.04L1174.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 465.384L999.959 471.495H1004.68L1000.86 475.273L1002.32 481.384L998.5 477.607L994.679 481.384L996.139 475.273L992.318 471.495H997.041L998.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 465.384L1351.96 471.495H1356.68L1352.86 475.273L1354.32 481.384L1350.5 477.607L1346.68 481.384L1348.14 475.273L1344.32 471.495H1349.04L1350.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 465.384L713.959 471.495H718.682L714.861 475.273L716.321 481.384L712.5 477.607L708.679 481.384L710.139 475.273L706.318 471.495H711.041L712.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 465.384L1065.96 471.495H1070.68L1066.86 475.273L1068.32 481.384L1064.5 477.607L1060.68 481.384L1062.14 475.273L1058.32 471.495H1063.04L1064.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 465.384L889.959 471.495H894.682L890.861 475.273L892.321 481.384L888.5 477.607L884.679 481.384L886.139 475.273L882.318 471.495H887.041L888.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 465.384L1241.96 471.495H1246.68L1242.86 475.273L1244.32 481.384L1240.5 477.607L1236.68 481.384L1238.14 475.273L1234.32 471.495H1239.04L1240.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 465.384L801.959 471.495H806.682L802.861 475.273L804.321 481.384L800.5 477.607L796.679 481.384L798.139 475.273L794.318 471.495H799.041L800.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 465.384L1153.96 471.495H1158.68L1154.86 475.273L1156.32 481.384L1152.5 477.607L1148.68 481.384L1150.14 475.273L1146.32 471.495H1151.04L1152.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 465.384L977.959 471.495H982.682L978.861 475.273L980.321 481.384L976.5 477.607L972.679 481.384L974.139 475.273L970.318 471.495H975.041L976.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 465.384L1329.96 471.495H1334.68L1330.86 475.273L1332.32 481.384L1328.5 477.607L1324.68 481.384L1326.14 475.273L1322.32 471.495H1327.04L1328.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 465.384L757.959 471.495H762.682L758.861 475.273L760.321 481.384L756.5 477.607L752.679 481.384L754.139 475.273L750.318 471.495H755.041L756.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 465.384L1109.96 471.495H1114.68L1110.86 475.273L1112.32 481.384L1108.5 477.607L1104.68 481.384L1106.14 475.273L1102.32 471.495H1107.04L1108.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 465.384L933.959 471.495H938.682L934.861 475.273L936.321 481.384L932.5 477.607L928.679 481.384L930.139 475.273L926.318 471.495H931.041L932.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 465.384L1285.96 471.495H1290.68L1286.86 475.273L1288.32 481.384L1284.5 477.607L1280.68 481.384L1282.14 475.273L1278.32 471.495H1283.04L1284.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 465.384L845.959 471.495H850.682L846.861 475.273L848.321 481.384L844.5 477.607L840.679 481.384L842.139 475.273L838.318 471.495H843.041L844.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 465.384L1197.96 471.495H1202.68L1198.86 475.273L1200.32 481.384L1196.5 477.607L1192.68 481.384L1194.14 475.273L1190.32 471.495H1195.04L1196.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 465.384L1021.96 471.495H1026.68L1022.86 475.273L1024.32 481.384L1020.5 477.607L1016.68 481.384L1018.14 475.273L1014.32 471.495H1019.04L1020.5 465.384Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 661.334L691.959 667.446H696.682L692.861 671.223L694.321 677.335L690.5 673.558L686.679 677.335L688.139 671.223L684.318 667.446H689.041L690.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 661.334L1043.96 667.446H1048.68L1044.86 671.223L1046.32 677.335L1042.5 673.558L1038.68 677.335L1040.14 671.223L1036.32 667.446H1041.04L1042.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 661.334L867.959 667.446H872.682L868.861 671.223L870.321 677.335L866.5 673.558L862.679 677.335L864.139 671.223L860.318 667.446H865.041L866.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 661.334L1219.96 667.446H1224.68L1220.86 671.223L1222.32 677.335L1218.5 673.558L1214.68 677.335L1216.14 671.223L1212.32 667.446H1217.04L1218.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 661.334L779.959 667.446H784.682L780.861 671.223L782.321 677.335L778.5 673.558L774.679 677.335L776.139 671.223L772.318 667.446H777.041L778.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 661.334L1131.96 667.446H1136.68L1132.86 671.223L1134.32 677.335L1130.5 673.558L1126.68 677.335L1128.14 671.223L1124.32 667.446H1129.04L1130.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 661.334L955.959 667.446H960.682L956.861 671.223L958.321 677.335L954.5 673.558L950.679 677.335L952.139 671.223L948.318 667.446H953.041L954.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 661.334L1307.96 667.446H1312.68L1308.86 671.223L1310.32 677.335L1306.5 673.558L1302.68 677.335L1304.14 671.223L1300.32 667.446H1305.04L1306.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 661.334L735.959 667.446H740.682L736.861 671.223L738.321 677.335L734.5 673.558L730.679 677.335L732.139 671.223L728.318 667.446H733.041L734.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 661.334L1087.96 667.446H1092.68L1088.86 671.223L1090.32 677.335L1086.5 673.558L1082.68 677.335L1084.14 671.223L1080.32 667.446H1085.04L1086.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 661.334L911.959 667.446H916.682L912.861 671.223L914.321 677.335L910.5 673.558L906.679 677.335L908.139 671.223L904.318 667.446H909.041L910.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 661.334L1263.96 667.446H1268.68L1264.86 671.223L1266.32 677.335L1262.5 673.558L1258.68 677.335L1260.14 671.223L1256.32 667.446H1261.04L1262.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 661.334L823.959 667.446H828.682L824.861 671.223L826.321 677.335L822.5 673.558L818.679 677.335L820.139 671.223L816.318 667.446H821.041L822.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 661.334L1175.96 667.446H1180.68L1176.86 671.223L1178.32 677.335L1174.5 673.558L1170.68 677.335L1172.14 671.223L1168.32 667.446H1173.04L1174.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 661.334L999.959 667.446H1004.68L1000.86 671.223L1002.32 677.335L998.5 673.558L994.679 677.335L996.139 671.223L992.318 667.446H997.041L998.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 661.334L1351.96 667.446H1356.68L1352.86 671.223L1354.32 677.335L1350.5 673.558L1346.68 677.335L1348.14 671.223L1344.32 667.446H1349.04L1350.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 661.334L713.959 667.446H718.682L714.861 671.223L716.321 677.335L712.5 673.558L708.679 677.335L710.139 671.223L706.318 667.446H711.041L712.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 661.334L1065.96 667.446H1070.68L1066.86 671.223L1068.32 677.335L1064.5 673.558L1060.68 677.335L1062.14 671.223L1058.32 667.446H1063.04L1064.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 661.334L889.959 667.446H894.682L890.861 671.223L892.321 677.335L888.5 673.558L884.679 677.335L886.139 671.223L882.318 667.446H887.041L888.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 661.334L1241.96 667.446H1246.68L1242.86 671.223L1244.32 677.335L1240.5 673.558L1236.68 677.335L1238.14 671.223L1234.32 667.446H1239.04L1240.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 661.334L801.959 667.446H806.682L802.861 671.223L804.321 677.335L800.5 673.558L796.679 677.335L798.139 671.223L794.318 667.446H799.041L800.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 661.334L1153.96 667.446H1158.68L1154.86 671.223L1156.32 677.335L1152.5 673.558L1148.68 677.335L1150.14 671.223L1146.32 667.446H1151.04L1152.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 661.334L977.959 667.446H982.682L978.861 671.223L980.321 677.335L976.5 673.558L972.679 677.335L974.139 671.223L970.318 667.446H975.041L976.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 661.334L1329.96 667.446H1334.68L1330.86 671.223L1332.32 677.335L1328.5 673.558L1324.68 677.335L1326.14 671.223L1322.32 667.446H1327.04L1328.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 661.334L757.959 667.446H762.682L758.861 671.223L760.321 677.335L756.5 673.558L752.679 677.335L754.139 671.223L750.318 667.446H755.041L756.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 661.334L1109.96 667.446H1114.68L1110.86 671.223L1112.32 677.335L1108.5 673.558L1104.68 677.335L1106.14 671.223L1102.32 667.446H1107.04L1108.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 661.334L933.959 667.446H938.682L934.861 671.223L936.321 677.335L932.5 673.558L928.679 677.335L930.139 671.223L926.318 667.446H931.041L932.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 661.334L1285.96 667.446H1290.68L1286.86 671.223L1288.32 677.335L1284.5 673.558L1280.68 677.335L1282.14 671.223L1278.32 667.446H1283.04L1284.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 661.334L845.959 667.446H850.682L846.861 671.223L848.321 677.335L844.5 673.558L840.679 677.335L842.139 671.223L838.318 667.446H843.041L844.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 661.334L1197.96 667.446H1202.68L1198.86 671.223L1200.32 677.335L1196.5 673.558L1192.68 677.335L1194.14 671.223L1190.32 667.446H1195.04L1196.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 661.334L1021.96 667.446H1026.68L1022.86 671.223L1024.32 677.335L1020.5 673.558L1016.68 677.335L1018.14 671.223L1014.32 667.446H1019.04L1020.5 661.334Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 563.359L691.959 569.471H696.682L692.861 573.248L694.321 579.36L690.5 575.583L686.679 579.36L688.139 573.248L684.318 569.471H689.041L690.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 563.359L1043.96 569.471H1048.68L1044.86 573.248L1046.32 579.36L1042.5 575.583L1038.68 579.36L1040.14 573.248L1036.32 569.471H1041.04L1042.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 563.359L867.959 569.471H872.682L868.861 573.248L870.321 579.36L866.5 575.583L862.679 579.36L864.139 573.248L860.318 569.471H865.041L866.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 563.359L1219.96 569.471H1224.68L1220.86 573.248L1222.32 579.36L1218.5 575.583L1214.68 579.36L1216.14 573.248L1212.32 569.471H1217.04L1218.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 563.359L779.959 569.471H784.682L780.861 573.248L782.321 579.36L778.5 575.583L774.679 579.36L776.139 573.248L772.318 569.471H777.041L778.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 563.359L1131.96 569.471H1136.68L1132.86 573.248L1134.32 579.36L1130.5 575.583L1126.68 579.36L1128.14 573.248L1124.32 569.471H1129.04L1130.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 563.359L955.959 569.471H960.682L956.861 573.248L958.321 579.36L954.5 575.583L950.679 579.36L952.139 573.248L948.318 569.471H953.041L954.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 563.359L1307.96 569.471H1312.68L1308.86 573.248L1310.32 579.36L1306.5 575.583L1302.68 579.36L1304.14 573.248L1300.32 569.471H1305.04L1306.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 563.359L735.959 569.471H740.682L736.861 573.248L738.321 579.36L734.5 575.583L730.679 579.36L732.139 573.248L728.318 569.471H733.041L734.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 563.359L1087.96 569.471H1092.68L1088.86 573.248L1090.32 579.36L1086.5 575.583L1082.68 579.36L1084.14 573.248L1080.32 569.471H1085.04L1086.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 563.359L911.959 569.471H916.682L912.861 573.248L914.321 579.36L910.5 575.583L906.679 579.36L908.139 573.248L904.318 569.471H909.041L910.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 563.359L1263.96 569.471H1268.68L1264.86 573.248L1266.32 579.36L1262.5 575.583L1258.68 579.36L1260.14 573.248L1256.32 569.471H1261.04L1262.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 563.359L823.959 569.471H828.682L824.861 573.248L826.321 579.36L822.5 575.583L818.679 579.36L820.139 573.248L816.318 569.471H821.041L822.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 563.359L1175.96 569.471H1180.68L1176.86 573.248L1178.32 579.36L1174.5 575.583L1170.68 579.36L1172.14 573.248L1168.32 569.471H1173.04L1174.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 563.359L999.959 569.471H1004.68L1000.86 573.248L1002.32 579.36L998.5 575.583L994.679 579.36L996.139 573.248L992.318 569.471H997.041L998.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 563.359L1351.96 569.471H1356.68L1352.86 573.248L1354.32 579.36L1350.5 575.583L1346.68 579.36L1348.14 573.248L1344.32 569.471H1349.04L1350.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 563.359L713.959 569.471H718.682L714.861 573.248L716.321 579.36L712.5 575.583L708.679 579.36L710.139 573.248L706.318 569.471H711.041L712.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 563.359L1065.96 569.471H1070.68L1066.86 573.248L1068.32 579.36L1064.5 575.583L1060.68 579.36L1062.14 573.248L1058.32 569.471H1063.04L1064.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 563.359L889.959 569.471H894.682L890.861 573.248L892.321 579.36L888.5 575.583L884.679 579.36L886.139 573.248L882.318 569.471H887.041L888.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 563.359L1241.96 569.471H1246.68L1242.86 573.248L1244.32 579.36L1240.5 575.583L1236.68 579.36L1238.14 573.248L1234.32 569.471H1239.04L1240.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 563.359L801.959 569.471H806.682L802.861 573.248L804.321 579.36L800.5 575.583L796.679 579.36L798.139 573.248L794.318 569.471H799.041L800.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 563.359L1153.96 569.471H1158.68L1154.86 573.248L1156.32 579.36L1152.5 575.583L1148.68 579.36L1150.14 573.248L1146.32 569.471H1151.04L1152.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 563.359L977.959 569.471H982.682L978.861 573.248L980.321 579.36L976.5 575.583L972.679 579.36L974.139 573.248L970.318 569.471H975.041L976.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 563.359L1329.96 569.471H1334.68L1330.86 573.248L1332.32 579.36L1328.5 575.583L1324.68 579.36L1326.14 573.248L1322.32 569.471H1327.04L1328.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 563.359L757.959 569.471H762.682L758.861 573.248L760.321 579.36L756.5 575.583L752.679 579.36L754.139 573.248L750.318 569.471H755.041L756.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 563.359L1109.96 569.471H1114.68L1110.86 573.248L1112.32 579.36L1108.5 575.583L1104.68 579.36L1106.14 573.248L1102.32 569.471H1107.04L1108.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 563.359L933.959 569.471H938.682L934.861 573.248L936.321 579.36L932.5 575.583L928.679 579.36L930.139 573.248L926.318 569.471H931.041L932.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 563.359L1285.96 569.471H1290.68L1286.86 573.248L1288.32 579.36L1284.5 575.583L1280.68 579.36L1282.14 573.248L1278.32 569.471H1283.04L1284.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 563.359L845.959 569.471H850.682L846.861 573.248L848.321 579.36L844.5 575.583L840.679 579.36L842.139 573.248L838.318 569.471H843.041L844.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 563.359L1197.96 569.471H1202.68L1198.86 573.248L1200.32 579.36L1196.5 575.583L1192.68 579.36L1194.14 573.248L1190.32 569.471H1195.04L1196.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 563.359L1021.96 569.471H1026.68L1022.86 573.248L1024.32 579.36L1020.5 575.583L1016.68 579.36L1018.14 573.248L1014.32 569.471H1019.04L1020.5 563.359Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 759.31L691.959 765.422H696.682L692.861 769.199L694.321 775.311L690.5 771.534L686.679 775.311L688.139 769.199L684.318 765.422H689.041L690.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 759.31L1043.96 765.422H1048.68L1044.86 769.199L1046.32 775.311L1042.5 771.534L1038.68 775.311L1040.14 769.199L1036.32 765.422H1041.04L1042.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 759.31L867.959 765.422H872.682L868.861 769.199L870.321 775.311L866.5 771.534L862.679 775.311L864.139 769.199L860.318 765.422H865.041L866.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5 759.31L1219.96 765.422H1224.68L1220.86 769.199L1222.32 775.311L1218.5 771.534L1214.68 775.311L1216.14 769.199L1212.32 765.422H1217.04L1218.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 759.31L779.959 765.422H784.682L780.861 769.199L782.321 775.311L778.5 771.534L774.679 775.311L776.139 769.199L772.318 765.422H777.041L778.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 759.31L1131.96 765.422H1136.68L1132.86 769.199L1134.32 775.311L1130.5 771.534L1126.68 775.311L1128.14 769.199L1124.32 765.422H1129.04L1130.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M954.5 759.31L955.959 765.422H960.682L956.861 769.199L958.321 775.311L954.5 771.534L950.679 775.311L952.139 769.199L948.318 765.422H953.041L954.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.5 759.31L1307.96 765.422H1312.68L1308.86 769.199L1310.32 775.311L1306.5 771.534L1302.68 775.311L1304.14 769.199L1300.32 765.422H1305.04L1306.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5 759.31L735.959 765.422H740.682L736.861 769.199L738.321 775.311L734.5 771.534L730.679 775.311L732.139 769.199L728.318 765.422H733.041L734.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 759.31L1087.96 765.422H1092.68L1088.86 769.199L1090.32 775.311L1086.5 771.534L1082.68 775.311L1084.14 769.199L1080.32 765.422H1085.04L1086.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5 759.31L911.959 765.422H916.682L912.861 769.199L914.321 775.311L910.5 771.534L906.679 775.311L908.139 769.199L904.318 765.422H909.041L910.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.5 759.31L1263.96 765.422H1268.68L1264.86 769.199L1266.32 775.311L1262.5 771.534L1258.68 775.311L1260.14 769.199L1256.32 765.422H1261.04L1262.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5 759.31L823.959 765.422H828.682L824.861 769.199L826.321 775.311L822.5 771.534L818.679 775.311L820.139 769.199L816.318 765.422H821.041L822.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 759.31L1175.96 765.422H1180.68L1176.86 769.199L1178.32 775.311L1174.5 771.534L1170.68 775.311L1172.14 769.199L1168.32 765.422H1173.04L1174.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M998.5 759.31L999.959 765.422H1004.68L1000.86 769.199L1002.32 775.311L998.5 771.534L994.679 775.311L996.139 769.199L992.318 765.422H997.041L998.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.5 759.31L1351.96 765.422H1356.68L1352.86 769.199L1354.32 775.311L1350.5 771.534L1346.68 775.311L1348.14 769.199L1344.32 765.422H1349.04L1350.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 759.31L713.959 765.422H718.682L714.861 769.199L716.321 775.311L712.5 771.534L708.679 775.311L710.139 769.199L706.318 765.422H711.041L712.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5 759.31L1065.96 765.422H1070.68L1066.86 769.199L1068.32 775.311L1064.5 771.534L1060.68 775.311L1062.14 769.199L1058.32 765.422H1063.04L1064.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 759.31L889.959 765.422H894.682L890.861 769.199L892.321 775.311L888.5 771.534L884.679 775.311L886.139 769.199L882.318 765.422H887.041L888.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 759.31L1241.96 765.422H1246.68L1242.86 769.199L1244.32 775.311L1240.5 771.534L1236.68 775.311L1238.14 769.199L1234.32 765.422H1239.04L1240.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 759.31L801.959 765.422H806.682L802.861 769.199L804.321 775.311L800.5 771.534L796.679 775.311L798.139 769.199L794.318 765.422H799.041L800.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.5 759.31L1153.96 765.422H1158.68L1154.86 769.199L1156.32 775.311L1152.5 771.534L1148.68 775.311L1150.14 769.199L1146.32 765.422H1151.04L1152.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M976.5 759.31L977.959 765.422H982.682L978.861 769.199L980.321 775.311L976.5 771.534L972.679 775.311L974.139 769.199L970.318 765.422H975.041L976.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5 759.31L1329.96 765.422H1334.68L1330.86 769.199L1332.32 775.311L1328.5 771.534L1324.68 775.311L1326.14 769.199L1322.32 765.422H1327.04L1328.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M756.5 759.31L757.959 765.422H762.682L758.861 769.199L760.321 775.311L756.5 771.534L752.679 775.311L754.139 769.199L750.318 765.422H755.041L756.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.5 759.31L1109.96 765.422H1114.68L1110.86 769.199L1112.32 775.311L1108.5 771.534L1104.68 775.311L1106.14 769.199L1102.32 765.422H1107.04L1108.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5 759.31L933.959 765.422H938.682L934.861 769.199L936.321 775.311L932.5 771.534L928.679 775.311L930.139 769.199L926.318 765.422H931.041L932.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 759.31L1285.96 765.422H1290.68L1286.86 769.199L1288.32 775.311L1284.5 771.534L1280.68 775.311L1282.14 769.199L1278.32 765.422H1283.04L1284.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 759.31L845.959 765.422H850.682L846.861 769.199L848.321 775.311L844.5 771.534L840.679 775.311L842.139 769.199L838.318 765.422H843.041L844.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.5 759.31L1197.96 765.422H1202.68L1198.86 769.199L1200.32 775.311L1196.5 771.534L1192.68 775.311L1194.14 769.199L1190.32 765.422H1195.04L1196.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5 759.31L1021.96 765.422H1026.68L1022.86 769.199L1024.32 775.311L1020.5 771.534L1016.68 775.311L1018.14 769.199L1014.32 765.422H1019.04L1020.5 759.31Z",
    fill: "#299EF3",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkBg);
export default __webpack_public_path__ + "static/media/WorkBg.72d82df0ae835ecc2dbbcfb6451d2b13.svg";
export { ForwardRef as ReactComponent };